var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 597,
    height: 377,
    viewBox: "0 0 597 377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.898,
    y1: -0.649,
    x2: 0.066,
    y2: 1.752,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#aec2fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2e0f7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(-725 -54)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54786",
    "data-name": "Rectangle 54786",
    width: 597,
    height: 377,
    transform: "translate(725 54)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_141974",
    "data-name": "Group 141974",
    transform: "translate(558.354 12.421)",
    opacity: 0.226
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141973",
    "data-name": "Group 141973"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73896",
    "data-name": "Path 73896",
    d: "M399.79,317.5c0,.133.131.133.245.133.075,0,.131-.133.131-.264-.056,0-.131-.15-.245-.15C399.79,317.313,399.715,317.424,399.79,317.5Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73897",
    "data-name": "Path 73897",
    d: "M388.436,320.263a.223.223,0,0,0,.32.206c.207,0,.263-.131.207-.337a.25.25,0,0,0-.319-.207A.234.234,0,0,0,388.436,320.263Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73898",
    "data-name": "Path 73898",
    d: "M376.989,323.045a.466.466,0,0,0,.564.319.55.55,0,0,0,.339-.581.4.4,0,0,0-.526-.283A.423.423,0,0,0,376.989,323.045Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73899",
    "data-name": "Path 73899",
    d: "M365.636,325.79a.711.711,0,0,0,.715.45.631.631,0,0,0,.394-.695.686.686,0,0,0-.714-.45C365.767,325.17,365.636,325.545,365.636,325.79Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73900",
    "data-name": "Path 73900",
    d: "M354.357,328.5a.63.63,0,0,0,.714.452.494.494,0,0,0,.4-.7.562.562,0,0,0-.659-.45A.783.783,0,0,0,354.357,328.5Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73901",
    "data-name": "Path 73901",
    d: "M343.1,331.269a.6.6,0,0,0,.77.376.533.533,0,0,0,.394-.6.6.6,0,0,0-.714-.452C343.23,330.63,343.1,331.044,343.1,331.269Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73902",
    "data-name": "Path 73902",
    d: "M331.952,333.976a.444.444,0,0,0,.581.375.435.435,0,0,0,.4-.6.446.446,0,0,0-.583-.339A.5.5,0,0,0,331.952,333.976Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73903",
    "data-name": "Path 73903",
    d: "M320.825,336.682a.353.353,0,0,0,.506.264c.208,0,.32-.189.264-.451a.286.286,0,0,0-.395-.188A.353.353,0,0,0,320.825,336.682Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73904",
    "data-name": "Path 73904",
    d: "M309.676,339.39a.407.407,0,0,0,.322.225c.131-.113.262-.225.187-.338-.056-.114-.131-.114-.264-.114A.264.264,0,0,0,309.676,339.39Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73905",
    "data-name": "Path 73905",
    d: "M298.643,342.1h.075c.075,0,.075,0,.075-.075l-.15-.038Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73906",
    "data-name": "Path 73906",
    d: "M419.489,300.752a.27.27,0,0,0,.264.263.366.366,0,0,0,.188-.394.249.249,0,0,0-.319-.131C419.489,300.49,419.433,300.621,419.489,300.752Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73907",
    "data-name": "Path 73907",
    d: "M408.042,303.61a.41.41,0,0,0,.564.356.682.682,0,0,0,.339-.639c-.15-.264-.339-.395-.6-.32A.41.41,0,0,0,408.042,303.61Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73908",
    "data-name": "Path 73908",
    d: "M396.5,306.353c.131.452.45.716.9.583a.853.853,0,0,0,.581-.9.71.71,0,0,0-.9-.506A.669.669,0,0,0,396.5,306.353Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73909",
    "data-name": "Path 73909",
    d: "M385.035,309.136a.909.909,0,0,0,1.164.7.838.838,0,0,0,.639-1.09.923.923,0,1,0-1.8.395Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73910",
    "data-name": "Path 73910",
    d: "M373.7,311.9a1.122,1.122,0,0,0,1.3.9,1.059,1.059,0,0,0,.695-1.353,1.023,1.023,0,0,0-1.993.45Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73911",
    "data-name": "Path 73911",
    d: "M362.366,314.662a1.1,1.1,0,0,0,1.353.845,1.08,1.08,0,0,0,.826-1.353,1.237,1.237,0,0,0-1.353-.9A1.255,1.255,0,0,0,362.366,314.662Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73912",
    "data-name": "Path 73912",
    d: "M351.087,317.368a1.16,1.16,0,1,0,2.256-.508,1.11,1.11,0,0,0-1.428-.845A1.174,1.174,0,0,0,351.087,317.368Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73913",
    "data-name": "Path 73913",
    d: "M339.885,320.132a1.126,1.126,0,1,0,2.18-.564,1.2,1.2,0,0,0-1.41-.846A1.337,1.337,0,0,0,339.885,320.132Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73914",
    "data-name": "Path 73914",
    d: "M328.682,322.839a1.057,1.057,0,1,0,2.048-.508,1.123,1.123,0,0,0-1.3-.734A1.085,1.085,0,0,0,328.682,322.839Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73915",
    "data-name": "Path 73915",
    d: "M317.478,325.545a1.067,1.067,0,0,0,1.278.789.92.92,0,0,0,.639-1.239.938.938,0,0,0-1.145-.7A1.014,1.014,0,0,0,317.478,325.545Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73916",
    "data-name": "Path 73916",
    d: "M306.445,328.251a.864.864,0,0,0,.977.659.892.892,0,0,0,.582-1.034.816.816,0,0,0-.976-.583A.883.883,0,0,0,306.445,328.251Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73917",
    "data-name": "Path 73917",
    d: "M295.373,330.969a.579.579,0,0,0,.714.451.664.664,0,0,0,.526-.79.765.765,0,0,0-.79-.338A.59.59,0,0,0,295.373,330.969Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73918",
    "data-name": "Path 73918",
    d: "M284.367,333.6c.123.262.244.376.45.3.189-.039.312-.15.189-.451a.2.2,0,0,0-.329-.152C284.49,333.337,284.367,333.412,284.367,333.6Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73919",
    "data-name": "Path 73919",
    d: "M273.419,336.307h.055c.066,0,.066,0,.066-.075,0,0,0,.075-.066.075Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73920",
    "data-name": "Path 73920",
    d: "M439.395,284.059l.056.076c.058,0,.058-.131.058-.131h-.058A.055.055,0,0,0,439.395,284.059Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73921",
    "data-name": "Path 73921",
    d: "M427.873,286.843a.339.339,0,0,0,.432.319c.207-.075.394-.319.338-.452a.526.526,0,0,0-.525-.395A.351.351,0,0,0,427.873,286.843Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73922",
    "data-name": "Path 73922",
    d: "M416.2,289.663a.752.752,0,0,0,.9.544.719.719,0,0,0,.584-.864.8.8,0,0,0-.9-.583A.862.862,0,0,0,416.2,289.663Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73923",
    "data-name": "Path 73923",
    d: "M404.733,292.5a1.082,1.082,0,0,0,1.242.772,1.1,1.1,0,0,0,.75-1.261,1.026,1.026,0,1,0-1.992.489Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73924",
    "data-name": "Path 73924",
    d: "M393.211,295.281a1.4,1.4,0,0,0,1.617.961,1.308,1.308,0,0,0,.9-1.542,1.206,1.206,0,0,0-1.486-.978A1.333,1.333,0,0,0,393.211,295.281Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73925",
    "data-name": "Path 73925",
    d: "M382.892,296.242a1.432,1.432,0,0,0-1.128,1.8,1.509,1.509,0,0,0,2.932-.714A1.422,1.422,0,0,0,382.892,296.242Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73926",
    "data-name": "Path 73926",
    d: "M371.576,298.815a1.7,1.7,0,0,0-1.166,1.994,1.617,1.617,0,0,0,1.936,1.221,1.66,1.66,0,0,0,1.223-1.993A1.722,1.722,0,0,0,371.576,298.815Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73927",
    "data-name": "Path 73927",
    d: "M360.3,301.39a1.834,1.834,0,0,0-1.278,2.22,1.8,1.8,0,0,0,2.106,1.314,1.734,1.734,0,0,0,1.3-2.18A1.808,1.808,0,0,0,360.3,301.39Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73928",
    "data-name": "Path 73928",
    d: "M349.02,304.174a1.751,1.751,0,0,0-1.279,2.179,1.788,1.788,0,1,0,3.479-.826A1.827,1.827,0,0,0,349.02,304.174Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73929",
    "data-name": "Path 73929",
    d: "M337.817,306.936a1.682,1.682,0,0,0-1.278,2.125,1.737,1.737,0,0,0,2.123,1.353,1.778,1.778,0,0,0,1.278-2.181A1.679,1.679,0,0,0,337.817,306.936Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73930",
    "data-name": "Path 73930",
    d: "M326.538,309.7a1.75,1.75,0,0,0-1.2,2.1,1.674,1.674,0,0,0,2.067,1.185,1.613,1.613,0,0,0,1.28-1.992A1.85,1.85,0,0,0,326.538,309.7Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73931",
    "data-name": "Path 73931",
    d: "M315.41,312.537a1.591,1.591,0,1,0,1.862,1.222A1.547,1.547,0,0,0,315.41,312.537Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73932",
    "data-name": "Path 73932",
    d: "M304.208,315.507a1.384,1.384,0,0,0-1.053,1.673,1.491,1.491,0,0,0,1.692,1.091,1.553,1.553,0,0,0,1.014-1.748A1.407,1.407,0,0,0,304.208,315.507Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73933",
    "data-name": "Path 73933",
    d: "M292.159,319.888a1.161,1.161,0,0,0,1.353.826,1.174,1.174,0,0,0,.847-1.409,1.194,1.194,0,0,0-1.355-.847A1.22,1.22,0,0,0,292.159,319.888Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73934",
    "data-name": "Path 73934",
    d: "M281.143,322.5a1.075,1.075,0,0,0,1.091.733.943.943,0,0,0,.582-1.089.829.829,0,0,0-1.034-.658A.917.917,0,0,0,281.143,322.5Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73935",
    "data-name": "Path 73935",
    d: "M270.26,325.206a.482.482,0,0,0,.574.339.467.467,0,0,0,.45-.564c-.056-.395-.32-.545-.7-.395C270.325,324.642,270.185,324.85,270.26,325.206Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73936",
    "data-name": "Path 73936",
    d: "M259.3,327.876c0,.131.14.131.329.131,0-.092.121-.131.121-.262,0-.15-.188-.188-.254-.188A.214.214,0,0,0,259.3,327.876Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73937",
    "data-name": "Path 73937",
    d: "M447.836,270.17l.131-.094h.113a.4.4,0,0,0-.113-.245C447.836,269.831,447.836,270.037,447.836,270.17Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73938",
    "data-name": "Path 73938",
    d: "M436.237,272.988c0,.208.319.32.639.32a.579.579,0,0,0,.377-.564c-.114-.412-.377-.545-.639-.451A.513.513,0,0,0,436.237,272.988Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73939",
    "data-name": "Path 73939",
    d: "M424.64,275.771a.861.861,0,0,0,1.672-.414.886.886,0,0,0-1.014-.77A.949.949,0,0,0,424.64,275.771Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73940",
    "data-name": "Path 73940",
    d: "M413.043,278.608a1.094,1.094,0,0,0,1.428.809,1.25,1.25,0,0,0,1.014-1.39,1.29,1.29,0,0,0-1.541-.978A1.218,1.218,0,0,0,413.043,278.608Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73941",
    "data-name": "Path 73941",
    d: "M402.629,279.417a1.6,1.6,0,1,0,.751,3.12,1.678,1.678,0,0,0,1.167-1.9A1.741,1.741,0,0,0,402.629,279.417Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73942",
    "data-name": "Path 73942",
    d: "M391.275,281.881A1.969,1.969,0,0,0,390,284.212a1.86,1.86,0,0,0,2.181,1.353,1.8,1.8,0,0,0,1.353-2.22A1.94,1.94,0,0,0,391.275,281.881Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73943",
    "data-name": "Path 73943",
    d: "M380.073,284.512a2.015,2.015,0,1,0,.9,3.928,2.071,2.071,0,0,0,1.54-2.386A2.041,2.041,0,0,0,380.073,284.512Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73944",
    "data-name": "Path 73944",
    d: "M368.738,287.087a2.221,2.221,0,0,0-1.673,2.706,2.26,2.26,0,0,0,2.706,1.542,2.165,2.165,0,0,0,1.673-2.614A2.2,2.2,0,0,0,368.738,287.087Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73945",
    "data-name": "Path 73945",
    d: "M357.477,289.663a2.356,2.356,0,1,0,2.82,1.767A2.326,2.326,0,0,0,357.477,289.663Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73946",
    "data-name": "Path 73946",
    d: "M346.2,292.369a2.358,2.358,0,1,0,1.091,4.587,2.358,2.358,0,0,0-1.091-4.587Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73947",
    "data-name": "Path 73947",
    d: "M334.922,295.075a2.429,2.429,0,0,0-1.748,2.97,2.464,2.464,0,0,0,2.913,1.673,2.4,2.4,0,0,0,1.8-2.837A2.431,2.431,0,0,0,334.922,295.075Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73948",
    "data-name": "Path 73948",
    d: "M323.643,297.914a2.307,2.307,0,0,0-1.6,2.838,2.3,2.3,0,0,0,4.456-1.09A2.365,2.365,0,0,0,323.643,297.914Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73949",
    "data-name": "Path 73949",
    d: "M312.571,300.752a2.2,2.2,0,0,0-1.615,2.708,2.1,2.1,0,1,0,1.615-2.708Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73950",
    "data-name": "Path 73950",
    d: "M301.35,303.779a1.886,1.886,0,0,0-1.39,2.312,1.878,1.878,0,0,0,3.645-.9A1.822,1.822,0,0,0,301.35,303.779Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73951",
    "data-name": "Path 73951",
    d: "M290.167,306.8a1.654,1.654,0,0,0-1.3,1.992,1.7,1.7,0,1,0,3.29-.828A1.556,1.556,0,0,0,290.167,306.8Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73952",
    "data-name": "Path 73952",
    d: "M278.954,309.775a1.278,1.278,0,0,0-.968,1.673,1.183,1.183,0,0,0,1.607.9,1.24,1.24,0,0,0,1.024-1.561A1.38,1.38,0,0,0,278.954,309.775Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73953",
    "data-name": "Path 73953",
    d: "M267.026,314.154a1.039,1.039,0,0,0,1.232.7,1.012,1.012,0,0,0,.77-1.24,1.039,1.039,0,0,0-1.288-.808A1.067,1.067,0,0,0,267.026,314.154Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73954",
    "data-name": "Path 73954",
    d: "M256.143,316.729a.667.667,0,0,0,.78.451.623.623,0,0,0,.508-.714c-.123-.395-.443-.714-.762-.639A.782.782,0,0,0,256.143,316.729Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73955",
    "data-name": "Path 73955",
    d: "M245.261,319.436a.25.25,0,0,0,.329.132.282.282,0,0,0,.261-.263c-.065-.283-.261-.395-.394-.32C245.336,318.985,245.2,319.174,245.261,319.436Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73956",
    "data-name": "Path 73956",
    d: "M456.463,256.053c0,.037,0,.037.075.037,0-.037.058-.037.058-.037a.2.2,0,0,0-.133-.075Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73957",
    "data-name": "Path 73957",
    d: "M444.735,258.891a.534.534,0,0,0,1.034-.264.455.455,0,0,0-.64-.281A.441.441,0,0,0,444.735,258.891Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73958",
    "data-name": "Path 73958",
    d: "M433.005,261.71a1.111,1.111,0,0,0,1.24.79.957.957,0,0,0,.639-1.165.893.893,0,0,0-1.09-.733A1.047,1.047,0,0,0,433.005,261.71Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73959",
    "data-name": "Path 73959",
    d: "M422.459,263.008a1.266,1.266,0,0,0-1.034,1.542,1.354,1.354,0,1,0,2.632-.64A1.338,1.338,0,0,0,422.459,263.008Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73960",
    "data-name": "Path 73960",
    d: "M411.051,265.319a1.667,1.667,0,0,0-1.223,2.05,1.782,1.782,0,0,0,2.048,1.354,1.751,1.751,0,1,0-.825-3.4Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73961",
    "data-name": "Path 73961",
    d: "M399.79,267.781a1.974,1.974,0,0,0-1.561,2.445,2.12,2.12,0,0,0,2.52,1.522,2.052,2.052,0,0,0,1.484-2.481A1.962,1.962,0,0,0,399.79,267.781Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73962",
    "data-name": "Path 73962",
    d: "M388.436,270.226a2.357,2.357,0,0,0-1.784,2.837,2.573,2.573,0,0,0,2.951,1.806,2.36,2.36,0,0,0,1.672-2.99A2.262,2.262,0,0,0,388.436,270.226Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73963",
    "data-name": "Path 73963",
    d: "M377.1,272.651a2.664,2.664,0,0,0,1.3,5.168,2.664,2.664,0,0,0-1.3-5.168Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73964",
    "data-name": "Path 73964",
    d: "M365.9,275.319a2.705,2.705,0,0,0-2.123,3.289,2.766,2.766,0,0,0,3.421,2.031,2.825,2.825,0,0,0,2.049-3.384A2.7,2.7,0,0,0,365.9,275.319Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73965",
    "data-name": "Path 73965",
    d: "M354.584,277.819a2.941,2.941,0,0,0-2.219,3.534,3.128,3.128,0,0,0,3.609,2.2A2.938,2.938,0,0,0,358.041,280,2.847,2.847,0,0,0,354.584,277.819Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73966",
    "data-name": "Path 73966",
    d: "M343.3,280.525a3.031,3.031,0,0,0-2.2,3.61,3,3,0,0,0,3.609,2.18,2.98,2.98,0,1,0-1.411-5.79Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73967",
    "data-name": "Path 73967",
    d: "M332.027,283.234a3.026,3.026,0,0,0-2.142,3.609,2.953,2.953,0,0,0,3.551,2.181,2.979,2.979,0,1,0-1.409-5.79Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73968",
    "data-name": "Path 73968",
    d: "M320.825,286.146a2.733,2.733,0,0,0-2.069,3.384,2.848,2.848,0,0,0,3.422,2.142,2.791,2.791,0,0,0,2.1-3.476A2.836,2.836,0,0,0,320.825,286.146Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73969",
    "data-name": "Path 73969",
    d: "M309.6,288.966a2.7,2.7,0,0,0-1.934,3.27,2.753,2.753,0,0,0,3.289,2.069,2.754,2.754,0,1,0-1.355-5.339Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73970",
    "data-name": "Path 73970",
    d: "M298.455,291.917a2.589,2.589,0,0,0-1.842,3.027,2.509,2.509,0,0,0,3.008,1.8,2.417,2.417,0,0,0,1.8-2.951A2.505,2.505,0,0,0,298.455,291.917Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73971",
    "data-name": "Path 73971",
    d: "M287.262,295.039a2.11,2.11,0,0,0-1.607,2.556,2.187,2.187,0,1,0,4.248-1.034A2.1,2.1,0,0,0,287.262,295.039Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73972",
    "data-name": "Path 73972",
    d: "M276.125,298.045a1.793,1.793,0,0,0-1.428,2.181,1.86,1.86,0,1,0,3.609-.883A1.772,1.772,0,0,0,276.125,298.045Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73973",
    "data-name": "Path 73973",
    d: "M264.913,301.129a1.507,1.507,0,0,0,.7,2.931,1.491,1.491,0,0,0,1.1-1.9A1.445,1.445,0,0,0,264.913,301.129Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73974",
    "data-name": "Path 73974",
    d: "M252.929,305.527a1.069,1.069,0,0,0,1.409.751,1.055,1.055,0,0,0,.781-1.278,1.171,1.171,0,0,0-1.287-.77A1.159,1.159,0,0,0,252.929,305.527Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73975",
    "data-name": "Path 73975",
    d: "M242.1,308.158c.14.375.45.714.9.583.394-.057.525-.508.45-.9-.056-.395-.45-.508-.826-.451A.617.617,0,0,0,242.1,308.158Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73976",
    "data-name": "Path 73976",
    d: "M231.294,310.789a.266.266,0,0,0,.32.208.409.409,0,0,0,.2-.319.388.388,0,0,0-.329-.227A.425.425,0,0,0,231.294,310.789Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73977",
    "data-name": "Path 73977",
    d: "M453.381,244.982c0,.244.245.319.506.244a.4.4,0,0,0,.32-.488.379.379,0,0,0-.506-.284C453.437,244.53,453.248,244.738,453.381,244.982Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73978",
    "data-name": "Path 73978",
    d: "M441.651,247.8a.8.8,0,0,0,1.015.583.86.86,0,1,0-.376-1.673A.833.833,0,0,0,441.651,247.8Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73979",
    "data-name": "Path 73979",
    d: "M430.955,248.966a1.486,1.486,0,0,0-1.034,1.673,1.4,1.4,0,0,0,2.707-.639A1.5,1.5,0,0,0,430.955,248.966Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73980",
    "data-name": "Path 73980",
    d: "M419.622,251.278a1.837,1.837,0,0,0-1.3,2.2,1.741,1.741,0,0,0,2.068,1.3,1.843,1.843,0,0,0,1.353-2.144A1.8,1.8,0,0,0,419.622,251.278Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73981",
    "data-name": "Path 73981",
    d: "M408.231,253.665a2.217,2.217,0,0,0-1.617,2.65,2.193,2.193,0,0,0,2.631,1.581,2.252,2.252,0,0,0,1.729-2.614A2.226,2.226,0,0,0,408.231,253.665Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73982",
    "data-name": "Path 73982",
    d: "M396.951,255.921a2.641,2.641,0,0,0-1.936,3.214,2.6,2.6,0,0,0,3.1,1.881,2.614,2.614,0,0,0-1.167-5.095Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73983",
    "data-name": "Path 73983",
    d: "M385.6,258.44a2.817,2.817,0,0,0-2.106,3.476,2.882,2.882,0,0,0,5.6-1.353A2.836,2.836,0,0,0,385.6,258.44Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73984",
    "data-name": "Path 73984",
    d: "M374.283,260.827a3.229,3.229,0,0,0-2.387,3.928,3.341,3.341,0,0,0,3.928,2.37,3.282,3.282,0,0,0,2.331-3.853A3.233,3.233,0,0,0,374.283,260.827Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73985",
    "data-name": "Path 73985",
    d: "M362.93,263.308a3.471,3.471,0,0,0-2.444,4.212,3.415,3.415,0,1,0,6.635-1.617A3.526,3.526,0,0,0,362.93,263.308Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73986",
    "data-name": "Path 73986",
    d: "M351.726,265.978a3.594,3.594,0,0,0-2.631,4.3,3.543,3.543,0,0,0,6.879-1.692A3.549,3.549,0,0,0,351.726,265.978Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73987",
    "data-name": "Path 73987",
    d: "M340.392,268.684a3.613,3.613,0,1,0,1.748,7.012,3.551,3.551,0,0,0,2.631-4.4A3.609,3.609,0,0,0,340.392,268.684Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73988",
    "data-name": "Path 73988",
    d: "M329.188,271.39a3.634,3.634,0,0,0-2.575,4.381,3.541,3.541,0,0,0,6.881-1.672A3.655,3.655,0,0,0,329.188,271.39Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73989",
    "data-name": "Path 73989",
    d: "M317.986,274.285a3.48,3.48,0,0,0-2.576,4.193,3.486,3.486,0,1,0,2.576-4.193Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73990",
    "data-name": "Path 73990",
    d: "M306.764,277.124a3.335,3.335,0,0,0,1.559,6.485,3.335,3.335,0,0,0-1.559-6.485Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73991",
    "data-name": "Path 73991",
    d: "M295.562,280.15a3.083,3.083,0,0,0-2.181,3.648,3.02,3.02,0,0,0,3.609,2.256,3.038,3.038,0,0,0-1.428-5.9Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73992",
    "data-name": "Path 73992",
    d: "M284.367,283.159a2.745,2.745,0,0,0-1.946,3.345,2.7,2.7,0,0,0,3.234,2.011,2.756,2.756,0,0,0,2.057-3.27A2.87,2.87,0,0,0,284.367,283.159Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73993",
    "data-name": "Path 73993",
    d: "M273.276,286.315a2.334,2.334,0,0,0-1.738,2.859,2.3,2.3,0,0,0,2.781,1.653,2.348,2.348,0,0,0,1.806-2.764A2.408,2.408,0,0,0,273.276,286.315Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73994",
    "data-name": "Path 73994",
    d: "M262.084,289.474a1.856,1.856,0,0,0-1.429,2.312,1.985,1.985,0,0,0,2.331,1.447,2.1,2.1,0,0,0,1.54-2.406A1.979,1.979,0,0,0,262.084,289.474Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73995",
    "data-name": "Path 73995",
    d: "M250.993,292.575a1.428,1.428,0,0,0-1.146,1.861,1.605,1.605,0,0,0,1.86,1.165,1.654,1.654,0,0,0,1.091-1.879A1.482,1.482,0,0,0,250.993,292.575Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73996",
    "data-name": "Path 73996",
    d: "M239.02,297.087a1.01,1.01,0,0,0,1.278.694.987.987,0,0,0,.78-1.22,1.054,1.054,0,0,0-1.288-.827A1.07,1.07,0,0,0,239.02,297.087Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73997",
    "data-name": "Path 73997",
    d: "M228.268,299.662a.569.569,0,0,0,.695.45.54.54,0,0,0,.4-.714.552.552,0,0,0-.639-.508A.6.6,0,0,0,228.268,299.662Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73998",
    "data-name": "Path 73998",
    d: "M217.366,302.293a.358.358,0,0,0,.262.131c0-.056.075-.131.075-.167-.075-.152-.075-.1-.187-.1C217.516,302.162,217.366,302.162,217.366,302.293Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73999",
    "data-name": "Path 73999",
    d: "M461.989,230.921a.3.3,0,0,0,.414.206c.113,0,.113-.206.113-.337a.266.266,0,0,0-.263-.244C461.989,230.6,461.989,230.79,461.989,230.921Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74000",
    "data-name": "Path 74000",
    d: "M450.336,233.835a.672.672,0,0,0,.845.451.732.732,0,0,0,.583-.828.776.776,0,0,0-.9-.6A.806.806,0,0,0,450.336,233.835Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74001",
    "data-name": "Path 74001",
    d: "M438.568,236.653a1.2,1.2,0,0,0,1.466.866,1.169,1.169,0,0,0,.978-1.447,1.257,1.257,0,1,0-2.444.581Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74002",
    "data-name": "Path 74002",
    d: "M428.118,237.369a1.814,1.814,0,0,0-1.278,2.123,1.728,1.728,0,0,0,2.123,1.223,1.612,1.612,0,0,0,1.222-1.993A1.705,1.705,0,0,0,428.118,237.369Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74003",
    "data-name": "Path 74003",
    d: "M416.783,239.681a2.2,2.2,0,1,0,1.033,4.267,2.2,2.2,0,1,0-1.033-4.267Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74004",
    "data-name": "Path 74004",
    d: "M405.372,241.937a2.666,2.666,0,0,0-1.917,3.289,2.607,2.607,0,0,0,3.159,1.879,2.717,2.717,0,0,0,2.067-3.157A2.819,2.819,0,0,0,405.372,241.937Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74005",
    "data-name": "Path 74005",
    d: "M394.114,244.285a3.068,3.068,0,0,0-2.312,3.779,3.08,3.08,0,1,0,2.312-3.779Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74006",
    "data-name": "Path 74006",
    d: "M382.779,246.655a3.523,3.523,0,0,0-2.6,4.173,3.45,3.45,0,0,0,6.712-1.581A3.445,3.445,0,0,0,382.779,246.655Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74007",
    "data-name": "Path 74007",
    d: "M371.444,249.1a3.771,3.771,0,0,0-2.763,4.568,3.743,3.743,0,0,0,7.275-1.748A3.762,3.762,0,0,0,371.444,249.1Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74008",
    "data-name": "Path 74008",
    d: "M360.11,251.542a3.915,3.915,0,0,0-2.895,4.887,3.955,3.955,0,0,0,4.755,2.914,4.085,4.085,0,0,0,2.97-4.776A4,4,0,0,0,360.11,251.542Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74009",
    "data-name": "Path 74009",
    d: "M348.831,254.173a4.153,4.153,0,1,0,5.037,3.1A4.2,4.2,0,0,0,348.831,254.173Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74010",
    "data-name": "Path 74010",
    d: "M337.553,256.823a4.273,4.273,0,0,0-3.083,5.132A4.18,4.18,0,0,0,339.49,265a4.117,4.117,0,0,0,3.1-5.018A4.209,4.209,0,0,0,337.553,256.823Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74011",
    "data-name": "Path 74011",
    d: "M326.351,259.663a4.049,4.049,0,0,0-3.084,5,4.172,4.172,0,1,0,3.084-5Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74012",
    "data-name": "Path 74012",
    d: "M315.091,262.5a4.07,4.07,0,0,0-2.97,4.869,4.035,4.035,0,1,0,2.97-4.869Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74013",
    "data-name": "Path 74013",
    d: "M303.944,265.395a3.785,3.785,0,0,0-2.839,4.681,3.836,3.836,0,0,0,4.643,2.781,3.772,3.772,0,0,0,2.82-4.587A3.814,3.814,0,0,0,303.944,265.395Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74014",
    "data-name": "Path 74014",
    d: "M292.742,268.42a3.513,3.513,0,1,0,1.672,6.824,3.38,3.38,0,0,0,2.576-4.115A3.464,3.464,0,0,0,292.742,268.42Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74015",
    "data-name": "Path 74015",
    d: "M281.52,271.523a3.175,3.175,0,0,0-2.314,3.834,3.178,3.178,0,1,0,6.185-1.466A3.151,3.151,0,0,0,281.52,271.523Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74016",
    "data-name": "Path 74016",
    d: "M270.449,274.663a2.766,2.766,0,0,0-2.07,3.4,2.793,2.793,0,0,0,5.415-1.353A2.791,2.791,0,0,0,270.449,274.663Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74017",
    "data-name": "Path 74017",
    d: "M259.235,277.744a2.409,2.409,0,0,0-1.738,2.989,2.484,2.484,0,0,0,2.9,1.673,2.4,2.4,0,0,0-1.166-4.662Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74018",
    "data-name": "Path 74018",
    d: "M248.163,280.978a1.925,1.925,0,0,0-1.419,2.331,1.972,1.972,0,0,0,2.322,1.353,1.91,1.91,0,0,0,1.353-2.217A1.858,1.858,0,0,0,248.163,280.978Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74019",
    "data-name": "Path 74019",
    d: "M236.951,284.135a1.4,1.4,0,0,0-1.024,1.8,1.454,1.454,0,0,0,2.83-.658A1.509,1.509,0,0,0,236.951,284.135Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74020",
    "data-name": "Path 74020",
    d: "M225.11,288.571a.994.994,0,0,0,1.222.639.883.883,0,0,0,.695-1.089.912.912,0,0,0-1.148-.753A1,1,0,0,0,225.11,288.571Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74021",
    "data-name": "Path 74021",
    d: "M214.413,291.147a.579.579,0,0,0,.509.319c.263-.131.394-.358.338-.489-.075-.319-.338-.414-.527-.319C214.471,290.7,214.413,290.827,214.413,291.147Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74022",
    "data-name": "Path 74022",
    d: "M459.038,219.736a.657.657,0,0,0,.658.32.456.456,0,0,0,.3-.582.471.471,0,0,0-.564-.394A.6.6,0,0,0,459.038,219.736Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74023",
    "data-name": "Path 74023",
    d: "M447.309,222.556a1.057,1.057,0,0,0,1.222.789,1.092,1.092,0,0,0,.789-1.315,1.075,1.075,0,0,0-1.24-.752A1.022,1.022,0,0,0,447.309,222.556Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74024",
    "data-name": "Path 74024",
    d: "M436.614,223.534a1.558,1.558,0,0,0-1.091,1.842,1.582,1.582,0,0,0,1.88,1.241,1.643,1.643,0,0,0,1.165-1.917A1.6,1.6,0,0,0,436.614,223.534Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74025",
    "data-name": "Path 74025",
    d: "M425.3,225.79a2.006,2.006,0,0,0-1.486,2.425,2.03,2.03,0,0,0,2.5,1.559,2.005,2.005,0,0,0,1.486-2.462A2.038,2.038,0,0,0,425.3,225.79Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74026",
    "data-name": "Path 74026",
    d: "M413.944,228.046a2.535,2.535,0,0,0-1.917,3.081,2.473,2.473,0,0,0,3.083,1.881,2.565,2.565,0,0,0,1.936-3.121A2.61,2.61,0,0,0,413.944,228.046Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74027",
    "data-name": "Path 74027",
    d: "M402.552,230.3a3.06,3.06,0,0,0-2.254,3.646,3.2,3.2,0,0,0,3.721,2.35,3.1,3.1,0,0,0,2.256-3.74A3.058,3.058,0,0,0,402.552,230.3Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74028",
    "data-name": "Path 74028",
    d: "M391.275,232.688a3.306,3.306,0,0,0-2.575,4.1,3.454,3.454,0,1,0,6.711-1.617A3.3,3.3,0,0,0,391.275,232.688Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74029",
    "data-name": "Path 74029",
    d: "M379.959,234.944a3.815,3.815,0,0,0-2.97,4.679,3.91,3.91,0,1,0,7.6-1.859A3.824,3.824,0,0,0,379.959,234.944Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74030",
    "data-name": "Path 74030",
    d: "M368.549,237.311a4.307,4.307,0,0,0-3.157,5.171,4.212,4.212,0,0,0,5.151,3.156,4.281,4.281,0,1,0-1.994-8.327Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74031",
    "data-name": "Path 74031",
    d: "M357.271,239.812a4.535,4.535,0,1,0,5.471,3.289A4.491,4.491,0,0,0,357.271,239.812Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74032",
    "data-name": "Path 74032",
    d: "M345.936,242.274a4.769,4.769,0,1,0,5.734,3.534A4.738,4.738,0,0,0,345.936,242.274Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74033",
    "data-name": "Path 74033",
    d: "M334.658,244.982a4.832,4.832,0,0,0,2.256,9.4,4.754,4.754,0,0,0,3.609-5.863A4.834,4.834,0,0,0,334.658,244.982Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74034",
    "data-name": "Path 74034",
    d: "M323.381,247.744a4.83,4.83,0,0,0-3.459,5.79,4.747,4.747,0,0,0,5.79,3.553,4.8,4.8,0,0,0,3.476-5.809A4.892,4.892,0,0,0,323.381,247.744Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74035",
    "data-name": "Path 74035",
    d: "M312.177,250.639a4.66,4.66,0,0,0-3.4,5.6,4.678,4.678,0,0,0,9.08-2.256A4.688,4.688,0,0,0,312.177,250.639Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74036",
    "data-name": "Path 74036",
    d: "M301.049,253.609a4.36,4.36,0,0,0-3.289,5.282,4.437,4.437,0,1,0,3.289-5.282Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74037",
    "data-name": "Path 74037",
    d: "M289.9,256.692a4.089,4.089,0,0,0-3.036,4.9,4.087,4.087,0,1,0,7.942-1.934A4.031,4.031,0,0,0,289.9,256.692Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74038",
    "data-name": "Path 74038",
    d: "M278.691,259.793a3.667,3.667,0,0,0-2.707,4.379,3.626,3.626,0,0,0,4.445,2.708,3.65,3.65,0,1,0-1.738-7.087Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74039",
    "data-name": "Path 74039",
    d: "M267.619,263.008a3.2,3.2,0,0,0-2.454,3.8,3.261,3.261,0,0,0,3.93,2.367,3.17,3.17,0,1,0-1.476-6.165Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74040",
    "data-name": "Path 74040",
    d: "M256.407,266.109a2.916,2.916,0,0,0-2.069,3.345,2.859,2.859,0,0,0,3.357,2.069,2.783,2.783,0,1,0-1.288-5.414Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74041",
    "data-name": "Path 74041",
    d: "M245.336,269.379a2.308,2.308,0,0,0-1.741,2.708,2.293,2.293,0,1,0,4.447-1.109A2.308,2.308,0,0,0,245.336,269.379Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74042",
    "data-name": "Path 74042",
    d: "M234.189,272.538a1.96,1.96,0,0,0-1.353,2.2,1.828,1.828,0,0,0,2.188,1.278,1.792,1.792,0,0,0,1.288-2.181A1.868,1.868,0,0,0,234.189,272.538Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74043",
    "data-name": "Path 74043",
    d: "M222.14,277.294a1.249,1.249,0,0,0,1.541.978,1.273,1.273,0,0,0-.639-2.464A1.264,1.264,0,0,0,222.14,277.294Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74044",
    "data-name": "Path 74044",
    d: "M211.463,279.869a.745.745,0,0,0,.827.656.947.947,0,0,0,.526-.975.761.761,0,0,0-.845-.453C211.576,279.247,211.313,279.511,211.463,279.869Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74045",
    "data-name": "Path 74045",
    d: "M200.636,282.537c.055.133.113.169.244.133.131,0,.131-.094.131-.225,0,0-.131-.227-.262-.227C200.636,282.256,200.636,282.445,200.636,282.537Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74046",
    "data-name": "Path 74046",
    d: "M467.854,205.677c0,.112.188.112.264.112a.163.163,0,0,0,.13-.225.407.407,0,0,0-.261-.226C467.929,205.433,467.8,205.564,467.854,205.677Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74047",
    "data-name": "Path 74047",
    d: "M456.087,208.5a.749.749,0,1,0,.564-.9A.782.782,0,0,0,456.087,208.5Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74048",
    "data-name": "Path 74048",
    d: "M444.358,211.409a1.257,1.257,0,0,0,2.444-.564,1.269,1.269,0,0,0-1.542-.995A1.251,1.251,0,0,0,444.358,211.409Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74049",
    "data-name": "Path 74049",
    d: "M433.869,211.993a1.925,1.925,0,0,0-1.353,2.236,1.8,1.8,0,0,0,2.181,1.353,1.851,1.851,0,0,0,1.428-2.161A1.965,1.965,0,0,0,433.869,211.993Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74050",
    "data-name": "Path 74050",
    d: "M422.517,214.229a2.352,2.352,0,0,0-1.731,2.934,2.281,2.281,0,0,0,2.82,1.672A2.331,2.331,0,0,0,425.354,216,2.422,2.422,0,0,0,422.517,214.229Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74051",
    "data-name": "Path 74051",
    d: "M411.126,216.447a2.988,2.988,0,0,0-2.145,3.533,2.882,2.882,0,0,0,5.6-1.353A2.936,2.936,0,0,0,411.126,216.447Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74052",
    "data-name": "Path 74052",
    d: "M399.715,218.7a3.385,3.385,0,0,0-2.444,4.1,3.453,3.453,0,0,0,4.061,2.576,3.414,3.414,0,0,0,2.5-4.1A3.369,3.369,0,0,0,399.715,218.7Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74053",
    "data-name": "Path 74053",
    d: "M388.436,220.958a3.931,3.931,0,0,0-2.951,4.757,3.949,3.949,0,1,0,7.671-1.881A3.913,3.913,0,0,0,388.436,220.958Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74054",
    "data-name": "Path 74054",
    d: "M377.045,223.253a4.347,4.347,0,0,0-3.157,5.281,4.341,4.341,0,0,0,8.44-2.03A4.347,4.347,0,0,0,377.045,223.253Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74055",
    "data-name": "Path 74055",
    d: "M365.711,225.507a4.806,4.806,0,1,0,2.257,9.343,4.681,4.681,0,0,0,3.476-5.734A4.854,4.854,0,0,0,365.711,225.507Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74056",
    "data-name": "Path 74056",
    d: "M354.321,227.97a5.218,5.218,0,0,0-3.76,6.241,5.175,5.175,0,0,0,10.056-2.426A5.186,5.186,0,0,0,354.321,227.97Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74057",
    "data-name": "Path 74057",
    d: "M343.1,230.471a5.4,5.4,0,0,0,2.517,10.507,5.425,5.425,0,0,0,3.929-6.579A5.357,5.357,0,0,0,343.1,230.471Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74058",
    "data-name": "Path 74058",
    d: "M320.561,235.883a5.325,5.325,0,0,0-3.986,6.6,5.391,5.391,0,0,0,6.562,3.965,5.437,5.437,0,0,0-2.576-10.564Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74059",
    "data-name": "Path 74059",
    d: "M309.357,238.778a5.315,5.315,0,0,0-3.871,6.41,5.185,5.185,0,0,0,6.316,3.778,5.239,5.239,0,1,0-2.445-10.188Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74060",
    "data-name": "Path 74060",
    d: "M298.193,241.823a5.024,5.024,0,0,0-3.648,5.977,4.932,4.932,0,0,0,9.588-2.312A5.007,5.007,0,0,0,298.193,241.823Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74061",
    "data-name": "Path 74061",
    d: "M287.008,244.907a4.614,4.614,0,0,0,2.181,8.966,4.615,4.615,0,0,0-2.181-8.966Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74062",
    "data-name": "Path 74062",
    d: "M275.861,248.121a4.032,4.032,0,0,0-2.97,4.963,3.982,3.982,0,0,0,4.9,2.969,4.082,4.082,0,1,0-1.927-7.932Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74063",
    "data-name": "Path 74063",
    d: "M264.79,251.278a3.725,3.725,0,0,0-2.706,4.456,3.559,3.559,0,0,0,4.369,2.612,3.66,3.66,0,0,0,2.708-4.362A3.715,3.715,0,0,0,264.79,251.278Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74064",
    "data-name": "Path 74064",
    d: "M253.578,254.623a3.08,3.08,0,0,0,1.476,5.979,3.079,3.079,0,1,0-1.476-5.979Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74065",
    "data-name": "Path 74065",
    d: "M242.5,257.726a2.739,2.739,0,0,0-1.936,3.215,2.568,2.568,0,0,0,3.224,1.878,2.653,2.653,0,0,0,1.862-3.12A2.742,2.742,0,0,0,242.5,257.726Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74066",
    "data-name": "Path 74066",
    d: "M231.35,261.016a2.013,2.013,0,0,0-1.484,2.5,2.054,2.054,0,1,0,3.994-.959A2.11,2.11,0,0,0,231.35,261.016Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74067",
    "data-name": "Path 74067",
    d: "M220.259,264.3a1.527,1.527,0,0,0-1.145,1.861,1.519,1.519,0,0,0,2.951-.716A1.5,1.5,0,0,0,220.259,264.3Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74068",
    "data-name": "Path 74068",
    d: "M208.362,268.815a1.044,1.044,0,0,0,1.222.639.967.967,0,0,0,.714-1.184.989.989,0,0,0-1.166-.695A1.046,1.046,0,0,0,208.362,268.815Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74069",
    "data-name": "Path 74069",
    d: "M197.721,271.39a.362.362,0,0,0,.453.245.331.331,0,0,0,.319-.451.424.424,0,0,0-.452-.338C197.8,270.978,197.666,271.129,197.721,271.39Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74070",
    "data-name": "Path 74070",
    d: "M464.959,194.473a.384.384,0,0,0,.452.189.287.287,0,0,0,.187-.376c0-.189-.187-.264-.375-.189C465.092,194.1,464.959,194.286,464.959,194.473Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74071",
    "data-name": "Path 74071",
    d: "M453.173,197.312a.922.922,0,0,0,1.167.7c.45-.056.714-.639.639-1.09-.189-.639-.639-.9-1.092-.77A.98.98,0,0,0,453.173,197.312Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74072",
    "data-name": "Path 74072",
    d: "M442.421,198.346a1.464,1.464,0,0,0-1.033,1.861,1.427,1.427,0,0,0,1.8,1.109,1.582,1.582,0,0,0,1.09-1.8A1.55,1.55,0,0,0,442.421,198.346Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74073",
    "data-name": "Path 74073",
    d: "M431.088,200.526a2,2,0,0,0-1.486,2.52,2.081,2.081,0,0,0,2.462,1.615,2.125,2.125,0,0,0,1.541-2.593A2.083,2.083,0,0,0,431.088,200.526Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74074",
    "data-name": "Path 74074",
    d: "M419.753,202.726a2.545,2.545,0,0,0-1.937,3.213,2.583,2.583,0,0,0,3.159,1.936,2.724,2.724,0,0,0,1.936-3.214A2.633,2.633,0,0,0,419.753,202.726Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74075",
    "data-name": "Path 74075",
    d: "M408.267,204.98a3.153,3.153,0,1,0,1.561,6.11,3.153,3.153,0,1,0-1.561-6.11Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74076",
    "data-name": "Path 74076",
    d: "M396.951,207.236a3.661,3.661,0,0,0-2.781,4.418,3.614,3.614,0,0,0,4.454,2.67,3.564,3.564,0,0,0,2.839-4.38A3.61,3.61,0,0,0,396.951,207.236Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74077",
    "data-name": "Path 74077",
    d: "M385.6,209.286a4.311,4.311,0,1,0,5.168,3.232A4.389,4.389,0,0,0,385.6,209.286Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74078",
    "data-name": "Path 74078",
    d: "M374.208,211.542a4.9,4.9,0,0,0-3.534,5.846,4.782,4.782,0,0,0,9.285-2.295A4.874,4.874,0,0,0,374.208,211.542Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74079",
    "data-name": "Path 74079",
    d: "M362.817,213.779a5.293,5.293,0,0,0-3.873,6.446,5.232,5.232,0,0,0,6.373,3.892,5.318,5.318,0,1,0-2.5-10.338Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74080",
    "data-name": "Path 74080",
    d: "M295.3,230.151a5.439,5.439,0,1,0,6.579,3.929A5.367,5.367,0,0,0,295.3,230.151Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74081",
    "data-name": "Path 74081",
    d: "M284.226,233.308a4.951,4.951,0,1,0,5.941,3.665A4.931,4.931,0,0,0,284.226,233.308Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74082",
    "data-name": "Path 74082",
    d: "M273.032,236.467a4.487,4.487,0,1,0,5.4,3.345A4.44,4.44,0,0,0,273.032,236.467Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74083",
    "data-name": "Path 74083",
    d: "M261.943,239.812a3.9,3.9,0,0,0-2.953,4.718,3.976,3.976,0,0,0,7.726-1.879A3.908,3.908,0,0,0,261.943,239.812Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74084",
    "data-name": "Path 74084",
    d: "M250.806,243.046a3.423,3.423,0,0,0,1.607,6.654,3.486,3.486,0,0,0,2.518-4.154A3.4,3.4,0,0,0,250.806,243.046Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74085",
    "data-name": "Path 74085",
    d: "M239.725,246.391a2.783,2.783,0,0,0-2.116,3.345,2.85,2.85,0,0,0,5.536-1.353A2.816,2.816,0,0,0,239.725,246.391Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74086",
    "data-name": "Path 74086",
    d: "M228.588,249.6a2.247,2.247,0,0,0-1.675,2.707,2.183,2.183,0,0,0,2.764,1.672,2.156,2.156,0,0,0,1.617-2.706A2.256,2.256,0,0,0,228.588,249.6Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74087",
    "data-name": "Path 74087",
    d: "M217.516,252.82a1.751,1.751,0,0,0,.751,3.42,1.751,1.751,0,0,0-.751-3.42Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74088",
    "data-name": "Path 74088",
    d: "M205.523,257.538a1.133,1.133,0,0,0,2.2-.545,1.133,1.133,0,0,0-2.2.545Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74089",
    "data-name": "Path 74089",
    d: "M194.828,260.151a.6.6,0,0,0,.657.412.606.606,0,0,0,.452-.639.549.549,0,0,0-.714-.45A.554.554,0,0,0,194.828,260.151Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74090",
    "data-name": "Path 74090",
    d: "M462.139,183.2a.452.452,0,0,0,.564.414.514.514,0,0,0,.339-.6.537.537,0,0,0-.6-.4A.459.459,0,0,0,462.139,183.2Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74091",
    "data-name": "Path 74091",
    d: "M450.278,186.109a1.016,1.016,0,0,0,1.3.7,1.021,1.021,0,1,0-.451-1.992A1.115,1.115,0,0,0,450.278,186.109Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74092",
    "data-name": "Path 74092",
    d: "M439.715,186.935a1.692,1.692,0,1,0,1.936,1.223A1.69,1.69,0,0,0,439.715,186.935Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74093",
    "data-name": "Path 74093",
    d: "M428.3,189.191a2.161,2.161,0,0,0-1.6,2.651,2.185,2.185,0,1,0,4.248-1.015A2.094,2.094,0,0,0,428.3,189.191Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74094",
    "data-name": "Path 74094",
    d: "M416.913,191.391a2.786,2.786,0,0,0-2.067,3.346,2.83,2.83,0,0,0,3.423,2.067,2.893,2.893,0,0,0,2.067-3.421A2.788,2.788,0,0,0,416.913,191.391Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74095",
    "data-name": "Path 74095",
    d: "M405.522,193.533a3.448,3.448,0,0,0-2.517,4.023,3.5,3.5,0,0,0,4.134,2.52,3.37,3.37,0,1,0-1.617-6.543Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74096",
    "data-name": "Path 74096",
    d: "M394.114,195.639a3.987,3.987,0,0,0-2.9,4.832,3.973,3.973,0,0,0,7.724-1.862A3.983,3.983,0,0,0,394.114,195.639Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74097",
    "data-name": "Path 74097",
    d: "M382.779,197.9a4.576,4.576,0,0,0-3.421,5.47,4.677,4.677,0,0,0,5.6,3.327,4.532,4.532,0,1,0-2.181-8.8Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74098",
    "data-name": "Path 74098",
    d: "M371.444,199.962a5.159,5.159,0,1,0,6.184,3.8A5.194,5.194,0,0,0,371.444,199.962Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74099",
    "data-name": "Path 74099",
    d: "M281.4,221.655a5.367,5.367,0,1,0,6.438,3.946A5.351,5.351,0,0,0,281.4,221.655Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74100",
    "data-name": "Path 74100",
    d: "M270.185,225.02a4.714,4.714,0,0,0-3.469,5.732,4.769,4.769,0,1,0,9.268-2.256A4.715,4.715,0,0,0,270.185,225.02Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74101",
    "data-name": "Path 74101",
    d: "M259.113,228.309a4.167,4.167,0,0,0-3.091,5,4.218,4.218,0,0,0,5.084,3.1,4.173,4.173,0,1,0-1.993-8.1Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74102",
    "data-name": "Path 74102",
    d: "M247.967,231.5a3.684,3.684,0,1,0,4.446,2.707A3.716,3.716,0,0,0,247.967,231.5Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74103",
    "data-name": "Path 74103",
    d: "M236.951,234.944a2.921,2.921,0,0,0-2.246,3.609,2.97,2.97,0,0,0,3.667,2.237,3.025,3.025,0,0,0,2.188-3.684A2.889,2.889,0,0,0,236.951,234.944Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74104",
    "data-name": "Path 74104",
    d: "M225.8,238.139a2.467,2.467,0,1,0,3.028,1.8A2.563,2.563,0,0,0,225.8,238.139Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74105",
    "data-name": "Path 74105",
    d: "M214.733,241.485a1.839,1.839,0,0,0-1.409,2.2,1.844,1.844,0,1,0,1.409-2.2Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74106",
    "data-name": "Path 74106",
    d: "M202.685,246.316a1.308,1.308,0,0,0,1.56.978,1.381,1.381,0,0,0,.9-1.542,1.23,1.23,0,0,0-1.562-.9A1.183,1.183,0,0,0,202.685,246.316Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74107",
    "data-name": "Path 74107",
    d: "M191.933,248.91a.645.645,0,0,0,.845.507.716.716,0,0,0,.564-.845.679.679,0,0,0-.9-.508A.7.7,0,0,0,191.933,248.91Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74108",
    "data-name": "Path 74108",
    d: "M181.312,251.542c0,.131.056.075.131.075.058,0,.133-.075.058-.208a.215.215,0,0,0-.133-.056C181.312,251.353,181.312,251.542,181.312,251.542Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74109",
    "data-name": "Path 74109",
    d: "M459.283,171.918c.15.337.413.545.714.45a.483.483,0,0,0,.338-.677c0-.262-.338-.412-.6-.337A.587.587,0,0,0,459.283,171.918Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74110",
    "data-name": "Path 74110",
    d: "M447.441,174.83a1.109,1.109,0,0,0,1.428.828,1.014,1.014,0,0,0,.828-1.353,1.139,1.139,0,0,0-1.353-.809A1.174,1.174,0,0,0,447.441,174.83Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74111",
    "data-name": "Path 74111",
    d: "M437.778,179.136a1.927,1.927,0,0,0,1.279-2.256,1.74,1.74,0,0,0-2.1-1.261,1.8,1.8,0,0,0-1.355,2.125A1.864,1.864,0,0,0,437.778,179.136Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74112",
    "data-name": "Path 74112",
    d: "M425.542,177.744a2.362,2.362,0,0,0-1.73,2.839,2.408,2.408,0,0,0,2.839,1.8,2.342,2.342,0,0,0,1.729-2.837A2.38,2.38,0,0,0,425.542,177.744Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74113",
    "data-name": "Path 74113",
    d: "M414.207,180a2.808,2.808,0,0,0-2.18,3.459,2.91,2.91,0,1,0,5.659-1.353A2.8,2.8,0,0,0,414.207,180Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74114",
    "data-name": "Path 74114",
    d: "M402.741,182.106a3.536,3.536,0,0,0-2.575,4.248,3.513,3.513,0,1,0,6.823-1.673A3.486,3.486,0,0,0,402.741,182.106Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74115",
    "data-name": "Path 74115",
    d: "M391.35,184.192a4.132,4.132,0,0,0-3.045,5,4.217,4.217,0,0,0,5.037,3.1,4.172,4.172,0,0,0-1.992-8.1Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74116",
    "data-name": "Path 74116",
    d: "M380,186.429a4.677,4.677,0,0,0-3.534,5.657,4.778,4.778,0,1,0,9.285-2.256A4.689,4.689,0,0,0,380,186.429Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74117",
    "data-name": "Path 74117",
    d: "M368.606,188.571A5.305,5.305,0,0,0,364.62,195a5.432,5.432,0,0,0,6.562,4.06,5.521,5.521,0,0,0,3.928-6.654A5.413,5.413,0,0,0,368.606,188.571Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74118",
    "data-name": "Path 74118",
    d: "M267.479,213.554a4.869,4.869,0,0,0-3.667,5.976,4.974,4.974,0,1,0,3.667-5.976Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74119",
    "data-name": "Path 74119",
    d: "M256.407,216.9a4.308,4.308,0,0,0-3.28,5.206,4.375,4.375,0,1,0,8.506-2.049A4.3,4.3,0,0,0,256.407,216.9Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74120",
    "data-name": "Path 74120",
    d: "M245.2,220.188a3.724,3.724,0,0,0-2.7,4.512,3.8,3.8,0,0,0,4.5,2.818,3.774,3.774,0,1,0-1.8-7.33Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74121",
    "data-name": "Path 74121",
    d: "M234.189,223.534a3.153,3.153,0,0,0-2.379,3.778,3.148,3.148,0,1,0,2.379-3.778Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74122",
    "data-name": "Path 74122",
    d: "M223.042,226.823a2.63,2.63,0,0,0-1.917,3.064,2.6,2.6,0,0,0,3.138,1.9,2.555,2.555,0,0,0-1.221-4.962Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74123",
    "data-name": "Path 74123",
    d: "M211.971,230.151a1.9,1.9,0,0,0-1.411,2.331,1.915,1.915,0,1,0,3.722-.9A1.859,1.859,0,0,0,211.971,230.151Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74124",
    "data-name": "Path 74124",
    d: "M200.824,233.458a1.37,1.37,0,0,0-1.033,1.6,1.392,1.392,0,0,0,2.706-.657A1.393,1.393,0,0,0,200.824,233.458Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74125",
    "data-name": "Path 74125",
    d: "M189.1,237.689a.831.831,0,0,0,1.616-.378.831.831,0,1,0-1.616.378Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74126",
    "data-name": "Path 74126",
    d: "M178.473,240.262c0,.208.133.208.264.133a.153.153,0,0,0,.133-.169c-.077-.15-.133-.206-.264-.206C178.473,240.076,178.473,240.131,178.473,240.262Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74127",
    "data-name": "Path 74127",
    d: "M457.629,160.452a.464.464,0,0,0-.639-.358.48.48,0,0,0-.394.677c.055.337.319.451.639.412C457.629,161.108,457.741,160.864,457.629,160.452Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74128",
    "data-name": "Path 74128",
    d: "M447.064,163.12a1.326,1.326,0,0,0-1.428-1,1.255,1.255,0,0,0-.9,1.56,1.128,1.128,0,0,0,1.428.789A1.179,1.179,0,0,0,447.064,163.12Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74129",
    "data-name": "Path 74129",
    d: "M435.072,167.82a1.847,1.847,0,0,0,1.242-2.125,1.778,1.778,0,0,0-2.145-1.315,1.819,1.819,0,0,0-1.277,2.143A1.909,1.909,0,0,0,435.072,167.82Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74130",
    "data-name": "Path 74130",
    d: "M423.87,171.109a2.351,2.351,0,1,0-1.034-4.586,2.42,2.42,0,0,0-1.8,2.819A2.327,2.327,0,0,0,423.87,171.109Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74131",
    "data-name": "Path 74131",
    d: "M412.779,174.435a2.857,2.857,0,0,0,2.2-3.533,2.914,2.914,0,0,0-3.553-2.179,2.936,2.936,0,1,0,1.353,5.712Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74132",
    "data-name": "Path 74132",
    d: "M401.727,177.783a3.6,3.6,0,0,0-1.748-6.993,3.6,3.6,0,1,0,1.748,6.993Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74133",
    "data-name": "Path 74133",
    d: "M390.636,181.2a4.243,4.243,0,0,0,3.083-5.131,4.173,4.173,0,1,0-3.083,5.131Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74134",
    "data-name": "Path 74134",
    d: "M379.545,184.418a4.81,4.81,0,1,0-2.292-9.343,4.877,4.877,0,0,0-3.609,5.865A4.784,4.784,0,0,0,379.545,184.418Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74135",
    "data-name": "Path 74135",
    d: "M282.167,201.824a5.681,5.681,0,0,0-6.371-2.97,5.614,5.614,0,0,0-4.183,6.9,5.761,5.761,0,0,0,6.889,4.192,5.667,5.667,0,0,0,4.248-5.545,6.847,6.847,0,0,0,4.71,3.609,6.279,6.279,0,0,0-2.4,5.732,5.56,5.56,0,1,0-3.854,7.388,5.668,5.668,0,0,0,4.117-6.316,6.146,6.146,0,0,0,5.987,4.135,5.745,5.745,0,0,0-3.147,6.56,5.8,5.8,0,0,0,11.456-1.071,6.709,6.709,0,0,0,5.545,3.29,5.522,5.522,0,0,0-2.95,6.315,5.756,5.756,0,0,0,7.01,4.229,5.68,5.68,0,0,0,4.3-6.24,6.14,6.14,0,0,0,7.031,3.817,6.025,6.025,0,0,0,4.512-5.96,5.954,5.954,0,0,0,6.691,3.252,5.378,5.378,0,0,0-3.985,6.636,5.521,5.521,0,0,0,6.56,4.06,5.724,5.724,0,0,0,4.117-6.729,5.506,5.506,0,0,0-6.692-3.967,6.092,6.092,0,0,0,4.511-6.146,6.026,6.026,0,0,0,6.691,3.308,6.1,6.1,0,0,0,4.456-7.087,5.651,5.651,0,1,0,4.756-7.087,5.994,5.994,0,0,0,3.946-6.446,5.593,5.593,0,0,0,6.562,3.534,5.681,5.681,0,0,0,4.248-6.824,5.77,5.77,0,0,0-6.712-4.248,5.821,5.821,0,0,0,4.192-7.087,5.956,5.956,0,0,0-6-4.379,5.972,5.972,0,0,0,3.365-6.9,5.5,5.5,0,1,0,4.059-6.635,5.623,5.623,0,0,0-4.059,6.635,5.968,5.968,0,0,0-5.921-4.551,5.889,5.889,0,0,0,3.157-6.635,6.027,6.027,0,0,0-6.579-4.511,5.83,5.83,0,0,0,3.684-6.729,5.93,5.93,0,0,0-7.1-4.229,5.675,5.675,0,0,0-4.3,5.545,6.324,6.324,0,0,0-5.415-3.42,5.8,5.8,0,0,0-4.248-10.7,5.7,5.7,0,0,0-4.323,5.864,6.114,6.114,0,0,0-6.373-3.478,5.551,5.551,0,1,0-1.22.32,5.759,5.759,0,0,0-3.987,4.681,6.522,6.522,0,0,0-5.412-2.5,5.664,5.664,0,1,0-8.121-3.665,5.784,5.784,0,0,0,5.6,4.323,6.212,6.212,0,0,0-3.551,4.417,6.638,6.638,0,0,0-5.415-2.294,5.574,5.574,0,0,0,3.234-6.371,5.7,5.7,0,1,0-11.072,2.706,5.606,5.606,0,0,0,5.808,4.173,6.212,6.212,0,0,0-3.76,5.17,5.98,5.98,0,0,0-10.882,4.493,5.621,5.621,0,1,0-4.3,6.973,6.087,6.087,0,0,0-4.248,7.255,6.016,6.016,0,0,0,5.337,4.473,6.249,6.249,0,0,0-2.895,5.771,5.523,5.523,0,0,0-6.381-3.195,5.6,5.6,0,0,0-4.182,6.8,5.693,5.693,0,0,0,6.824,4.136,5.444,5.444,0,0,0,4.247-5.676,6.09,6.09,0,0,0,4.512,3.609A6.4,6.4,0,0,0,282.167,201.824Zm6.7-21.579a6.219,6.219,0,0,0,3.478,2.367,5.911,5.911,0,0,0-2.059,3.609,6.126,6.126,0,0,0-4.116-2.029A6.233,6.233,0,0,0,288.869,180.245Zm11.466-2.012A7.941,7.941,0,0,0,302.78,180a6.213,6.213,0,0,0-1.467,2.5,7.967,7.967,0,0,0-2.67-1.429A6.616,6.616,0,0,0,300.335,178.233Zm11.467-2.444a7.832,7.832,0,0,0,1.991,1.43,8.352,8.352,0,0,0-1.222,1.878,5.723,5.723,0,0,0-1.934-.977A8.024,8.024,0,0,0,311.8,175.789Zm11.465-2.837a5.823,5.823,0,0,0,2.331,1.483,7.568,7.568,0,0,0-1.428,1.956,8.7,8.7,0,0,0-2.067-1.222A7.423,7.423,0,0,0,323.267,172.952Zm11.2-3.329a6.842,6.842,0,0,0,3.214,2.068,5.927,5.927,0,0,0-1.936,2.689,7.47,7.47,0,0,0-2.893-1.673A7.164,7.164,0,0,0,334.47,169.623Zm14.041,8.16a5.965,5.965,0,0,0,4.643,2.142,5.855,5.855,0,0,0-3.232,3.984,6.783,6.783,0,0,0-3.534-2.386A7.094,7.094,0,0,0,348.511,177.783Zm4.268,17.668a6.563,6.563,0,0,0-3.759-2.462,6.749,6.749,0,0,0,2.2-3.929,6.165,6.165,0,0,0,4.829,2.218A5.457,5.457,0,0,0,352.779,195.451Zm-8.647,13.835a5.809,5.809,0,0,0-3.214-2.181,7.716,7.716,0,0,0,1.936-3.289,5.95,5.95,0,0,0,3.4,1.861A5.983,5.983,0,0,0,344.132,209.286Zm-11.6,2.256a6.312,6.312,0,0,0-2.442-1.805,5.762,5.762,0,0,0,1.542-2.443,10.938,10.938,0,0,0,2.575,1.353A7.369,7.369,0,0,0,332.533,211.542ZM321.2,214.193a6.123,6.123,0,0,0-2.575-1.675,8.037,8.037,0,0,0,1.559-2.254,6.962,6.962,0,0,0,2.444,1.353A7.439,7.439,0,0,0,321.2,214.193Zm-11.335,3.081a6.179,6.179,0,0,0-3.215-1.917,7.93,7.93,0,0,0,1.993-2.839,6.854,6.854,0,0,0,2.895,1.711A6.517,6.517,0,0,0,309.865,217.274Zm-6.71-26.991a4.884,4.884,0,0,0,1.8,1.22,5.66,5.66,0,0,0-1.015,1.936,7.218,7.218,0,0,0-2.181-1.033A6.479,6.479,0,0,0,303.155,190.283Zm23.083-5.151c.563.319,1.014.639,1.541.9a4.324,4.324,0,0,0-.827,1.184,6.989,6.989,0,0,0-1.24-.9A3.826,3.826,0,0,0,326.238,185.132Zm11.2-3.534a7.553,7.553,0,0,0,2.708,1.467,5.494,5.494,0,0,0-1.692,2.461,4.858,4.858,0,0,0-2.256-1.466A8.164,8.164,0,0,0,337.44,181.6Zm3.722,15.658a7.91,7.91,0,0,0-2.369-1.748,5.335,5.335,0,0,0,1.467-2.575,6.689,6.689,0,0,0,2.781,1.54A6.8,6.8,0,0,0,341.162,197.256ZM329.7,199.3a3.427,3.427,0,0,0-1.2-1.034c.245-.45.564-.958.828-1.466a4.245,4.245,0,0,0,1.465.639A6.855,6.855,0,0,0,329.7,199.3Zm-11.579,2.52a4.934,4.934,0,0,0-1.429-.772c.264-.4.584-.789.847-1.165.395.264.77.526,1.221.77C318.494,200.977,318.38,201.429,318.117,201.824Zm-11.222,3.4a6.7,6.7,0,0,0-2.443-1.353,10.243,10.243,0,0,0,1.484-2.106,6.961,6.961,0,0,0,1.993,1.317A4.879,4.879,0,0,0,306.895,205.225Zm8.779-16.484a10.352,10.352,0,0,0-.583,1.089,8.634,8.634,0,0,0-1.034-.506,3.786,3.786,0,0,0,.714-1.2A2.76,2.76,0,0,0,315.674,188.741Zm-23.966,3.289a6.087,6.087,0,0,0,3.026,2.067,7.561,7.561,0,0,0-1.881,3.215,5.91,5.91,0,0,0-3.335-1.936A6.315,6.315,0,0,0,291.708,192.03Zm2.706,11.391a6.905,6.905,0,0,0,3.215,2.068,6.466,6.466,0,0,0-1.806,3.42,5.921,5.921,0,0,0-3.609-2.067A7.2,7.2,0,0,0,294.414,203.421Zm4.454,17.782a5.576,5.576,0,0,0-5.112-2.782,6.488,6.488,0,0,0,3.345-4.1,6.837,6.837,0,0,0,3.8,2.386A6.308,6.308,0,0,0,298.868,221.2Zm14.342,9.4a5.7,5.7,0,0,0-5.281-3.609,6.437,6.437,0,0,0,3.289-4.193,6.719,6.719,0,0,0,4.117,2.464A5.961,5.961,0,0,0,313.21,230.6Zm11.147-3.421a6.209,6.209,0,0,0-4.06-3.158,6.294,6.294,0,0,0,2.445-3.648,5.974,5.974,0,0,0,3.759,2.181A5.588,5.588,0,0,0,324.357,227.181Zm11.391-2.575a6.187,6.187,0,0,0-4.06-3.328,6.017,6.017,0,0,0,2.331-3.665A7.147,7.147,0,0,0,338,219.736,5.879,5.879,0,0,0,335.748,224.606Zm11.618-1.711a5.92,5.92,0,0,0-4.775-4.268,6.973,6.973,0,0,0,2.764-4.4,5.6,5.6,0,0,0,5.545,2.218A5.659,5.659,0,0,0,347.366,222.9Zm8.421-14.512a6.242,6.242,0,0,0-4.437-3.947,6.236,6.236,0,0,0,2.518-4.285,5.978,5.978,0,0,0,5.9,2.123A5.745,5.745,0,0,0,355.787,208.383ZM345.43,165.489a5.516,5.516,0,0,0,5.657,2.912,6.2,6.2,0,0,0-3.873,4.381,6.142,6.142,0,0,0-3.909-2.537A6.419,6.419,0,0,0,345.43,165.489Zm-14.192-8.76A5.843,5.843,0,0,0,336.2,160a5.979,5.979,0,0,0-3.083,3.929,6.573,6.573,0,0,0-3.929-2.292A6.489,6.489,0,0,0,331.238,156.729Zm-10.941,4a6.549,6.549,0,0,0,3.421,2.181,6.648,6.648,0,0,0-2.123,3.158,7.839,7.839,0,0,0-3.29-1.861A6.5,6.5,0,0,0,320.3,160.733Zm-11.391,2.839a6.229,6.229,0,0,0,3.215,2.161,6.865,6.865,0,0,0-1.992,3.121,6.394,6.394,0,0,0-3.234-1.806A6.648,6.648,0,0,0,308.906,163.572ZM297.365,165.7a6.369,6.369,0,0,0,3.609,2.745,7.215,7.215,0,0,0-2.181,3.57,5.814,5.814,0,0,0-3.74-2.084A5.4,5.4,0,0,0,297.365,165.7Zm-11.71,1.072a6,6,0,0,0,4.7,4.342,6.364,6.364,0,0,0-2.641,4.3,6.3,6.3,0,0,0-6.051-2.142A5.483,5.483,0,0,0,285.655,166.767Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74136",
    "data-name": "Path 74136",
    d: "M267.1,212.068a5.01,5.01,0,0,0,3.733-6.129,5.068,5.068,0,1,0-3.733,6.129Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74137",
    "data-name": "Path 74137",
    d: "M255.693,214.193a4.489,4.489,0,0,0,3.3-5.415,4.429,4.429,0,0,0-5.412-3.214,4.307,4.307,0,0,0-3.224,5.339A4.4,4.4,0,0,0,255.693,214.193Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74138",
    "data-name": "Path 74138",
    d: "M244.292,216.316a3.843,3.843,0,0,0,2.847-4.568,3.848,3.848,0,1,0-2.847,4.568Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74139",
    "data-name": "Path 74139",
    d: "M232.957,218.421a3.212,3.212,0,0,0,2.321-3.853,3.192,3.192,0,1,0-6.184,1.559A3.122,3.122,0,0,0,232.957,218.421Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74140",
    "data-name": "Path 74140",
    d: "M221.5,220.544a2.468,2.468,0,0,0,1.917-3.062,2.508,2.508,0,0,0-3.084-2.011,2.6,2.6,0,0,0-1.917,3.231A2.471,2.471,0,0,0,221.5,220.544Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74141",
    "data-name": "Path 74141",
    d: "M210.165,222.764a2.018,2.018,0,0,0-.9-3.929,2.036,2.036,0,0,0-1.542,2.443A2.067,2.067,0,0,0,210.165,222.764Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74142",
    "data-name": "Path 74142",
    d: "M198.757,224.887a1.367,1.367,0,0,0,1.034-1.673,1.417,1.417,0,0,0-2.764.62A1.36,1.36,0,0,0,198.757,224.887Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74143",
    "data-name": "Path 74143",
    d: "M188.005,226.053a.908.908,0,0,0-1.016-.583.8.8,0,0,0-.6,1.034.755.755,0,0,0,.978.564A.806.806,0,0,0,188.005,226.053Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74144",
    "data-name": "Path 74144",
    d: "M175.711,229.079c.056.114.112.169.245.114.13-.077.263-.114.206-.245,0-.152-.131-.152-.262-.152C175.767,228.873,175.636,228.948,175.711,229.079Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74145",
    "data-name": "Path 74145",
    d: "M454.921,149.267c-.075-.32-.394-.545-.639-.451a.519.519,0,0,0-.45.7.565.565,0,0,0,.7.4A.625.625,0,0,0,454.921,149.267Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74146",
    "data-name": "Path 74146",
    d: "M444.227,151.842a1.158,1.158,0,0,0-1.353-.9,1.134,1.134,0,0,0-.847,1.392,1.129,1.129,0,1,0,2.2-.489Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74147",
    "data-name": "Path 74147",
    d: "M432.308,156.6a1.821,1.821,0,0,0-.845-3.534,1.778,1.778,0,0,0-1.278,2.181A1.735,1.735,0,0,0,432.308,156.6Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74148",
    "data-name": "Path 74148",
    d: "M421.162,159.868a2.431,2.431,0,0,0,1.805-2.875,2.469,2.469,0,0,0-2.9-1.748,2.39,2.39,0,0,0-1.748,2.912A2.341,2.341,0,0,0,421.162,159.868Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74149",
    "data-name": "Path 74149",
    d: "M410.073,163.158a2.938,2.938,0,0,0,2.2-3.515,3.032,3.032,0,0,0-3.59-2.2,3.1,3.1,0,0,0-2.2,3.554A2.962,2.962,0,0,0,410.073,163.158Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74150",
    "data-name": "Path 74150",
    d: "M398.943,166.523a3.586,3.586,0,0,0-1.672-6.974,3.586,3.586,0,1,0,1.672,6.974Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74151",
    "data-name": "Path 74151",
    d: "M387.8,169.887a4.175,4.175,0,1,0-1.935-8.121,4.107,4.107,0,0,0-3.008,5A4.165,4.165,0,0,0,387.8,169.887Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74152",
    "data-name": "Path 74152",
    d: "M376.8,173.158a4.788,4.788,0,0,0,3.456-5.733,4.65,4.65,0,0,0-5.713-3.609,4.806,4.806,0,0,0,2.257,9.342Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74153",
    "data-name": "Path 74153",
    d: "M365.711,176.522a5.409,5.409,0,1,0-6.578-4.023A5.454,5.454,0,0,0,365.711,176.522Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74154",
    "data-name": "Path 74154",
    d: "M264.339,200.79a5.041,5.041,0,1,0-6.128-3.742A5.093,5.093,0,0,0,264.339,200.79Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74155",
    "data-name": "Path 74155",
    d: "M252.929,202.913a4.572,4.572,0,0,0,3.355-5.357,4.5,4.5,0,0,0-5.413-3.214,4.407,4.407,0,1,0,2.058,8.571Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74156",
    "data-name": "Path 74156",
    d: "M241.594,205.038a3.811,3.811,0,1,0-4.643-2.858A3.837,3.837,0,0,0,241.594,205.038Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74157",
    "data-name": "Path 74157",
    d: "M230.26,207.236a3.257,3.257,0,0,0-1.541-6.315,3.185,3.185,0,0,0-2.387,3.929A3.3,3.3,0,0,0,230.26,207.236Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74158",
    "data-name": "Path 74158",
    d: "M218.795,209.286a2.539,2.539,0,0,0,1.916-3.083,2.625,2.625,0,0,0-3.158-1.937,2.74,2.74,0,0,0-1.917,3.159A2.6,2.6,0,0,0,218.795,209.286Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74159",
    "data-name": "Path 74159",
    d: "M207.459,211.542a2.065,2.065,0,0,0,1.409-2.5,1.985,1.985,0,0,0-3.853.958A2.045,2.045,0,0,0,207.459,211.542Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74160",
    "data-name": "Path 74160",
    d: "M195.993,213.665a1.42,1.42,0,0,0-.658-2.762,1.431,1.431,0,0,0-1.015,1.748A1.525,1.525,0,0,0,195.993,213.665Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74161",
    "data-name": "Path 74161",
    d: "M185.185,214.812a.779.779,0,0,0-.9-.583.842.842,0,0,0-.659,1,1.048,1.048,0,0,0,1.034.639A.936.936,0,0,0,185.185,214.812Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74162",
    "data-name": "Path 74162",
    d: "M173.455,217.669c0-.15-.206-.187-.339-.15-.111,0-.186.15-.186.283.075.13.186.244.319.167C173.38,217.969,173.455,217.8,173.455,217.669Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74163",
    "data-name": "Path 74163",
    d: "M452.14,138.045a.434.434,0,0,0-.564-.375.45.45,0,0,0-.395.639.371.371,0,0,0,.583.261A.4.4,0,0,0,452.14,138.045Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74164",
    "data-name": "Path 74164",
    d: "M441.463,140.64a1.033,1.033,0,0,0-1.3-.847,1.159,1.159,0,0,0-.844,1.353,1.266,1.266,0,0,0,1.352.847A1.227,1.227,0,0,0,441.463,140.64Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74165",
    "data-name": "Path 74165",
    d: "M429.546,145.263a1.826,1.826,0,0,0,1.278-2.067,1.8,1.8,0,0,0-2.067-1.278,1.776,1.776,0,0,0-1.278,2.123A1.7,1.7,0,0,0,429.546,145.263Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74166",
    "data-name": "Path 74166",
    d: "M418.456,148.553a2.3,2.3,0,0,0,1.672-2.707,2.39,2.39,0,0,0-2.762-1.747,2.352,2.352,0,0,0-1.673,2.856A2.234,2.234,0,0,0,418.456,148.553Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74167",
    "data-name": "Path 74167",
    d: "M407.328,151.842a2.893,2.893,0,0,0,2.106-3.42,2.855,2.855,0,0,0-3.459-2.125,2.854,2.854,0,1,0,1.353,5.545Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74168",
    "data-name": "Path 74168",
    d: "M396.181,155.187a3.456,3.456,0,0,0,2.576-4.209,3.387,3.387,0,0,0-4.193-2.481,3.431,3.431,0,0,0-2.519,4.173A3.511,3.511,0,0,0,396.181,155.187Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74169",
    "data-name": "Path 74169",
    d: "M385.091,158.515a4.04,4.04,0,0,0,3.025-4.869,4.2,4.2,0,0,0-4.962-3.121,4.113,4.113,0,0,0,1.937,7.99Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74170",
    "data-name": "Path 74170",
    d: "M374.019,161.8a4.714,4.714,0,0,0,3.422-5.584,4.641,4.641,0,1,0-3.422,5.584Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74171",
    "data-name": "Path 74171",
    d: "M362.93,165.037a5.208,5.208,0,0,0-2.5-10.111,5.208,5.208,0,1,0,2.5,10.111Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74172",
    "data-name": "Path 74172",
    d: "M273.032,187.255a5.547,5.547,0,0,0,4-6.635,5.5,5.5,0,1,0-10.7,2.575A5.572,5.572,0,0,0,273.032,187.255Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74173",
    "data-name": "Path 74173",
    d: "M261.556,189.324a4.841,4.841,0,1,0-2.321-9.4,4.906,4.906,0,0,0-3.542,5.94A4.844,4.844,0,0,0,261.556,189.324Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74174",
    "data-name": "Path 74174",
    d: "M250.223,191.447a4.147,4.147,0,0,0,3.091-5.093,4.246,4.246,0,0,0-5.151-3.159,4.294,4.294,0,0,0-3.091,5.226A4.212,4.212,0,0,0,250.223,191.447Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74175",
    "data-name": "Path 74175",
    d: "M238.757,193.647a3.533,3.533,0,0,0,2.706-4.381,3.648,3.648,0,1,0-2.706,4.381Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74176",
    "data-name": "Path 74176",
    d: "M227.421,195.789a3.033,3.033,0,0,0,2.256-3.609,3.164,3.164,0,0,0-3.664-2.35,3.12,3.12,0,0,0-2.332,3.742A3.059,3.059,0,0,0,227.421,195.789Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74177",
    "data-name": "Path 74177",
    d: "M216.086,198.082A2.6,2.6,0,0,0,217.892,195a2.557,2.557,0,0,0-3.026-1.88A2.5,2.5,0,0,0,213,196.147,2.649,2.649,0,0,0,216.086,198.082Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74178",
    "data-name": "Path 74178",
    d: "M204.7,200.151a1.921,1.921,0,0,0,1.355-2.256,1.9,1.9,0,1,0-3.684.9A1.874,1.874,0,0,0,204.7,200.151Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74179",
    "data-name": "Path 74179",
    d: "M194.187,200.79a1.284,1.284,0,0,0-1.559-1.033,1.331,1.331,0,0,0-.939,1.614,1.381,1.381,0,0,0,1.6.959A1.27,1.27,0,0,0,194.187,200.79Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74180",
    "data-name": "Path 74180",
    d: "M182.4,203.627a.742.742,0,0,0-.9-.581.846.846,0,0,0-.508.939c.056.414.45.545.827.414A.636.636,0,0,0,182.4,203.627Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74181",
    "data-name": "Path 74181",
    d: "M170.616,206.522c-.075-.131-.131-.186-.206-.186a.33.33,0,0,0-.113.242c.057.077.113.114.188.077A.162.162,0,0,0,170.616,206.522Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74182",
    "data-name": "Path 74182",
    d: "M449.245,126.71a.274.274,0,0,0-.376-.17.589.589,0,0,0-.394.3.472.472,0,0,0,.508.394C449.189,127.162,449.378,126.993,449.245,126.71Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74183",
    "data-name": "Path 74183",
    d: "M438.606,129.38a1.044,1.044,0,0,0-1.2-.79,1.013,1.013,0,0,0-.714,1.24.986.986,0,1,0,1.917-.45Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74184",
    "data-name": "Path 74184",
    d: "M426.765,133.8a1.539,1.539,0,0,0,1.164-1.842,1.463,1.463,0,0,0-1.861-1.109,1.426,1.426,0,0,0-1.164,1.8A1.484,1.484,0,0,0,426.765,133.8Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74185",
    "data-name": "Path 74185",
    d: "M415.618,137.142a2.081,2.081,0,0,0,1.615-2.631,2.116,2.116,0,0,0-2.573-1.484,2.2,2.2,0,0,0-1.617,2.537A2.156,2.156,0,0,0,415.618,137.142Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74186",
    "data-name": "Path 74186",
    d: "M404.547,140.526a2.875,2.875,0,0,0,1.992-3.384,2.748,2.748,0,0,0-5.34,1.3A2.9,2.9,0,0,0,404.547,140.526Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74187",
    "data-name": "Path 74187",
    d: "M393.4,143.721a3.251,3.251,0,1,0-1.542-6.315,3.219,3.219,0,0,0-2.387,3.873A3.269,3.269,0,0,0,393.4,143.721Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74188",
    "data-name": "Path 74188",
    d: "M382.253,147.069a3.862,3.862,0,0,0,2.838-4.776,3.759,3.759,0,0,0-4.643-2.67,3.831,3.831,0,0,0,1.8,7.446Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74189",
    "data-name": "Path 74189",
    d: "M371.182,150.225a4.343,4.343,0,1,0-5.284-3.214A4.314,4.314,0,0,0,371.182,150.225Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74190",
    "data-name": "Path 74190",
    d: "M360.11,153.515a4.808,4.808,0,0,0,3.534-5.921,4.876,4.876,0,1,0-3.534,5.921Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74191",
    "data-name": "Path 74191",
    d: "M348.964,156.729a5.356,5.356,0,0,0,4-6.56,5.487,5.487,0,0,0-6.579-4,5.644,5.644,0,0,0-4.061,6.579A5.467,5.467,0,0,0,348.964,156.729Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74192",
    "data-name": "Path 74192",
    d: "M270.185,175.658a5.183,5.183,0,0,0,3.74-6.316,5.112,5.112,0,0,0-6.185-3.722,5,5,0,0,0-3.73,6.184A5.1,5.1,0,0,0,270.185,175.658Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74193",
    "data-name": "Path 74193",
    d: "M258.784,177.875a4.686,4.686,0,0,0,3.355-5.62,4.572,4.572,0,1,0-3.355,5.62Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74194",
    "data-name": "Path 74194",
    d: "M247.393,180.037a4.046,4.046,0,1,0-4.9-3.026A4.031,4.031,0,0,0,247.393,180.037Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74195",
    "data-name": "Path 74195",
    d: "M236.05,182.256a3.563,3.563,0,0,0,2.583-4.267,3.515,3.515,0,1,0-6.823,1.692A3.553,3.553,0,0,0,236.05,182.256Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74196",
    "data-name": "Path 74196",
    d: "M224.715,184.418a2.993,2.993,0,0,0,2.067-3.609,2.921,2.921,0,0,0-5.657,1.447A2.965,2.965,0,0,0,224.715,184.418Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74197",
    "data-name": "Path 74197",
    d: "M213.268,186.616A2.382,2.382,0,0,0,215,183.74a2.347,2.347,0,0,0-4.568,1.072A2.383,2.383,0,0,0,213.268,186.616Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74198",
    "data-name": "Path 74198",
    d: "M201.914,188.741a1.79,1.79,0,0,0,1.3-2.125,1.706,1.706,0,0,0-2.125-1.2,1.63,1.63,0,0,0-1.353,1.975A1.72,1.72,0,0,0,201.914,188.741Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74199",
    "data-name": "Path 74199",
    d: "M191.35,189.474a1.14,1.14,0,0,0-1.428-.864,1.218,1.218,0,0,0-.883,1.428,1.294,1.294,0,0,0,1.484.959A1.281,1.281,0,0,0,191.35,189.474Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74200",
    "data-name": "Path 74200",
    d: "M179.509,192.35a.617.617,0,0,0-.716-.451.631.631,0,0,0,.319,1.221A.578.578,0,0,0,179.509,192.35Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74201",
    "data-name": "Path 74201",
    d: "M167.779,195.189l-.075.056h-.058c0,.131.058.131.058.131C167.779,195.339,167.779,195.339,167.779,195.189Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74202",
    "data-name": "Path 74202",
    d: "M446.408,115.563c0-.131-.133-.169-.245-.169-.208,0-.264.169-.264.319,0,.133.189.17.376.17A.253.253,0,0,0,446.408,115.563Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74203",
    "data-name": "Path 74203",
    d: "M435.673,118.233a.685.685,0,0,0-.9-.583.694.694,0,0,0-.6.9.772.772,0,0,0,.978.584A.734.734,0,0,0,435.673,118.233Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74204",
    "data-name": "Path 74204",
    d: "M424,122.481a1.343,1.343,0,0,0,1.033-1.673,1.285,1.285,0,0,0-1.672-1.033,1.364,1.364,0,0,0-1.034,1.653A1.385,1.385,0,0,0,424,122.481Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74205",
    "data-name": "Path 74205",
    d: "M412.854,125.676a1.918,1.918,0,0,0,1.484-2.292,2.055,2.055,0,0,0-2.387-1.428,1.949,1.949,0,0,0-1.353,2.33A1.832,1.832,0,0,0,412.854,125.676Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74206",
    "data-name": "Path 74206",
    d: "M401.783,129.041A2.528,2.528,0,0,0,403.588,126a2.376,2.376,0,0,0-2.97-1.785,2.431,2.431,0,0,0-1.861,2.951A2.612,2.612,0,0,0,401.783,129.041Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74207",
    "data-name": "Path 74207",
    d: "M390.636,132.255a2.983,2.983,0,0,0,2.181-3.665,2.9,2.9,0,0,0-3.609-2.2,3.019,3.019,0,0,0,1.428,5.865Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74208",
    "data-name": "Path 74208",
    d: "M379.509,135.564a3.688,3.688,0,0,0,2.631-4.343,3.776,3.776,0,0,0-4.4-2.706,3.622,3.622,0,0,0-2.445,4.379A3.517,3.517,0,0,0,379.509,135.564Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74209",
    "data-name": "Path 74209",
    d: "M368.418,138.834a4.25,4.25,0,0,0,2.97-5.037,4.082,4.082,0,1,0-7.932,1.936A4.235,4.235,0,0,0,368.418,138.834Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74210",
    "data-name": "Path 74210",
    d: "M357.271,141.918a4.469,4.469,0,0,0,3.346-5.451,4.568,4.568,0,1,0-8.891,2.1A4.576,4.576,0,0,0,357.271,141.918Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74211",
    "data-name": "Path 74211",
    d: "M346.125,145.074a5,5,0,1,0-5.977-3.645A4.918,4.918,0,0,0,346.125,145.074Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74212",
    "data-name": "Path 74212",
    d: "M334.978,148.158a5.327,5.327,0,1,0-6.448-3.909A5.312,5.312,0,0,0,334.978,148.158Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74213",
    "data-name": "Path 74213",
    d: "M290.026,159.3a5.536,5.536,0,0,0-2.643-10.752,5.537,5.537,0,0,0,2.643,10.752Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74214",
    "data-name": "Path 74214",
    d: "M278.691,161.636a5.139,5.139,0,1,0-6.25-3.74A5.179,5.179,0,0,0,278.691,161.636Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74215",
    "data-name": "Path 74215",
    d: "M267.355,163.928a4.658,4.658,0,0,0,3.479-5.638,4.737,4.737,0,1,0-9.2,2.254A4.659,4.659,0,0,0,267.355,163.928Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74216",
    "data-name": "Path 74216",
    d: "M255.955,166.184a4.148,4.148,0,0,0,3.158-5.076,4.278,4.278,0,1,0-8.307,2.05A4.143,4.143,0,0,0,255.955,166.184Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74217",
    "data-name": "Path 74217",
    d: "M244.621,168.534a3.83,3.83,0,0,0,2.772-4.606,3.747,3.747,0,0,0-4.512-2.706,3.814,3.814,0,0,0-2.827,4.511A3.866,3.866,0,0,0,244.621,168.534Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74218",
    "data-name": "Path 74218",
    d: "M233.221,170.657a3.173,3.173,0,0,0,2.377-3.815,3.273,3.273,0,0,0-3.929-2.369,3.226,3.226,0,0,0-2.311,3.853A3.137,3.137,0,0,0,233.221,170.657Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74219",
    "data-name": "Path 74219",
    d: "M221.876,172.952a2.669,2.669,0,0,0,1.936-3.29,2.743,2.743,0,0,0-3.214-1.992,2.772,2.772,0,0,0-1.992,3.307A2.6,2.6,0,0,0,221.876,172.952Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74220",
    "data-name": "Path 74220",
    d: "M210.56,175.207a2.147,2.147,0,0,0,1.467-2.614,2.049,2.049,0,0,0-2.576-1.616,2.165,2.165,0,0,0-1.6,2.633A2.289,2.289,0,0,0,210.56,175.207Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74221",
    "data-name": "Path 74221",
    d: "M199.076,177.331a1.553,1.553,0,0,0,1.221-1.918,1.49,1.49,0,0,0-1.917-1.147,1.569,1.569,0,0,0-1.24,1.917A1.519,1.519,0,0,0,199.076,177.331Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74222",
    "data-name": "Path 74222",
    d: "M188.53,178.328a1.083,1.083,0,0,0-1.3-.79,1.055,1.055,0,0,0-.77,1.24,1.115,1.115,0,0,0,1.278.772A1.138,1.138,0,0,0,188.53,178.328Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74223",
    "data-name": "Path 74223",
    d: "M176.67,181.2a.53.53,0,0,0-.508-.394.6.6,0,0,0-.4.583c.133.206.319.45.583.412A.531.531,0,0,0,176.67,181.2Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74224",
    "data-name": "Path 74224",
    d: "M443.513,104.436l-.058-.15c-.131,0-.131,0-.131.15h.189Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74225",
    "data-name": "Path 74225",
    d: "M432.816,106.992a.637.637,0,0,0-.752-.45.583.583,0,0,0-.451.769c.039.339.376.453.753.414A.671.671,0,0,0,432.816,106.992Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74226",
    "data-name": "Path 74226",
    d: "M422.008,109.662a1.062,1.062,0,0,0-1.353-.865,1.076,1.076,0,1,0,.507,2.087A.967.967,0,0,0,422.008,109.662Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74227",
    "data-name": "Path 74227",
    d: "M410.073,114.285a1.738,1.738,0,0,0,1.239-2.048,1.626,1.626,0,0,0-1.992-1.222,1.7,1.7,0,0,0-1.278,2.048A1.729,1.729,0,0,0,410.073,114.285Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74228",
    "data-name": "Path 74228",
    d: "M398.943,117.444a2.076,2.076,0,0,0,1.617-2.576,2.118,2.118,0,0,0-2.65-1.692,2.248,2.248,0,0,0-1.6,2.707A2.215,2.215,0,0,0,398.943,117.444Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74229",
    "data-name": "Path 74229",
    d: "M387.8,120.677a2.775,2.775,0,0,0,2.069-3.233,2.865,2.865,0,0,0-3.365-2.05,2.835,2.835,0,0,0-1.994,3.328A2.721,2.721,0,0,0,387.8,120.677Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74230",
    "data-name": "Path 74230",
    d: "M376.65,123.873a3.178,3.178,0,1,0-1.464-6.185,3.272,3.272,0,0,0-2.332,3.89A3.163,3.163,0,0,0,376.65,123.873Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74231",
    "data-name": "Path 74231",
    d: "M365.579,127.124a3.7,3.7,0,0,0-1.748-7.18,3.8,3.8,0,0,0-2.706,4.51A3.733,3.733,0,0,0,365.579,127.124Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74232",
    "data-name": "Path 74232",
    d: "M354.432,130.282a4.184,4.184,0,0,0,3.045-4.925,4.076,4.076,0,0,0-4.962-3.026,4.155,4.155,0,0,0-3.1,4.962A4.248,4.248,0,0,0,354.432,130.282Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74233",
    "data-name": "Path 74233",
    d: "M343.23,133.308a4.453,4.453,0,0,0,3.345-5.282,4.516,4.516,0,0,0-5.413-3.364,4.445,4.445,0,0,0,2.068,8.646Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74234",
    "data-name": "Path 74234",
    d: "M332.083,136.372a4.681,4.681,0,0,0,3.478-5.639,4.735,4.735,0,0,0-5.715-3.7,4.8,4.8,0,0,0-3.495,5.865A4.706,4.706,0,0,0,332.083,136.372Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74235",
    "data-name": "Path 74235",
    d: "M320.936,139.342a4.939,4.939,0,0,0,3.609-6,5.026,5.026,0,0,0-6.051-3.741,5.019,5.019,0,0,0,2.442,9.737Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74236",
    "data-name": "Path 74236",
    d: "M309.6,142.18a5.1,5.1,0,1,0-2.387-9.925,5.1,5.1,0,0,0,2.387,9.925Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74237",
    "data-name": "Path 74237",
    d: "M298.418,144.888a5.085,5.085,0,0,0,3.721-6.054,5.037,5.037,0,1,0-9.792,2.37A5.065,5.065,0,0,0,298.418,144.888Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74238",
    "data-name": "Path 74238",
    d: "M287.064,147.463a4.931,4.931,0,0,0,3.676-5.922,4.868,4.868,0,0,0-5.923-3.552,4.716,4.716,0,0,0-3.541,5.865A4.851,4.851,0,0,0,287.064,147.463Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74239",
    "data-name": "Path 74239",
    d: "M275.861,149.85a4.57,4.57,0,0,0-2.19-8.874,4.57,4.57,0,1,0,2.19,8.874Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74240",
    "data-name": "Path 74240",
    d: "M264.526,152.331a4.337,4.337,0,0,0-2.067-8.421,4.227,4.227,0,0,0-3.082,5.262A4.271,4.271,0,0,0,264.526,152.331Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74241",
    "data-name": "Path 74241",
    d: "M253.127,154.587a3.774,3.774,0,0,0,2.828-4.55,3.841,3.841,0,1,0-7.463,1.8A3.806,3.806,0,0,0,253.127,154.587Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74242",
    "data-name": "Path 74242",
    d: "M241.792,156.935a3.522,3.522,0,0,0,2.5-4.059,3.436,3.436,0,0,0-4.117-2.576,3.415,3.415,0,0,0,1.617,6.635Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74243",
    "data-name": "Path 74243",
    d: "M230.391,159.191a2.981,2.981,0,0,0,2.181-3.5,2.919,2.919,0,1,0-2.181,3.5Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74244",
    "data-name": "Path 74244",
    d: "M219.056,161.353a2.4,2.4,0,0,0,1.806-2.838,2.511,2.511,0,0,0-2.9-1.786,2.376,2.376,0,1,0,1.089,4.624Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74245",
    "data-name": "Path 74245",
    d: "M207.723,163.609a1.879,1.879,0,0,0-.9-3.646,1.839,1.839,0,0,0-1.353,2.292A1.793,1.793,0,0,0,207.723,163.609Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74246",
    "data-name": "Path 74246",
    d: "M196.313,165.864a1.345,1.345,0,0,0-.64-2.612,1.394,1.394,0,0,0-.977,1.673A1.357,1.357,0,0,0,196.313,165.864Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74247",
    "data-name": "Path 74247",
    d: "M185.56,167.181a.916.916,0,0,0-1.033-.714.877.877,0,0,0-.583,1.07.793.793,0,0,0,.977.545A.807.807,0,0,0,185.56,167.181Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74248",
    "data-name": "Path 74248",
    d: "M173.775,170c-.075-.245-.206-.339-.32-.245-.131,0-.263.131-.263.356.057.133.263.264.377.226C173.7,170.245,173.831,170.112,173.775,170Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74249",
    "data-name": "Path 74249",
    d: "M429.735,95.809c0-.133-.189-.264-.32-.264-.264.131-.319.264-.264.4,0,.188.131.225.395.188C429.658,96.128,429.81,95.94,429.735,95.809Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74250",
    "data-name": "Path 74250",
    d: "M419.038,98.384a.862.862,0,0,0-1.091-.639.81.81,0,0,0-.581,1.015.857.857,0,1,0,1.672-.376Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74251",
    "data-name": "Path 74251",
    d: "M407.253,102.688a1.326,1.326,0,0,0,1.014-1.73,1.361,1.361,0,0,0-1.653-.976,1.511,1.511,0,0,0-1.034,1.692A1.367,1.367,0,0,0,407.253,102.688Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74252",
    "data-name": "Path 74252",
    d: "M396.181,105.922a1.89,1.89,0,0,0,1.353-2.331,1.84,1.84,0,0,0-2.255-1.278,1.788,1.788,0,0,0-1.429,2.179A1.881,1.881,0,0,0,396.181,105.922Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74253",
    "data-name": "Path 74253",
    d: "M384.96,109.078a2.321,2.321,0,1,0-1.092-4.511,2.237,2.237,0,0,0-1.672,2.744A2.269,2.269,0,0,0,384.96,109.078Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74254",
    "data-name": "Path 74254",
    d: "M373.832,112.274a2.809,2.809,0,1,0-1.355-5.451,2.715,2.715,0,0,0-1.934,3.328A2.779,2.779,0,0,0,373.832,112.274Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74255",
    "data-name": "Path 74255",
    d: "M362.742,115.394a3.214,3.214,0,0,0,2.386-3.89,3.259,3.259,0,0,0-3.928-2.387,3.293,3.293,0,0,0-2.387,3.89A3.335,3.335,0,0,0,362.742,115.394Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74256",
    "data-name": "Path 74256",
    d: "M351.614,118.552a3.65,3.65,0,1,0-1.749-7.087,3.612,3.612,0,0,0-2.651,4.381A3.681,3.681,0,0,0,351.614,118.552Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74257",
    "data-name": "Path 74257",
    d: "M340.392,121.578a3.912,3.912,0,1,0-4.756-2.9A3.879,3.879,0,0,0,340.392,121.578Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74258",
    "data-name": "Path 74258",
    d: "M329.188,124.587a4.19,4.19,0,0,0,3.1-5.1,4.11,4.11,0,0,0-5.039-3.063,4.159,4.159,0,0,0-3.157,5A4.216,4.216,0,0,0,329.188,124.587Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74259",
    "data-name": "Path 74259",
    d: "M317.986,127.443a4.293,4.293,0,0,0,3.214-5.282,4.347,4.347,0,0,0-5.282-3.251,4.39,4.39,0,0,0,2.068,8.533Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74260",
    "data-name": "Path 74260",
    d: "M306.764,130.319A4.342,4.342,0,0,0,310,124.906a4.393,4.393,0,0,0-5.34-3.289,4.465,4.465,0,0,0-3.308,5.376A4.512,4.512,0,0,0,306.764,130.319Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74261",
    "data-name": "Path 74261",
    d: "M295.5,132.969a4.42,4.42,0,0,0,3.289-5.356,4.437,4.437,0,1,0-8.626,2.086A4.441,4.441,0,0,0,295.5,132.969Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74262",
    "data-name": "Path 74262",
    d: "M284.226,135.6a4.257,4.257,0,0,0,3.157-5.207,4.274,4.274,0,1,0-8.307,2.011A4.289,4.289,0,0,0,284.226,135.6Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74263",
    "data-name": "Path 74263",
    d: "M272.966,138.045a3.994,3.994,0,1,0-1.878-7.763,4,4,0,1,0,1.878,7.763Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74264",
    "data-name": "Path 74264",
    d: "M261.633,140.565a3.786,3.786,0,0,0,2.762-4.551,3.784,3.784,0,1,0-7.349,1.806A3.938,3.938,0,0,0,261.633,140.565Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74265",
    "data-name": "Path 74265",
    d: "M250.223,142.819a3.246,3.246,0,0,0,2.575-3.985,3.41,3.41,0,0,0-4.117-2.462,3.282,3.282,0,0,0-2.443,4A3.1,3.1,0,0,0,250.223,142.819Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74266",
    "data-name": "Path 74266",
    d: "M238.943,145.207a2.959,2.959,0,0,0,2.135-3.553,2.918,2.918,0,0,0-3.544-2.181,3.01,3.01,0,0,0-2.181,3.609A2.964,2.964,0,0,0,238.943,145.207Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74267",
    "data-name": "Path 74267",
    d: "M227.552,147.594a2.6,2.6,0,0,0,1.937-3.1,2.549,2.549,0,1,0-1.937,3.1Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74268",
    "data-name": "Path 74268",
    d: "M216.219,149.775a2.078,2.078,0,0,0,1.559-2.445,2.065,2.065,0,1,0-1.559,2.445Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74269",
    "data-name": "Path 74269",
    d: "M204.884,152.106a1.626,1.626,0,0,0,1.166-1.937,1.6,1.6,0,1,0-1.166,1.937Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74270",
    "data-name": "Path 74270",
    d: "M194.32,152.989a1.187,1.187,0,0,0-1.278-.7,1.054,1.054,0,1,0,1.278.7Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74271",
    "data-name": "Path 74271",
    d: "M182.535,155.9a.56.56,0,0,0-.639-.411.669.669,0,0,0-.453.656.5.5,0,0,0,.7.339A.456.456,0,0,0,182.535,155.9Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74272",
    "data-name": "Path 74272",
    d: "M170.749,158.741v.055h0C170.8,158.8,170.8,158.8,170.749,158.741Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74273",
    "data-name": "Path 74273",
    d: "M426.765,84.587l-.058-.058c-.056,0,0,.133,0,.133v-.075Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74274",
    "data-name": "Path 74274",
    d: "M416.013,87.238a.59.59,0,0,0-.639-.4.55.55,0,0,0-.453.639.57.57,0,0,0,.7.4A.581.581,0,0,0,416.013,87.238Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74275",
    "data-name": "Path 74275",
    d: "M405.186,89.886a1.031,1.031,0,0,0-1.2-.789,1.07,1.07,0,0,0-.714,1.241.945.945,0,0,0,1.164.695A.931.931,0,0,0,405.186,89.886Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74276",
    "data-name": "Path 74276",
    d: "M393.342,94.248a1.552,1.552,0,0,0,1.092-1.8,1.6,1.6,0,0,0-1.806-1.091,1.491,1.491,0,1,0,.714,2.9Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74277",
    "data-name": "Path 74277",
    d: "M382.14,97.481a1.967,1.967,0,0,0,1.542-2.386,1.907,1.907,0,0,0-2.445-1.355,1.835,1.835,0,0,0-1.428,2.313A1.971,1.971,0,0,0,382.14,97.481Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74278",
    "data-name": "Path 74278",
    d: "M370.993,100.563a2.386,2.386,0,0,0,1.861-2.818,2.415,2.415,0,0,0-2.95-1.692,2.32,2.32,0,0,0,1.089,4.51Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74279",
    "data-name": "Path 74279",
    d: "M359.847,103.666a2.717,2.717,0,1,0-3.271-1.936A2.6,2.6,0,0,0,359.847,103.666Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74280",
    "data-name": "Path 74280",
    d: "M348.775,106.748a3.08,3.08,0,0,0-1.484-5.977,3.08,3.08,0,1,0,1.484,5.977Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74281",
    "data-name": "Path 74281",
    d: "M337.553,109.85a3.459,3.459,0,1,0-4.117-2.539A3.409,3.409,0,0,0,337.553,109.85Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74282",
    "data-name": "Path 74282",
    d: "M326.351,112.726a3.6,3.6,0,1,0-1.73-6.993,3.6,3.6,0,1,0,1.73,6.993Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74283",
    "data-name": "Path 74283",
    d: "M315.147,115.638a3.757,3.757,0,0,0-1.8-7.293,3.756,3.756,0,1,0,1.8,7.293Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74284",
    "data-name": "Path 74284",
    d: "M303.869,118.422a3.831,3.831,0,0,0,2.839-4.587,3.792,3.792,0,0,0-4.644-2.82,3.812,3.812,0,0,0,1.8,7.407Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74285",
    "data-name": "Path 74285",
    d: "M292.609,121.164a3.778,3.778,0,0,0,2.839-4.623,3.816,3.816,0,1,0-7.416,1.805A3.724,3.724,0,0,0,292.609,121.164Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74286",
    "data-name": "Path 74286",
    d: "M281.332,123.759a3.717,3.717,0,0,0,2.771-4.437,3.712,3.712,0,1,0-7.218,1.731A3.731,3.731,0,0,0,281.332,123.759Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74287",
    "data-name": "Path 74287",
    d: "M270.062,126.334a3.463,3.463,0,0,0,2.575-4.267,3.564,3.564,0,0,0-4.182-2.575,3.678,3.678,0,0,0-2.641,4.267A3.557,3.557,0,0,0,270.062,126.334Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74288",
    "data-name": "Path 74288",
    d: "M258.784,128.8a3.232,3.232,0,1,0-3.853-2.406A3.176,3.176,0,0,0,258.784,128.8Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74289",
    "data-name": "Path 74289",
    d: "M247.393,131.166a2.882,2.882,0,1,0-1.353-5.6,2.882,2.882,0,0,0,1.353,5.6Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74290",
    "data-name": "Path 74290",
    d: "M236.116,133.666a2.672,2.672,0,0,0,1.869-3.159,2.522,2.522,0,1,0-4.887,1.242A2.548,2.548,0,0,0,236.116,133.666Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74291",
    "data-name": "Path 74291",
    d: "M224.715,135.92a2.146,2.146,0,0,0,1.617-2.574,2.266,2.266,0,0,0-2.651-1.6,2.172,2.172,0,0,0-1.541,2.631A2.127,2.127,0,0,0,224.715,135.92Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74292",
    "data-name": "Path 74292",
    d: "M213.455,138.176a1.644,1.644,0,0,0,1.2-1.992,1.729,1.729,0,0,0-2.048-1.223,1.769,1.769,0,0,0-1.3,2.07A1.7,1.7,0,0,0,213.455,138.176Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74293",
    "data-name": "Path 74293",
    d: "M202.947,139.079a1.16,1.16,0,0,0-1.409-.9,1.068,1.068,0,0,0-.9,1.447,1.2,1.2,0,0,0,1.41.9A1.3,1.3,0,0,0,202.947,139.079Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74294",
    "data-name": "Path 74294",
    d: "M191.237,141.918a.763.763,0,0,0-.9-.584.744.744,0,0,0-.528.9.676.676,0,0,0,.9.506A.656.656,0,0,0,191.237,141.918Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74295",
    "data-name": "Path 74295",
    d: "M179.509,144.755c0-.131-.133-.262-.264-.206a.364.364,0,0,0-.264.339c0,.111.208.186.4.186C179.509,145,179.509,144.888,179.509,144.755Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74296",
    "data-name": "Path 74296",
    d: "M412.929,76.091a.3.3,0,0,0-.264-.264.394.394,0,0,0-.186.32c.056.225.186.225.3.131C412.929,76.278,412.985,76.241,412.929,76.091Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74297",
    "data-name": "Path 74297",
    d: "M402.1,78.664a.628.628,0,0,0-.77-.45.583.583,0,0,0-.508.77.768.768,0,0,0,.828.583A.788.788,0,0,0,402.1,78.664Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74298",
    "data-name": "Path 74298",
    d: "M391.275,81.315a1.064,1.064,0,0,0-2.067.508,1.066,1.066,0,1,0,2.067-.508Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74299",
    "data-name": "Path 74299",
    d: "M379.358,85.882a1.513,1.513,0,0,0,1.09-1.934,1.519,1.519,0,1,0-2.951.714A1.632,1.632,0,0,0,379.358,85.882Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74300",
    "data-name": "Path 74300",
    d: "M368.154,88.835a1.829,1.829,0,0,0,1.43-2.219,1.893,1.893,0,0,0-3.686.864A1.891,1.891,0,0,0,368.154,88.835Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74301",
    "data-name": "Path 74301",
    d: "M357.027,92.067a2.348,2.348,0,0,0,1.653-2.837,2.286,2.286,0,0,0-4.435,1.108A2.4,2.4,0,0,0,357.027,92.067Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74302",
    "data-name": "Path 74302",
    d: "M345.88,95.037a2.619,2.619,0,1,0-3.158-1.936A2.612,2.612,0,0,0,345.88,95.037Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74303",
    "data-name": "Path 74303",
    d: "M334.658,97.97a2.773,2.773,0,0,0,2.068-3.383,2.827,2.827,0,0,0-5.488,1.353A2.776,2.776,0,0,0,334.658,97.97Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74304",
    "data-name": "Path 74304",
    d: "M323.456,100.958a3.118,3.118,0,0,0,2.256-3.665A3.044,3.044,0,1,0,319.79,98.7,3.157,3.157,0,0,0,323.456,100.958Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74305",
    "data-name": "Path 74305",
    d: "M312.252,103.722a3.04,3.04,0,0,0,2.313-3.74,3.074,3.074,0,0,0-3.8-2.314,3.158,3.158,0,0,0-2.312,3.8A3.058,3.058,0,0,0,312.252,103.722Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74306",
    "data-name": "Path 74306",
    d: "M300.974,106.636a3.243,3.243,0,0,0-1.466-6.317,3.242,3.242,0,0,0,1.466,6.317Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74307",
    "data-name": "Path 74307",
    d: "M289.772,109.248a3.179,3.179,0,0,0-1.552-6.165,3.252,3.252,0,0,0-2.311,3.872A3.144,3.144,0,0,0,289.772,109.248Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74308",
    "data-name": "Path 74308",
    d: "M278.437,111.918a3.089,3.089,0,0,0,2.321-3.742,3.046,3.046,0,0,0-3.73-2.254,3.08,3.08,0,1,0,1.409,6Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74309",
    "data-name": "Path 74309",
    d: "M267.234,114.493a2.844,2.844,0,0,0,2.048-3.478,2.9,2.9,0,0,0-3.468-2.218,3.07,3.07,0,0,0-2.189,3.571A2.994,2.994,0,0,0,267.234,114.493Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74310",
    "data-name": "Path 74310",
    d: "M255.889,117.068a2.78,2.78,0,0,0,1.992-3.308,2.56,2.56,0,0,0-3.214-1.937,2.719,2.719,0,0,0-2.058,3.251A2.818,2.818,0,0,0,255.889,117.068Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74311",
    "data-name": "Path 74311",
    d: "M244.554,119.492a2.482,2.482,0,0,0,1.806-2.951,2.389,2.389,0,0,0-2.9-1.728,2.4,2.4,0,1,0,1.1,4.679Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74312",
    "data-name": "Path 74312",
    d: "M233.286,121.88a2.075,2.075,0,0,0,1.477-2.519,2.111,2.111,0,0,0-2.445-1.542,2.173,2.173,0,0,0-1.551,2.539A2.028,2.028,0,0,0,233.286,121.88Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74313",
    "data-name": "Path 74313",
    d: "M221.876,124.286a1.789,1.789,0,0,0,1.3-2.086,1.735,1.735,0,0,0-2.048-1.278,1.841,1.841,0,0,0-1.316,2.048A1.758,1.758,0,0,0,221.876,124.286Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74314",
    "data-name": "Path 74314",
    d: "M211.519,125.037a1.24,1.24,0,0,0-1.485-.9A1.33,1.33,0,0,0,209,125.676a1.355,1.355,0,0,0,1.617.9A1.278,1.278,0,0,0,211.519,125.037Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74315",
    "data-name": "Path 74315",
    d: "M199.846,127.895a.855.855,0,1,0-1.672.357,1.058,1.058,0,0,0,1.108.714A.9.9,0,0,0,199.846,127.895Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74316",
    "data-name": "Path 74316",
    d: "M188.136,130.733a.282.282,0,0,0-.4-.281c-.263,0-.375.186-.375.45a.423.423,0,0,0,.525.189A.267.267,0,0,0,188.136,130.733Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74317",
    "data-name": "Path 74317",
    d: "M399.02,67.518c0-.131-.207-.169-.338-.169-.114,0-.189.169-.189.321s.189.242.32.242A.284.284,0,0,0,399.02,67.518Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74318",
    "data-name": "Path 74318",
    d: "M388.193,70.168a.748.748,0,0,0-.847-.525.735.735,0,0,0-.583.864.8.8,0,0,0,.9.489A.641.641,0,0,0,388.193,70.168Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74319",
    "data-name": "Path 74319",
    d: "M377.289,72.8a1.135,1.135,0,0,0-1.333-.771,1.08,1.08,0,0,0-.715,1.222,1.049,1.049,0,0,0,2.048-.451Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74320",
    "data-name": "Path 74320",
    d: "M365.317,77.256a1.6,1.6,0,0,0,1.109-1.787,1.476,1.476,0,0,0-1.806-1.033,1.331,1.331,0,0,0-1.033,1.655A1.6,1.6,0,0,0,365.317,77.256Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74321",
    "data-name": "Path 74321",
    d: "M354.17,80.3a1.8,1.8,0,0,0,1.3-2.218,1.823,1.823,0,0,0-2.125-1.353,1.89,1.89,0,0,0-1.278,2.217A1.751,1.751,0,0,0,354.17,80.3Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74322",
    "data-name": "Path 74322",
    d: "M342.966,83.232a2.016,2.016,0,0,0,1.561-2.481,2.065,2.065,0,0,0-4,1.016A2,2,0,0,0,342.966,83.232Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74323",
    "data-name": "Path 74323",
    d: "M331.839,86.277a2.366,2.366,0,0,0,1.655-2.818A2.229,2.229,0,0,0,330.73,81.9a2.171,2.171,0,0,0-1.673,2.631A2.372,2.372,0,0,0,331.839,86.277Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74324",
    "data-name": "Path 74324",
    d: "M320.561,89.1a2.419,2.419,0,0,0,1.879-2.931,2.489,2.489,0,0,0-4.849,1.127A2.411,2.411,0,0,0,320.561,89.1Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74325",
    "data-name": "Path 74325",
    d: "M309.357,91.936a2.53,2.53,0,0,0,1.919-3.1,2.586,2.586,0,0,0-5.02,1.24A2.517,2.517,0,0,0,309.357,91.936Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74326",
    "data-name": "Path 74326",
    d: "M298.155,94.775a2.691,2.691,0,0,0,1.916-3.233,2.726,2.726,0,0,0-3.214-1.918A2.69,2.69,0,0,0,295,92.839,2.6,2.6,0,0,0,298.155,94.775Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74327",
    "data-name": "Path 74327",
    d: "M286.867,97.406a2.619,2.619,0,0,0,1.946-3.083,2.62,2.62,0,0,0-5.1,1.222A2.538,2.538,0,0,0,286.867,97.406Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74328",
    "data-name": "Path 74328",
    d: "M275.6,100.188a2.625,2.625,0,0,0,1.881-3.12,2.534,2.534,0,0,0-3.035-1.806,2.531,2.531,0,0,0,1.154,4.926Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74329",
    "data-name": "Path 74329",
    d: "M264.339,102.632A2.25,2.25,0,0,0,266,99.868a2.369,2.369,0,0,0-2.771-1.747,2.23,2.23,0,0,0-1.675,2.837A2.288,2.288,0,0,0,264.339,102.632Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74330",
    "data-name": "Path 74330",
    d: "M253.06,105.283a2.163,2.163,0,0,0,1.542-2.651,2.046,2.046,0,0,0-2.576-1.505,2.018,2.018,0,0,0-1.54,2.539A2.248,2.248,0,0,0,253.06,105.283Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74331",
    "data-name": "Path 74331",
    d: "M241.726,107.65a1.824,1.824,0,1,0-.9-3.534,1.824,1.824,0,1,0,.9,3.534Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74332",
    "data-name": "Path 74332",
    d: "M230.391,110.151a1.537,1.537,0,0,0,1.147-1.937,1.558,1.558,0,0,0-3.025.734A1.571,1.571,0,0,0,230.391,110.151Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74333",
    "data-name": "Path 74333",
    d: "M219.959,111.053a1.239,1.239,0,0,0-1.5-.9,1.388,1.388,0,0,0-.9,1.5,1.443,1.443,0,0,0,1.5.958A1.354,1.354,0,0,0,219.959,111.053Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74334",
    "data-name": "Path 74334",
    d: "M208.362,113.91a.89.89,0,0,0-1.034-.734.867.867,0,0,0-.639,1.109.908.908,0,0,0,1.09.658A.809.809,0,0,0,208.362,113.91Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74335",
    "data-name": "Path 74335",
    d: "M196.632,116.749c0-.283-.189-.32-.4-.32a.443.443,0,0,0-.375.487c.131.283.32.414.525.32A.324.324,0,0,0,196.632,116.749Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74336",
    "data-name": "Path 74336",
    d: "M385.091,59.022a.406.406,0,0,0-.395-.206c-.112,0-.189.206-.189.206.077.244.189.338.339.338C384.96,59.36,385.091,59.154,385.091,59.022Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74337",
    "data-name": "Path 74337",
    d: "M374.152,61.655a.763.763,0,0,0-.772-.452.638.638,0,0,0-.45.771.6.6,0,0,0,.714.451A.7.7,0,0,0,374.152,61.655Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74338",
    "data-name": "Path 74338",
    d: "M363.192,64.361a.927.927,0,0,0-1.165-.714.916.916,0,0,0-.7,1.165,1.055,1.055,0,0,0,1.147.733A.973.973,0,0,0,363.192,64.361Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74339",
    "data-name": "Path 74339",
    d: "M352.253,67.012a1.316,1.316,0,0,0-1.542-.978,1.361,1.361,0,0,0-.9,1.559,1.316,1.316,0,0,0,1.541.9A1.27,1.27,0,0,0,352.253,67.012Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74340",
    "data-name": "Path 74340",
    d: "M340.148,71.579a1.616,1.616,0,0,0,1.089-1.936,1.478,1.478,0,0,0-1.8-1.072,1.432,1.432,0,0,0-1.089,1.842A1.547,1.547,0,0,0,340.148,71.579Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74341",
    "data-name": "Path 74341",
    d: "M328.944,74.436a1.791,1.791,0,0,0,1.278-2.087,1.746,1.746,0,0,0-2.067-1.278,1.688,1.688,0,0,0-1.279,2.142A1.794,1.794,0,0,0,328.944,74.436Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74342",
    "data-name": "Path 74342",
    d: "M317.722,77.386a1.9,1.9,0,0,0,1.353-2.331,1.824,1.824,0,1,0-3.534.9A1.93,1.93,0,0,0,317.722,77.386Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74343",
    "data-name": "Path 74343",
    d: "M306.52,80.15a1.98,1.98,0,0,0,1.409-2.386,1.96,1.96,0,0,0-3.8.975A2.112,2.112,0,0,0,306.52,80.15Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74344",
    "data-name": "Path 74344",
    d: "M295.259,82.913a1.988,1.988,0,1,0-.977-3.854,2,2,0,0,0-1.429,2.389A1.945,1.945,0,0,0,295.259,82.913Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74345",
    "data-name": "Path 74345",
    d: "M283.972,85.621a1.926,1.926,0,0,0,1.542-2.389,2.05,2.05,0,0,0-2.444-1.465,2.012,2.012,0,0,0-1.409,2.443A1.891,1.891,0,0,0,283.972,85.621Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74346",
    "data-name": "Path 74346",
    d: "M272.77,88.271a1.785,1.785,0,0,0,1.353-2.256,1.886,1.886,0,0,0-2.256-1.428,1.987,1.987,0,0,0-1.418,2.331A1.893,1.893,0,0,0,272.77,88.271Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74347",
    "data-name": "Path 74347",
    d: "M261.49,90.9a1.7,1.7,0,0,0,1.232-2.125,1.762,1.762,0,0,0-2.067-1.353,1.789,1.789,0,0,0,.835,3.478Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74348",
    "data-name": "Path 74348",
    d: "M250.157,93.42a1.585,1.585,0,0,0,1.23-1.878,1.686,1.686,0,0,0-1.936-1.279,1.664,1.664,0,0,0-1.155,2.068A1.524,1.524,0,0,0,250.157,93.42Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74349",
    "data-name": "Path 74349",
    d: "M239.846,94.361a1.386,1.386,0,0,0-1.6-1.072,1.325,1.325,0,0,0-.968,1.673,1.318,1.318,0,1,0,2.566-.6Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74350",
    "data-name": "Path 74350",
    d: "M228.324,97.162a1.006,1.006,0,0,0-1.3-.772,1.05,1.05,0,0,0-.77,1.278,1.066,1.066,0,0,0,2.067-.506Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74351",
    "data-name": "Path 74351",
    d: "M216.725,99.924a.647.647,0,0,0-.9-.506.727.727,0,0,0-.508.9.748.748,0,0,0,.9.508A.685.685,0,0,0,216.725,99.924Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74352",
    "data-name": "Path 74352",
    d: "M205.2,102.763a.357.357,0,0,0-.45-.283c-.264.094-.4.208-.32.452a.577.577,0,0,0,.506.339A.749.749,0,0,0,205.2,102.763Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74353",
    "data-name": "Path 74353",
    d: "M370.937,50.526a.736.736,0,0,0-.208-.056c-.055,0-.055.056-.055.113,0,0,.055.112.131.112C370.862,50.695,370.937,50.583,370.937,50.526Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74354",
    "data-name": "Path 74354",
    d: "M359.977,53.234c-.13-.283-.319-.4-.581-.322-.188,0-.319.264-.263.489a.37.37,0,0,0,.45.283C359.847,53.684,359.977,53.4,359.977,53.234Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74355",
    "data-name": "Path 74355",
    d: "M348.964,55.865a.689.689,0,0,0-.847-.527.7.7,0,0,0-.506.9.811.811,0,0,0,.9.526A.83.83,0,0,0,348.964,55.865Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74356",
    "data-name": "Path 74356",
    d: "M337.948,58.571a.957.957,0,1,0-.639,1.147A.943.943,0,0,0,337.948,58.571Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74357",
    "data-name": "Path 74357",
    d: "M326.876,61.278a1.089,1.089,0,0,0-1.278-.826,1.134,1.134,0,0,0-.9,1.353,1.174,1.174,0,0,0,1.391.751A1.074,1.074,0,0,0,326.876,61.278Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74358",
    "data-name": "Path 74358",
    d: "M315.786,63.984a1.285,1.285,0,0,0-1.54-.976,1.3,1.3,0,0,0,.581,2.537A1.348,1.348,0,0,0,315.786,63.984Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74359",
    "data-name": "Path 74359",
    d: "M303.681,68.365a1.505,1.505,0,0,0,.977-1.673,1.547,1.547,0,0,0-1.691-1.109,1.486,1.486,0,0,0-1.015,1.766A1.518,1.518,0,0,0,303.681,68.365Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74360",
    "data-name": "Path 74360",
    d: "M292.347,71.071a1.283,1.283,0,0,0,1.034-1.673,1.311,1.311,0,0,0-1.673-1.033,1.365,1.365,0,0,0-1.035,1.692A1.311,1.311,0,0,0,292.347,71.071Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74361",
    "data-name": "Path 74361",
    d: "M281.143,73.835a1.382,1.382,0,0,0,1.024-1.75,1.438,1.438,0,0,0-1.673-1.014,1.338,1.338,0,0,0-1.024,1.73A1.3,1.3,0,0,0,281.143,73.835Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74362",
    "data-name": "Path 74362",
    d: "M270.834,74.888a1.3,1.3,0,0,0-1.608-1,1.33,1.33,0,0,0,.584,2.6A1.324,1.324,0,0,0,270.834,74.888Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74363",
    "data-name": "Path 74363",
    d: "M259.5,77.631a1.289,1.289,0,0,0-1.409-.9,1.165,1.165,0,0,0-.9,1.484,1.08,1.08,0,0,0,1.409.9A1.227,1.227,0,0,0,259.5,77.631Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74364",
    "data-name": "Path 74364",
    d: "M248.042,80.414a.935.935,0,0,0-1.164-.714,1.032,1.032,0,0,0-.838,1.22,1,1,0,0,0,1.223.734A.943.943,0,0,0,248.042,80.414Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74365",
    "data-name": "Path 74365",
    d: "M236.566,83.176a.8.8,0,0,0-.968-.583.833.833,0,0,0,.394,1.617A.817.817,0,0,0,236.566,83.176Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74366",
    "data-name": "Path 74366",
    d: "M225.11,86.015a.579.579,0,0,0-.639-.452c-.339.058-.451.377-.395.714a.553.553,0,0,0,.639.452A.63.63,0,0,0,225.11,86.015Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74367",
    "data-name": "Path 74367",
    d: "M213.568,88.835c-.055-.113-.113-.244-.3-.244a.23.23,0,0,0-.152.319c0,.131.152.32.264.262C213.568,89.1,213.643,88.985,213.568,88.835Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74368",
    "data-name": "Path 74368",
    d: "M345.749,44.718c-.075-.113-.133-.057-.188-.057-.131,0-.264.057-.206.188.075.075.131.206.261.206A.306.306,0,0,0,345.749,44.718Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74369",
    "data-name": "Path 74369",
    d: "M334.658,47.425c-.055-.245-.188-.32-.45-.32-.264.114-.377.264-.264.526a.306.306,0,0,0,.451.244A.33.33,0,0,0,334.658,47.425Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74370",
    "data-name": "Path 74370",
    d: "M323.587,50.131a.65.65,0,0,0-.658-.45.677.677,0,0,0-.451.695c.15.319.414.544.714.452A.564.564,0,0,0,323.587,50.131Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74371",
    "data-name": "Path 74371",
    d: "M312.515,52.837a.754.754,0,0,0-.845-.564.774.774,0,0,0-.583.9.665.665,0,0,0,.845.508A.844.844,0,0,0,312.515,52.837Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74372",
    "data-name": "Path 74372",
    d: "M301.35,55.546a.742.742,0,0,0-.94-.584.8.8,0,0,0-.6.978.75.75,0,0,0,.976.581A.729.729,0,0,0,301.35,55.546Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74373",
    "data-name": "Path 74373",
    d: "M290.091,58.252a.752.752,0,0,0-.968-.583.824.824,0,1,0,.4,1.6A.776.776,0,0,0,290.091,58.252Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74374",
    "data-name": "Path 74374",
    d: "M278.812,61.033c-.121-.45-.506-.733-.884-.581a.758.758,0,0,0-.656.939.861.861,0,0,0,1.034.583A.7.7,0,0,0,278.812,61.033Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74375",
    "data-name": "Path 74375",
    d: "M267.554,63.739a.789.789,0,0,0-.9-.544.861.861,0,0,0-.583.9.753.753,0,0,0,.9.584A.846.846,0,0,0,267.554,63.739Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74376",
    "data-name": "Path 74376",
    d: "M256.143,66.559a.636.636,0,0,0-.7-.45.625.625,0,0,0-.452.695c.067.414.394.545.781.452A.516.516,0,0,0,256.143,66.559Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74377",
    "data-name": "Path 74377",
    d: "M244.743,69.267a.44.44,0,0,0-.508-.319.522.522,0,0,0-.328.564.406.406,0,0,0,.526.337A.469.469,0,0,0,244.743,69.267Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74378",
    "data-name": "Path 74378",
    d: "M233.352,72.085c0-.111-.2-.225-.4-.186-.121,0-.188.186-.121.319,0,.131.186.264.319.264A.365.365,0,0,0,233.352,72.085Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74379",
    "data-name": "Path 74379",
    d: "M221.876,74.888h0Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74380",
    "data-name": "Path 74380",
    d: "M309.226,41.691c-.075-.056-.131-.112-.206-.112-.058.056-.114.112-.058.187a.267.267,0,0,0,.133.038A.124.124,0,0,0,309.226,41.691Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74381",
    "data-name": "Path 74381",
    d: "M298,44.4c0-.058-.113-.133-.244-.058-.131.058-.131.058-.131.17,0,.15.131.15.262.15C297.968,44.661,298,44.511,298,44.4Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74382",
    "data-name": "Path 74382",
    d: "M286.811,47.1a.46.46,0,0,0-.254-.131c-.14.075-.263.206-.2.245,0,.15.2.281.264.281C286.744,47.5,286.811,47.219,286.811,47.1Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74383",
    "data-name": "Path 74383",
    d: "M275.532,49.887s-.121-.206-.254-.131c-.131,0-.2.169-.2.169.065.15.2.32.329.281C275.532,50.206,275.6,50.019,275.532,49.887Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74384",
    "data-name": "Path 74384",
    d: "M264.264,52.631c0-.038-.133-.13-.254-.13,0,0-.123.13-.123.225a.55.55,0,0,0,.189.186C264.264,52.837,264.264,52.782,264.264,52.631Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74385",
    "data-name": "Path 74385",
    d: "M252.929,55.338H252.8v.075c0,.075,0,.075.066.075C252.864,55.488,252.929,55.488,252.929,55.338Z",
    fill: "#aec2fd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_141975",
    "data-name": "Group 141975",
    transform: "translate(828.354 88.421)",
    opacity: 0.226
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141973-2",
    "data-name": "Group 141973"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73896-2",
    "data-name": "Path 73896",
    d: "M399.79,317.5c0,.133.131.133.245.133.075,0,.131-.133.131-.264-.056,0-.131-.15-.245-.15C399.79,317.313,399.715,317.424,399.79,317.5Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73897-2",
    "data-name": "Path 73897",
    d: "M388.436,320.263a.223.223,0,0,0,.32.206c.207,0,.263-.131.207-.337a.25.25,0,0,0-.319-.207A.234.234,0,0,0,388.436,320.263Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73898-2",
    "data-name": "Path 73898",
    d: "M376.989,323.045a.466.466,0,0,0,.564.319.55.55,0,0,0,.339-.581.4.4,0,0,0-.526-.283A.423.423,0,0,0,376.989,323.045Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73899-2",
    "data-name": "Path 73899",
    d: "M365.636,325.79a.711.711,0,0,0,.715.45.631.631,0,0,0,.394-.695.686.686,0,0,0-.714-.45C365.767,325.17,365.636,325.545,365.636,325.79Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73900-2",
    "data-name": "Path 73900",
    d: "M354.357,328.5a.63.63,0,0,0,.714.452.494.494,0,0,0,.4-.7.562.562,0,0,0-.659-.45A.783.783,0,0,0,354.357,328.5Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73901-2",
    "data-name": "Path 73901",
    d: "M343.1,331.269a.6.6,0,0,0,.77.376.533.533,0,0,0,.394-.6.6.6,0,0,0-.714-.452C343.23,330.63,343.1,331.044,343.1,331.269Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73902-2",
    "data-name": "Path 73902",
    d: "M331.952,333.976a.444.444,0,0,0,.581.375.435.435,0,0,0,.4-.6.446.446,0,0,0-.583-.339A.5.5,0,0,0,331.952,333.976Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73903-2",
    "data-name": "Path 73903",
    d: "M320.825,336.682a.353.353,0,0,0,.506.264c.208,0,.32-.189.264-.451a.286.286,0,0,0-.395-.188A.353.353,0,0,0,320.825,336.682Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73904-2",
    "data-name": "Path 73904",
    d: "M309.676,339.39a.407.407,0,0,0,.322.225c.131-.113.262-.225.187-.338-.056-.114-.131-.114-.264-.114A.264.264,0,0,0,309.676,339.39Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73905-2",
    "data-name": "Path 73905",
    d: "M298.643,342.1h.075c.075,0,.075,0,.075-.075l-.15-.038Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73906-2",
    "data-name": "Path 73906",
    d: "M419.489,300.752a.27.27,0,0,0,.264.263.366.366,0,0,0,.188-.394.249.249,0,0,0-.319-.131C419.489,300.49,419.433,300.621,419.489,300.752Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73907-2",
    "data-name": "Path 73907",
    d: "M408.042,303.61a.41.41,0,0,0,.564.356.682.682,0,0,0,.339-.639c-.15-.264-.339-.395-.6-.32A.41.41,0,0,0,408.042,303.61Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73908-2",
    "data-name": "Path 73908",
    d: "M396.5,306.353c.131.452.45.716.9.583a.853.853,0,0,0,.581-.9.71.71,0,0,0-.9-.506A.669.669,0,0,0,396.5,306.353Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73909-2",
    "data-name": "Path 73909",
    d: "M385.035,309.136a.909.909,0,0,0,1.164.7.838.838,0,0,0,.639-1.09.923.923,0,1,0-1.8.395Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73910-2",
    "data-name": "Path 73910",
    d: "M373.7,311.9a1.122,1.122,0,0,0,1.3.9,1.059,1.059,0,0,0,.695-1.353,1.023,1.023,0,0,0-1.993.45Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73911-2",
    "data-name": "Path 73911",
    d: "M362.366,314.662a1.1,1.1,0,0,0,1.353.845,1.08,1.08,0,0,0,.826-1.353,1.237,1.237,0,0,0-1.353-.9A1.255,1.255,0,0,0,362.366,314.662Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73912-2",
    "data-name": "Path 73912",
    d: "M351.087,317.368a1.16,1.16,0,1,0,2.256-.508,1.11,1.11,0,0,0-1.428-.845A1.174,1.174,0,0,0,351.087,317.368Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73913-2",
    "data-name": "Path 73913",
    d: "M339.885,320.132a1.126,1.126,0,1,0,2.18-.564,1.2,1.2,0,0,0-1.41-.846A1.337,1.337,0,0,0,339.885,320.132Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73914-2",
    "data-name": "Path 73914",
    d: "M328.682,322.839a1.057,1.057,0,1,0,2.048-.508,1.123,1.123,0,0,0-1.3-.734A1.085,1.085,0,0,0,328.682,322.839Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73915-2",
    "data-name": "Path 73915",
    d: "M317.478,325.545a1.067,1.067,0,0,0,1.278.789.92.92,0,0,0,.639-1.239.938.938,0,0,0-1.145-.7A1.014,1.014,0,0,0,317.478,325.545Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73916-2",
    "data-name": "Path 73916",
    d: "M306.445,328.251a.864.864,0,0,0,.977.659.892.892,0,0,0,.582-1.034.816.816,0,0,0-.976-.583A.883.883,0,0,0,306.445,328.251Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73917-2",
    "data-name": "Path 73917",
    d: "M295.373,330.969a.579.579,0,0,0,.714.451.664.664,0,0,0,.526-.79.765.765,0,0,0-.79-.338A.59.59,0,0,0,295.373,330.969Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73918-2",
    "data-name": "Path 73918",
    d: "M284.367,333.6c.123.262.244.376.45.3.189-.039.312-.15.189-.451a.2.2,0,0,0-.329-.152C284.49,333.337,284.367,333.412,284.367,333.6Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73919-2",
    "data-name": "Path 73919",
    d: "M273.419,336.307h.055c.066,0,.066,0,.066-.075,0,0,0,.075-.066.075Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73920-2",
    "data-name": "Path 73920",
    d: "M439.395,284.059l.056.076c.058,0,.058-.131.058-.131h-.058A.055.055,0,0,0,439.395,284.059Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73921-2",
    "data-name": "Path 73921",
    d: "M427.873,286.843a.339.339,0,0,0,.432.319c.207-.075.394-.319.338-.452a.526.526,0,0,0-.525-.395A.351.351,0,0,0,427.873,286.843Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73922-2",
    "data-name": "Path 73922",
    d: "M416.2,289.663a.752.752,0,0,0,.9.544.719.719,0,0,0,.584-.864.8.8,0,0,0-.9-.583A.862.862,0,0,0,416.2,289.663Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73923-2",
    "data-name": "Path 73923",
    d: "M404.733,292.5a1.082,1.082,0,0,0,1.242.772,1.1,1.1,0,0,0,.75-1.261,1.026,1.026,0,1,0-1.992.489Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73924-2",
    "data-name": "Path 73924",
    d: "M393.211,295.281a1.4,1.4,0,0,0,1.617.961,1.308,1.308,0,0,0,.9-1.542,1.206,1.206,0,0,0-1.486-.978A1.333,1.333,0,0,0,393.211,295.281Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73925-2",
    "data-name": "Path 73925",
    d: "M382.892,296.242a1.432,1.432,0,0,0-1.128,1.8,1.509,1.509,0,0,0,2.932-.714A1.422,1.422,0,0,0,382.892,296.242Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73926-2",
    "data-name": "Path 73926",
    d: "M371.576,298.815a1.7,1.7,0,0,0-1.166,1.994,1.617,1.617,0,0,0,1.936,1.221,1.66,1.66,0,0,0,1.223-1.993A1.722,1.722,0,0,0,371.576,298.815Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73927-2",
    "data-name": "Path 73927",
    d: "M360.3,301.39a1.834,1.834,0,0,0-1.278,2.22,1.8,1.8,0,0,0,2.106,1.314,1.734,1.734,0,0,0,1.3-2.18A1.808,1.808,0,0,0,360.3,301.39Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73928-2",
    "data-name": "Path 73928",
    d: "M349.02,304.174a1.751,1.751,0,0,0-1.279,2.179,1.788,1.788,0,1,0,3.479-.826A1.827,1.827,0,0,0,349.02,304.174Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73929-2",
    "data-name": "Path 73929",
    d: "M337.817,306.936a1.682,1.682,0,0,0-1.278,2.125,1.737,1.737,0,0,0,2.123,1.353,1.778,1.778,0,0,0,1.278-2.181A1.679,1.679,0,0,0,337.817,306.936Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73930-2",
    "data-name": "Path 73930",
    d: "M326.538,309.7a1.75,1.75,0,0,0-1.2,2.1,1.674,1.674,0,0,0,2.067,1.185,1.613,1.613,0,0,0,1.28-1.992A1.85,1.85,0,0,0,326.538,309.7Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73931-2",
    "data-name": "Path 73931",
    d: "M315.41,312.537a1.591,1.591,0,1,0,1.862,1.222A1.547,1.547,0,0,0,315.41,312.537Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73932-2",
    "data-name": "Path 73932",
    d: "M304.208,315.507a1.384,1.384,0,0,0-1.053,1.673,1.491,1.491,0,0,0,1.692,1.091,1.553,1.553,0,0,0,1.014-1.748A1.407,1.407,0,0,0,304.208,315.507Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73933-2",
    "data-name": "Path 73933",
    d: "M292.159,319.888a1.161,1.161,0,0,0,1.353.826,1.174,1.174,0,0,0,.847-1.409,1.194,1.194,0,0,0-1.355-.847A1.22,1.22,0,0,0,292.159,319.888Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73934-2",
    "data-name": "Path 73934",
    d: "M281.143,322.5a1.075,1.075,0,0,0,1.091.733.943.943,0,0,0,.582-1.089.829.829,0,0,0-1.034-.658A.917.917,0,0,0,281.143,322.5Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73935-2",
    "data-name": "Path 73935",
    d: "M270.26,325.206a.482.482,0,0,0,.574.339.467.467,0,0,0,.45-.564c-.056-.395-.32-.545-.7-.395C270.325,324.642,270.185,324.85,270.26,325.206Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73936-2",
    "data-name": "Path 73936",
    d: "M259.3,327.876c0,.131.14.131.329.131,0-.092.121-.131.121-.262,0-.15-.188-.188-.254-.188A.214.214,0,0,0,259.3,327.876Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73937-2",
    "data-name": "Path 73937",
    d: "M447.836,270.17l.131-.094h.113a.4.4,0,0,0-.113-.245C447.836,269.831,447.836,270.037,447.836,270.17Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73938-2",
    "data-name": "Path 73938",
    d: "M436.237,272.988c0,.208.319.32.639.32a.579.579,0,0,0,.377-.564c-.114-.412-.377-.545-.639-.451A.513.513,0,0,0,436.237,272.988Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73939-2",
    "data-name": "Path 73939",
    d: "M424.64,275.771a.861.861,0,0,0,1.672-.414.886.886,0,0,0-1.014-.77A.949.949,0,0,0,424.64,275.771Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73940-2",
    "data-name": "Path 73940",
    d: "M413.043,278.608a1.094,1.094,0,0,0,1.428.809,1.25,1.25,0,0,0,1.014-1.39,1.29,1.29,0,0,0-1.541-.978A1.218,1.218,0,0,0,413.043,278.608Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73941-2",
    "data-name": "Path 73941",
    d: "M402.629,279.417a1.6,1.6,0,1,0,.751,3.12,1.678,1.678,0,0,0,1.167-1.9A1.741,1.741,0,0,0,402.629,279.417Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73942-2",
    "data-name": "Path 73942",
    d: "M391.275,281.881A1.969,1.969,0,0,0,390,284.212a1.86,1.86,0,0,0,2.181,1.353,1.8,1.8,0,0,0,1.353-2.22A1.94,1.94,0,0,0,391.275,281.881Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73943-2",
    "data-name": "Path 73943",
    d: "M380.073,284.512a2.015,2.015,0,1,0,.9,3.928,2.071,2.071,0,0,0,1.54-2.386A2.041,2.041,0,0,0,380.073,284.512Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73944-2",
    "data-name": "Path 73944",
    d: "M368.738,287.087a2.221,2.221,0,0,0-1.673,2.706,2.26,2.26,0,0,0,2.706,1.542,2.165,2.165,0,0,0,1.673-2.614A2.2,2.2,0,0,0,368.738,287.087Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73945-2",
    "data-name": "Path 73945",
    d: "M357.477,289.663a2.356,2.356,0,1,0,2.82,1.767A2.326,2.326,0,0,0,357.477,289.663Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73946-2",
    "data-name": "Path 73946",
    d: "M346.2,292.369a2.358,2.358,0,1,0,1.091,4.587,2.358,2.358,0,0,0-1.091-4.587Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73947-2",
    "data-name": "Path 73947",
    d: "M334.922,295.075a2.429,2.429,0,0,0-1.748,2.97,2.464,2.464,0,0,0,2.913,1.673,2.4,2.4,0,0,0,1.8-2.837A2.431,2.431,0,0,0,334.922,295.075Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73948-2",
    "data-name": "Path 73948",
    d: "M323.643,297.914a2.307,2.307,0,0,0-1.6,2.838,2.3,2.3,0,0,0,4.456-1.09A2.365,2.365,0,0,0,323.643,297.914Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73949-2",
    "data-name": "Path 73949",
    d: "M312.571,300.752a2.2,2.2,0,0,0-1.615,2.708,2.1,2.1,0,1,0,1.615-2.708Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73950-2",
    "data-name": "Path 73950",
    d: "M301.35,303.779a1.886,1.886,0,0,0-1.39,2.312,1.878,1.878,0,0,0,3.645-.9A1.822,1.822,0,0,0,301.35,303.779Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73951-2",
    "data-name": "Path 73951",
    d: "M290.167,306.8a1.654,1.654,0,0,0-1.3,1.992,1.7,1.7,0,1,0,3.29-.828A1.556,1.556,0,0,0,290.167,306.8Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73952-2",
    "data-name": "Path 73952",
    d: "M278.954,309.775a1.278,1.278,0,0,0-.968,1.673,1.183,1.183,0,0,0,1.607.9,1.24,1.24,0,0,0,1.024-1.561A1.38,1.38,0,0,0,278.954,309.775Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73953-2",
    "data-name": "Path 73953",
    d: "M267.026,314.154a1.039,1.039,0,0,0,1.232.7,1.012,1.012,0,0,0,.77-1.24,1.039,1.039,0,0,0-1.288-.808A1.067,1.067,0,0,0,267.026,314.154Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73954-2",
    "data-name": "Path 73954",
    d: "M256.143,316.729a.667.667,0,0,0,.78.451.623.623,0,0,0,.508-.714c-.123-.395-.443-.714-.762-.639A.782.782,0,0,0,256.143,316.729Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73955-2",
    "data-name": "Path 73955",
    d: "M245.261,319.436a.25.25,0,0,0,.329.132.282.282,0,0,0,.261-.263c-.065-.283-.261-.395-.394-.32C245.336,318.985,245.2,319.174,245.261,319.436Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73956-2",
    "data-name": "Path 73956",
    d: "M456.463,256.053c0,.037,0,.037.075.037,0-.037.058-.037.058-.037a.2.2,0,0,0-.133-.075Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73957-2",
    "data-name": "Path 73957",
    d: "M444.735,258.891a.534.534,0,0,0,1.034-.264.455.455,0,0,0-.64-.281A.441.441,0,0,0,444.735,258.891Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73958-2",
    "data-name": "Path 73958",
    d: "M433.005,261.71a1.111,1.111,0,0,0,1.24.79.957.957,0,0,0,.639-1.165.893.893,0,0,0-1.09-.733A1.047,1.047,0,0,0,433.005,261.71Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73959-2",
    "data-name": "Path 73959",
    d: "M422.459,263.008a1.266,1.266,0,0,0-1.034,1.542,1.354,1.354,0,1,0,2.632-.64A1.338,1.338,0,0,0,422.459,263.008Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73960-2",
    "data-name": "Path 73960",
    d: "M411.051,265.319a1.667,1.667,0,0,0-1.223,2.05,1.782,1.782,0,0,0,2.048,1.354,1.751,1.751,0,1,0-.825-3.4Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73961-2",
    "data-name": "Path 73961",
    d: "M399.79,267.781a1.974,1.974,0,0,0-1.561,2.445,2.12,2.12,0,0,0,2.52,1.522,2.052,2.052,0,0,0,1.484-2.481A1.962,1.962,0,0,0,399.79,267.781Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73962-2",
    "data-name": "Path 73962",
    d: "M388.436,270.226a2.357,2.357,0,0,0-1.784,2.837,2.573,2.573,0,0,0,2.951,1.806,2.36,2.36,0,0,0,1.672-2.99A2.262,2.262,0,0,0,388.436,270.226Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73963-2",
    "data-name": "Path 73963",
    d: "M377.1,272.651a2.664,2.664,0,0,0,1.3,5.168,2.664,2.664,0,0,0-1.3-5.168Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73964-2",
    "data-name": "Path 73964",
    d: "M365.9,275.319a2.705,2.705,0,0,0-2.123,3.289,2.766,2.766,0,0,0,3.421,2.031,2.825,2.825,0,0,0,2.049-3.384A2.7,2.7,0,0,0,365.9,275.319Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73965-2",
    "data-name": "Path 73965",
    d: "M354.584,277.819a2.941,2.941,0,0,0-2.219,3.534,3.128,3.128,0,0,0,3.609,2.2A2.938,2.938,0,0,0,358.041,280,2.847,2.847,0,0,0,354.584,277.819Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73966-2",
    "data-name": "Path 73966",
    d: "M343.3,280.525a3.031,3.031,0,0,0-2.2,3.61,3,3,0,0,0,3.609,2.18,2.98,2.98,0,1,0-1.411-5.79Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73967-2",
    "data-name": "Path 73967",
    d: "M332.027,283.234a3.026,3.026,0,0,0-2.142,3.609,2.953,2.953,0,0,0,3.551,2.181,2.979,2.979,0,1,0-1.409-5.79Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73968-2",
    "data-name": "Path 73968",
    d: "M320.825,286.146a2.733,2.733,0,0,0-2.069,3.384,2.848,2.848,0,0,0,3.422,2.142,2.791,2.791,0,0,0,2.1-3.476A2.836,2.836,0,0,0,320.825,286.146Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73969-2",
    "data-name": "Path 73969",
    d: "M309.6,288.966a2.7,2.7,0,0,0-1.934,3.27,2.753,2.753,0,0,0,3.289,2.069,2.754,2.754,0,1,0-1.355-5.339Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73970-2",
    "data-name": "Path 73970",
    d: "M298.455,291.917a2.589,2.589,0,0,0-1.842,3.027,2.509,2.509,0,0,0,3.008,1.8,2.417,2.417,0,0,0,1.8-2.951A2.505,2.505,0,0,0,298.455,291.917Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73971-2",
    "data-name": "Path 73971",
    d: "M287.262,295.039a2.11,2.11,0,0,0-1.607,2.556,2.187,2.187,0,1,0,4.248-1.034A2.1,2.1,0,0,0,287.262,295.039Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73972-2",
    "data-name": "Path 73972",
    d: "M276.125,298.045a1.793,1.793,0,0,0-1.428,2.181,1.86,1.86,0,1,0,3.609-.883A1.772,1.772,0,0,0,276.125,298.045Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73973-2",
    "data-name": "Path 73973",
    d: "M264.913,301.129a1.507,1.507,0,0,0,.7,2.931,1.491,1.491,0,0,0,1.1-1.9A1.445,1.445,0,0,0,264.913,301.129Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73974-2",
    "data-name": "Path 73974",
    d: "M252.929,305.527a1.069,1.069,0,0,0,1.409.751,1.055,1.055,0,0,0,.781-1.278,1.171,1.171,0,0,0-1.287-.77A1.159,1.159,0,0,0,252.929,305.527Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73975-2",
    "data-name": "Path 73975",
    d: "M242.1,308.158c.14.375.45.714.9.583.394-.057.525-.508.45-.9-.056-.395-.45-.508-.826-.451A.617.617,0,0,0,242.1,308.158Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73976-2",
    "data-name": "Path 73976",
    d: "M231.294,310.789a.266.266,0,0,0,.32.208.409.409,0,0,0,.2-.319.388.388,0,0,0-.329-.227A.425.425,0,0,0,231.294,310.789Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73977-2",
    "data-name": "Path 73977",
    d: "M453.381,244.982c0,.244.245.319.506.244a.4.4,0,0,0,.32-.488.379.379,0,0,0-.506-.284C453.437,244.53,453.248,244.738,453.381,244.982Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73978-2",
    "data-name": "Path 73978",
    d: "M441.651,247.8a.8.8,0,0,0,1.015.583.86.86,0,1,0-.376-1.673A.833.833,0,0,0,441.651,247.8Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73979-2",
    "data-name": "Path 73979",
    d: "M430.955,248.966a1.486,1.486,0,0,0-1.034,1.673,1.4,1.4,0,0,0,2.707-.639A1.5,1.5,0,0,0,430.955,248.966Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73980-2",
    "data-name": "Path 73980",
    d: "M419.622,251.278a1.837,1.837,0,0,0-1.3,2.2,1.741,1.741,0,0,0,2.068,1.3,1.843,1.843,0,0,0,1.353-2.144A1.8,1.8,0,0,0,419.622,251.278Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73981-2",
    "data-name": "Path 73981",
    d: "M408.231,253.665a2.217,2.217,0,0,0-1.617,2.65,2.193,2.193,0,0,0,2.631,1.581,2.252,2.252,0,0,0,1.729-2.614A2.226,2.226,0,0,0,408.231,253.665Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73982-2",
    "data-name": "Path 73982",
    d: "M396.951,255.921a2.641,2.641,0,0,0-1.936,3.214,2.6,2.6,0,0,0,3.1,1.881,2.614,2.614,0,0,0-1.167-5.095Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73983-2",
    "data-name": "Path 73983",
    d: "M385.6,258.44a2.817,2.817,0,0,0-2.106,3.476,2.882,2.882,0,0,0,5.6-1.353A2.836,2.836,0,0,0,385.6,258.44Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73984-2",
    "data-name": "Path 73984",
    d: "M374.283,260.827a3.229,3.229,0,0,0-2.387,3.928,3.341,3.341,0,0,0,3.928,2.37,3.282,3.282,0,0,0,2.331-3.853A3.233,3.233,0,0,0,374.283,260.827Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73985-2",
    "data-name": "Path 73985",
    d: "M362.93,263.308a3.471,3.471,0,0,0-2.444,4.212,3.415,3.415,0,1,0,6.635-1.617A3.526,3.526,0,0,0,362.93,263.308Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73986-2",
    "data-name": "Path 73986",
    d: "M351.726,265.978a3.594,3.594,0,0,0-2.631,4.3,3.543,3.543,0,0,0,6.879-1.692A3.549,3.549,0,0,0,351.726,265.978Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73987-2",
    "data-name": "Path 73987",
    d: "M340.392,268.684a3.613,3.613,0,1,0,1.748,7.012,3.551,3.551,0,0,0,2.631-4.4A3.609,3.609,0,0,0,340.392,268.684Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73988-2",
    "data-name": "Path 73988",
    d: "M329.188,271.39a3.634,3.634,0,0,0-2.575,4.381,3.541,3.541,0,0,0,6.881-1.672A3.655,3.655,0,0,0,329.188,271.39Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73989-2",
    "data-name": "Path 73989",
    d: "M317.986,274.285a3.48,3.48,0,0,0-2.576,4.193,3.486,3.486,0,1,0,2.576-4.193Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73990-2",
    "data-name": "Path 73990",
    d: "M306.764,277.124a3.335,3.335,0,0,0,1.559,6.485,3.335,3.335,0,0,0-1.559-6.485Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73991-2",
    "data-name": "Path 73991",
    d: "M295.562,280.15a3.083,3.083,0,0,0-2.181,3.648,3.02,3.02,0,0,0,3.609,2.256,3.038,3.038,0,0,0-1.428-5.9Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73992-2",
    "data-name": "Path 73992",
    d: "M284.367,283.159a2.745,2.745,0,0,0-1.946,3.345,2.7,2.7,0,0,0,3.234,2.011,2.756,2.756,0,0,0,2.057-3.27A2.87,2.87,0,0,0,284.367,283.159Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73993-2",
    "data-name": "Path 73993",
    d: "M273.276,286.315a2.334,2.334,0,0,0-1.738,2.859,2.3,2.3,0,0,0,2.781,1.653,2.348,2.348,0,0,0,1.806-2.764A2.408,2.408,0,0,0,273.276,286.315Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73994-2",
    "data-name": "Path 73994",
    d: "M262.084,289.474a1.856,1.856,0,0,0-1.429,2.312,1.985,1.985,0,0,0,2.331,1.447,2.1,2.1,0,0,0,1.54-2.406A1.979,1.979,0,0,0,262.084,289.474Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73995-2",
    "data-name": "Path 73995",
    d: "M250.993,292.575a1.428,1.428,0,0,0-1.146,1.861,1.605,1.605,0,0,0,1.86,1.165,1.654,1.654,0,0,0,1.091-1.879A1.482,1.482,0,0,0,250.993,292.575Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73996-2",
    "data-name": "Path 73996",
    d: "M239.02,297.087a1.01,1.01,0,0,0,1.278.694.987.987,0,0,0,.78-1.22,1.054,1.054,0,0,0-1.288-.827A1.07,1.07,0,0,0,239.02,297.087Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73997-2",
    "data-name": "Path 73997",
    d: "M228.268,299.662a.569.569,0,0,0,.695.45.54.54,0,0,0,.4-.714.552.552,0,0,0-.639-.508A.6.6,0,0,0,228.268,299.662Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73998-2",
    "data-name": "Path 73998",
    d: "M217.366,302.293a.358.358,0,0,0,.262.131c0-.056.075-.131.075-.167-.075-.152-.075-.1-.187-.1C217.516,302.162,217.366,302.162,217.366,302.293Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73999-2",
    "data-name": "Path 73999",
    d: "M461.989,230.921a.3.3,0,0,0,.414.206c.113,0,.113-.206.113-.337a.266.266,0,0,0-.263-.244C461.989,230.6,461.989,230.79,461.989,230.921Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74000-2",
    "data-name": "Path 74000",
    d: "M450.336,233.835a.672.672,0,0,0,.845.451.732.732,0,0,0,.583-.828.776.776,0,0,0-.9-.6A.806.806,0,0,0,450.336,233.835Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74001-2",
    "data-name": "Path 74001",
    d: "M438.568,236.653a1.2,1.2,0,0,0,1.466.866,1.169,1.169,0,0,0,.978-1.447,1.257,1.257,0,1,0-2.444.581Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74002-2",
    "data-name": "Path 74002",
    d: "M428.118,237.369a1.814,1.814,0,0,0-1.278,2.123,1.728,1.728,0,0,0,2.123,1.223,1.612,1.612,0,0,0,1.222-1.993A1.705,1.705,0,0,0,428.118,237.369Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74003-2",
    "data-name": "Path 74003",
    d: "M416.783,239.681a2.2,2.2,0,1,0,1.033,4.267,2.2,2.2,0,1,0-1.033-4.267Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74004-2",
    "data-name": "Path 74004",
    d: "M405.372,241.937a2.666,2.666,0,0,0-1.917,3.289,2.607,2.607,0,0,0,3.159,1.879,2.717,2.717,0,0,0,2.067-3.157A2.819,2.819,0,0,0,405.372,241.937Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74005-2",
    "data-name": "Path 74005",
    d: "M394.114,244.285a3.068,3.068,0,0,0-2.312,3.779,3.08,3.08,0,1,0,2.312-3.779Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74006-2",
    "data-name": "Path 74006",
    d: "M382.779,246.655a3.523,3.523,0,0,0-2.6,4.173,3.45,3.45,0,0,0,6.712-1.581A3.445,3.445,0,0,0,382.779,246.655Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74007-2",
    "data-name": "Path 74007",
    d: "M371.444,249.1a3.771,3.771,0,0,0-2.763,4.568,3.743,3.743,0,0,0,7.275-1.748A3.762,3.762,0,0,0,371.444,249.1Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74008-2",
    "data-name": "Path 74008",
    d: "M360.11,251.542a3.915,3.915,0,0,0-2.895,4.887,3.955,3.955,0,0,0,4.755,2.914,4.085,4.085,0,0,0,2.97-4.776A4,4,0,0,0,360.11,251.542Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74009-2",
    "data-name": "Path 74009",
    d: "M348.831,254.173a4.153,4.153,0,1,0,5.037,3.1A4.2,4.2,0,0,0,348.831,254.173Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74010-2",
    "data-name": "Path 74010",
    d: "M337.553,256.823a4.273,4.273,0,0,0-3.083,5.132A4.18,4.18,0,0,0,339.49,265a4.117,4.117,0,0,0,3.1-5.018A4.209,4.209,0,0,0,337.553,256.823Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74011-2",
    "data-name": "Path 74011",
    d: "M326.351,259.663a4.049,4.049,0,0,0-3.084,5,4.172,4.172,0,1,0,3.084-5Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74012-2",
    "data-name": "Path 74012",
    d: "M315.091,262.5a4.07,4.07,0,0,0-2.97,4.869,4.035,4.035,0,1,0,2.97-4.869Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74013-2",
    "data-name": "Path 74013",
    d: "M303.944,265.395a3.785,3.785,0,0,0-2.839,4.681,3.836,3.836,0,0,0,4.643,2.781,3.772,3.772,0,0,0,2.82-4.587A3.814,3.814,0,0,0,303.944,265.395Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74014-2",
    "data-name": "Path 74014",
    d: "M292.742,268.42a3.513,3.513,0,1,0,1.672,6.824,3.38,3.38,0,0,0,2.576-4.115A3.464,3.464,0,0,0,292.742,268.42Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74015-2",
    "data-name": "Path 74015",
    d: "M281.52,271.523a3.175,3.175,0,0,0-2.314,3.834,3.178,3.178,0,1,0,6.185-1.466A3.151,3.151,0,0,0,281.52,271.523Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74016-2",
    "data-name": "Path 74016",
    d: "M270.449,274.663a2.766,2.766,0,0,0-2.07,3.4,2.793,2.793,0,0,0,5.415-1.353A2.791,2.791,0,0,0,270.449,274.663Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74017-2",
    "data-name": "Path 74017",
    d: "M259.235,277.744a2.409,2.409,0,0,0-1.738,2.989,2.484,2.484,0,0,0,2.9,1.673,2.4,2.4,0,0,0-1.166-4.662Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74018-2",
    "data-name": "Path 74018",
    d: "M248.163,280.978a1.925,1.925,0,0,0-1.419,2.331,1.972,1.972,0,0,0,2.322,1.353,1.91,1.91,0,0,0,1.353-2.217A1.858,1.858,0,0,0,248.163,280.978Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74019-2",
    "data-name": "Path 74019",
    d: "M236.951,284.135a1.4,1.4,0,0,0-1.024,1.8,1.454,1.454,0,0,0,2.83-.658A1.509,1.509,0,0,0,236.951,284.135Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74020-2",
    "data-name": "Path 74020",
    d: "M225.11,288.571a.994.994,0,0,0,1.222.639.883.883,0,0,0,.695-1.089.912.912,0,0,0-1.148-.753A1,1,0,0,0,225.11,288.571Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74021-2",
    "data-name": "Path 74021",
    d: "M214.413,291.147a.579.579,0,0,0,.509.319c.263-.131.394-.358.338-.489-.075-.319-.338-.414-.527-.319C214.471,290.7,214.413,290.827,214.413,291.147Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74022-2",
    "data-name": "Path 74022",
    d: "M459.038,219.736a.657.657,0,0,0,.658.32.456.456,0,0,0,.3-.582.471.471,0,0,0-.564-.394A.6.6,0,0,0,459.038,219.736Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74023-2",
    "data-name": "Path 74023",
    d: "M447.309,222.556a1.057,1.057,0,0,0,1.222.789,1.092,1.092,0,0,0,.789-1.315,1.075,1.075,0,0,0-1.24-.752A1.022,1.022,0,0,0,447.309,222.556Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74024-2",
    "data-name": "Path 74024",
    d: "M436.614,223.534a1.558,1.558,0,0,0-1.091,1.842,1.582,1.582,0,0,0,1.88,1.241,1.643,1.643,0,0,0,1.165-1.917A1.6,1.6,0,0,0,436.614,223.534Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74025-2",
    "data-name": "Path 74025",
    d: "M425.3,225.79a2.006,2.006,0,0,0-1.486,2.425,2.03,2.03,0,0,0,2.5,1.559,2.005,2.005,0,0,0,1.486-2.462A2.038,2.038,0,0,0,425.3,225.79Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74026-2",
    "data-name": "Path 74026",
    d: "M413.944,228.046a2.535,2.535,0,0,0-1.917,3.081,2.473,2.473,0,0,0,3.083,1.881,2.565,2.565,0,0,0,1.936-3.121A2.61,2.61,0,0,0,413.944,228.046Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74027-2",
    "data-name": "Path 74027",
    d: "M402.552,230.3a3.06,3.06,0,0,0-2.254,3.646,3.2,3.2,0,0,0,3.721,2.35,3.1,3.1,0,0,0,2.256-3.74A3.058,3.058,0,0,0,402.552,230.3Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74028-2",
    "data-name": "Path 74028",
    d: "M391.275,232.688a3.306,3.306,0,0,0-2.575,4.1,3.454,3.454,0,1,0,6.711-1.617A3.3,3.3,0,0,0,391.275,232.688Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74029-2",
    "data-name": "Path 74029",
    d: "M379.959,234.944a3.815,3.815,0,0,0-2.97,4.679,3.91,3.91,0,1,0,7.6-1.859A3.824,3.824,0,0,0,379.959,234.944Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74030-2",
    "data-name": "Path 74030",
    d: "M368.549,237.311a4.307,4.307,0,0,0-3.157,5.171,4.212,4.212,0,0,0,5.151,3.156,4.281,4.281,0,1,0-1.994-8.327Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74031-2",
    "data-name": "Path 74031",
    d: "M357.271,239.812a4.535,4.535,0,1,0,5.471,3.289A4.491,4.491,0,0,0,357.271,239.812Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74032-2",
    "data-name": "Path 74032",
    d: "M345.936,242.274a4.769,4.769,0,1,0,5.734,3.534A4.738,4.738,0,0,0,345.936,242.274Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74033-2",
    "data-name": "Path 74033",
    d: "M334.658,244.982a4.832,4.832,0,0,0,2.256,9.4,4.754,4.754,0,0,0,3.609-5.863A4.834,4.834,0,0,0,334.658,244.982Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74034-2",
    "data-name": "Path 74034",
    d: "M323.381,247.744a4.83,4.83,0,0,0-3.459,5.79,4.747,4.747,0,0,0,5.79,3.553,4.8,4.8,0,0,0,3.476-5.809A4.892,4.892,0,0,0,323.381,247.744Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74035-2",
    "data-name": "Path 74035",
    d: "M312.177,250.639a4.66,4.66,0,0,0-3.4,5.6,4.678,4.678,0,0,0,9.08-2.256A4.688,4.688,0,0,0,312.177,250.639Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74036-2",
    "data-name": "Path 74036",
    d: "M301.049,253.609a4.36,4.36,0,0,0-3.289,5.282,4.437,4.437,0,1,0,3.289-5.282Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74037-2",
    "data-name": "Path 74037",
    d: "M289.9,256.692a4.089,4.089,0,0,0-3.036,4.9,4.087,4.087,0,1,0,7.942-1.934A4.031,4.031,0,0,0,289.9,256.692Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74038-2",
    "data-name": "Path 74038",
    d: "M278.691,259.793a3.667,3.667,0,0,0-2.707,4.379,3.626,3.626,0,0,0,4.445,2.708,3.65,3.65,0,1,0-1.738-7.087Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74039-2",
    "data-name": "Path 74039",
    d: "M267.619,263.008a3.2,3.2,0,0,0-2.454,3.8,3.261,3.261,0,0,0,3.93,2.367,3.17,3.17,0,1,0-1.476-6.165Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74040-2",
    "data-name": "Path 74040",
    d: "M256.407,266.109a2.916,2.916,0,0,0-2.069,3.345,2.859,2.859,0,0,0,3.357,2.069,2.783,2.783,0,1,0-1.288-5.414Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74041-2",
    "data-name": "Path 74041",
    d: "M245.336,269.379a2.308,2.308,0,0,0-1.741,2.708,2.293,2.293,0,1,0,4.447-1.109A2.308,2.308,0,0,0,245.336,269.379Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74042-2",
    "data-name": "Path 74042",
    d: "M234.189,272.538a1.96,1.96,0,0,0-1.353,2.2,1.828,1.828,0,0,0,2.188,1.278,1.792,1.792,0,0,0,1.288-2.181A1.868,1.868,0,0,0,234.189,272.538Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74043-2",
    "data-name": "Path 74043",
    d: "M222.14,277.294a1.249,1.249,0,0,0,1.541.978,1.273,1.273,0,0,0-.639-2.464A1.264,1.264,0,0,0,222.14,277.294Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74044-2",
    "data-name": "Path 74044",
    d: "M211.463,279.869a.745.745,0,0,0,.827.656.947.947,0,0,0,.526-.975.761.761,0,0,0-.845-.453C211.576,279.247,211.313,279.511,211.463,279.869Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74045-2",
    "data-name": "Path 74045",
    d: "M200.636,282.537c.055.133.113.169.244.133.131,0,.131-.094.131-.225,0,0-.131-.227-.262-.227C200.636,282.256,200.636,282.445,200.636,282.537Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74046-2",
    "data-name": "Path 74046",
    d: "M467.854,205.677c0,.112.188.112.264.112a.163.163,0,0,0,.13-.225.407.407,0,0,0-.261-.226C467.929,205.433,467.8,205.564,467.854,205.677Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74047-2",
    "data-name": "Path 74047",
    d: "M456.087,208.5a.749.749,0,1,0,.564-.9A.782.782,0,0,0,456.087,208.5Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74048-2",
    "data-name": "Path 74048",
    d: "M444.358,211.409a1.257,1.257,0,0,0,2.444-.564,1.269,1.269,0,0,0-1.542-.995A1.251,1.251,0,0,0,444.358,211.409Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74049-2",
    "data-name": "Path 74049",
    d: "M433.869,211.993a1.925,1.925,0,0,0-1.353,2.236,1.8,1.8,0,0,0,2.181,1.353,1.851,1.851,0,0,0,1.428-2.161A1.965,1.965,0,0,0,433.869,211.993Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74050-2",
    "data-name": "Path 74050",
    d: "M422.517,214.229a2.352,2.352,0,0,0-1.731,2.934,2.281,2.281,0,0,0,2.82,1.672A2.331,2.331,0,0,0,425.354,216,2.422,2.422,0,0,0,422.517,214.229Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74051-2",
    "data-name": "Path 74051",
    d: "M411.126,216.447a2.988,2.988,0,0,0-2.145,3.533,2.882,2.882,0,0,0,5.6-1.353A2.936,2.936,0,0,0,411.126,216.447Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74052-2",
    "data-name": "Path 74052",
    d: "M399.715,218.7a3.385,3.385,0,0,0-2.444,4.1,3.453,3.453,0,0,0,4.061,2.576,3.414,3.414,0,0,0,2.5-4.1A3.369,3.369,0,0,0,399.715,218.7Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74053-2",
    "data-name": "Path 74053",
    d: "M388.436,220.958a3.931,3.931,0,0,0-2.951,4.757,3.949,3.949,0,1,0,7.671-1.881A3.913,3.913,0,0,0,388.436,220.958Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74054-2",
    "data-name": "Path 74054",
    d: "M377.045,223.253a4.347,4.347,0,0,0-3.157,5.281,4.341,4.341,0,0,0,8.44-2.03A4.347,4.347,0,0,0,377.045,223.253Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74055-2",
    "data-name": "Path 74055",
    d: "M365.711,225.507a4.806,4.806,0,1,0,2.257,9.343,4.681,4.681,0,0,0,3.476-5.734A4.854,4.854,0,0,0,365.711,225.507Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74056-2",
    "data-name": "Path 74056",
    d: "M354.321,227.97a5.218,5.218,0,0,0-3.76,6.241,5.175,5.175,0,0,0,10.056-2.426A5.186,5.186,0,0,0,354.321,227.97Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74057-2",
    "data-name": "Path 74057",
    d: "M343.1,230.471a5.4,5.4,0,0,0,2.517,10.507,5.425,5.425,0,0,0,3.929-6.579A5.357,5.357,0,0,0,343.1,230.471Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74058-2",
    "data-name": "Path 74058",
    d: "M320.561,235.883a5.325,5.325,0,0,0-3.986,6.6,5.391,5.391,0,0,0,6.562,3.965,5.437,5.437,0,0,0-2.576-10.564Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74059-2",
    "data-name": "Path 74059",
    d: "M309.357,238.778a5.315,5.315,0,0,0-3.871,6.41,5.185,5.185,0,0,0,6.316,3.778,5.239,5.239,0,1,0-2.445-10.188Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74060-2",
    "data-name": "Path 74060",
    d: "M298.193,241.823a5.024,5.024,0,0,0-3.648,5.977,4.932,4.932,0,0,0,9.588-2.312A5.007,5.007,0,0,0,298.193,241.823Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74061-2",
    "data-name": "Path 74061",
    d: "M287.008,244.907a4.614,4.614,0,0,0,2.181,8.966,4.615,4.615,0,0,0-2.181-8.966Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74062-2",
    "data-name": "Path 74062",
    d: "M275.861,248.121a4.032,4.032,0,0,0-2.97,4.963,3.982,3.982,0,0,0,4.9,2.969,4.082,4.082,0,1,0-1.927-7.932Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74063-2",
    "data-name": "Path 74063",
    d: "M264.79,251.278a3.725,3.725,0,0,0-2.706,4.456,3.559,3.559,0,0,0,4.369,2.612,3.66,3.66,0,0,0,2.708-4.362A3.715,3.715,0,0,0,264.79,251.278Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74064-2",
    "data-name": "Path 74064",
    d: "M253.578,254.623a3.08,3.08,0,0,0,1.476,5.979,3.079,3.079,0,1,0-1.476-5.979Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74065-2",
    "data-name": "Path 74065",
    d: "M242.5,257.726a2.739,2.739,0,0,0-1.936,3.215,2.568,2.568,0,0,0,3.224,1.878,2.653,2.653,0,0,0,1.862-3.12A2.742,2.742,0,0,0,242.5,257.726Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74066-2",
    "data-name": "Path 74066",
    d: "M231.35,261.016a2.013,2.013,0,0,0-1.484,2.5,2.054,2.054,0,1,0,3.994-.959A2.11,2.11,0,0,0,231.35,261.016Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74067-2",
    "data-name": "Path 74067",
    d: "M220.259,264.3a1.527,1.527,0,0,0-1.145,1.861,1.519,1.519,0,0,0,2.951-.716A1.5,1.5,0,0,0,220.259,264.3Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74068-2",
    "data-name": "Path 74068",
    d: "M208.362,268.815a1.044,1.044,0,0,0,1.222.639.967.967,0,0,0,.714-1.184.989.989,0,0,0-1.166-.695A1.046,1.046,0,0,0,208.362,268.815Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74069-2",
    "data-name": "Path 74069",
    d: "M197.721,271.39a.362.362,0,0,0,.453.245.331.331,0,0,0,.319-.451.424.424,0,0,0-.452-.338C197.8,270.978,197.666,271.129,197.721,271.39Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74070-2",
    "data-name": "Path 74070",
    d: "M464.959,194.473a.384.384,0,0,0,.452.189.287.287,0,0,0,.187-.376c0-.189-.187-.264-.375-.189C465.092,194.1,464.959,194.286,464.959,194.473Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74071-2",
    "data-name": "Path 74071",
    d: "M453.173,197.312a.922.922,0,0,0,1.167.7c.45-.056.714-.639.639-1.09-.189-.639-.639-.9-1.092-.77A.98.98,0,0,0,453.173,197.312Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74072-2",
    "data-name": "Path 74072",
    d: "M442.421,198.346a1.464,1.464,0,0,0-1.033,1.861,1.427,1.427,0,0,0,1.8,1.109,1.582,1.582,0,0,0,1.09-1.8A1.55,1.55,0,0,0,442.421,198.346Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74073-2",
    "data-name": "Path 74073",
    d: "M431.088,200.526a2,2,0,0,0-1.486,2.52,2.081,2.081,0,0,0,2.462,1.615,2.125,2.125,0,0,0,1.541-2.593A2.083,2.083,0,0,0,431.088,200.526Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74074-2",
    "data-name": "Path 74074",
    d: "M419.753,202.726a2.545,2.545,0,0,0-1.937,3.213,2.583,2.583,0,0,0,3.159,1.936,2.724,2.724,0,0,0,1.936-3.214A2.633,2.633,0,0,0,419.753,202.726Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74075-2",
    "data-name": "Path 74075",
    d: "M408.267,204.98a3.153,3.153,0,1,0,1.561,6.11,3.153,3.153,0,1,0-1.561-6.11Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74076-2",
    "data-name": "Path 74076",
    d: "M396.951,207.236a3.661,3.661,0,0,0-2.781,4.418,3.614,3.614,0,0,0,4.454,2.67,3.564,3.564,0,0,0,2.839-4.38A3.61,3.61,0,0,0,396.951,207.236Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74077-2",
    "data-name": "Path 74077",
    d: "M385.6,209.286a4.311,4.311,0,1,0,5.168,3.232A4.389,4.389,0,0,0,385.6,209.286Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74078-2",
    "data-name": "Path 74078",
    d: "M374.208,211.542a4.9,4.9,0,0,0-3.534,5.846,4.782,4.782,0,0,0,9.285-2.295A4.874,4.874,0,0,0,374.208,211.542Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74079-2",
    "data-name": "Path 74079",
    d: "M362.817,213.779a5.293,5.293,0,0,0-3.873,6.446,5.232,5.232,0,0,0,6.373,3.892,5.318,5.318,0,1,0-2.5-10.338Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74080-2",
    "data-name": "Path 74080",
    d: "M295.3,230.151a5.439,5.439,0,1,0,6.579,3.929A5.367,5.367,0,0,0,295.3,230.151Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74081-2",
    "data-name": "Path 74081",
    d: "M284.226,233.308a4.951,4.951,0,1,0,5.941,3.665A4.931,4.931,0,0,0,284.226,233.308Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74082-2",
    "data-name": "Path 74082",
    d: "M273.032,236.467a4.487,4.487,0,1,0,5.4,3.345A4.44,4.44,0,0,0,273.032,236.467Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74083-2",
    "data-name": "Path 74083",
    d: "M261.943,239.812a3.9,3.9,0,0,0-2.953,4.718,3.976,3.976,0,0,0,7.726-1.879A3.908,3.908,0,0,0,261.943,239.812Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74084-2",
    "data-name": "Path 74084",
    d: "M250.806,243.046a3.423,3.423,0,0,0,1.607,6.654,3.486,3.486,0,0,0,2.518-4.154A3.4,3.4,0,0,0,250.806,243.046Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74085-2",
    "data-name": "Path 74085",
    d: "M239.725,246.391a2.783,2.783,0,0,0-2.116,3.345,2.85,2.85,0,0,0,5.536-1.353A2.816,2.816,0,0,0,239.725,246.391Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74086-2",
    "data-name": "Path 74086",
    d: "M228.588,249.6a2.247,2.247,0,0,0-1.675,2.707,2.183,2.183,0,0,0,2.764,1.672,2.156,2.156,0,0,0,1.617-2.706A2.256,2.256,0,0,0,228.588,249.6Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74087-2",
    "data-name": "Path 74087",
    d: "M217.516,252.82a1.751,1.751,0,0,0,.751,3.42,1.751,1.751,0,0,0-.751-3.42Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74088-2",
    "data-name": "Path 74088",
    d: "M205.523,257.538a1.133,1.133,0,0,0,2.2-.545,1.133,1.133,0,0,0-2.2.545Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74089-2",
    "data-name": "Path 74089",
    d: "M194.828,260.151a.6.6,0,0,0,.657.412.606.606,0,0,0,.452-.639.549.549,0,0,0-.714-.45A.554.554,0,0,0,194.828,260.151Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74090-2",
    "data-name": "Path 74090",
    d: "M462.139,183.2a.452.452,0,0,0,.564.414.514.514,0,0,0,.339-.6.537.537,0,0,0-.6-.4A.459.459,0,0,0,462.139,183.2Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74091-2",
    "data-name": "Path 74091",
    d: "M450.278,186.109a1.016,1.016,0,0,0,1.3.7,1.021,1.021,0,1,0-.451-1.992A1.115,1.115,0,0,0,450.278,186.109Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74092-2",
    "data-name": "Path 74092",
    d: "M439.715,186.935a1.692,1.692,0,1,0,1.936,1.223A1.69,1.69,0,0,0,439.715,186.935Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74093-2",
    "data-name": "Path 74093",
    d: "M428.3,189.191a2.161,2.161,0,0,0-1.6,2.651,2.185,2.185,0,1,0,4.248-1.015A2.094,2.094,0,0,0,428.3,189.191Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74094-2",
    "data-name": "Path 74094",
    d: "M416.913,191.391a2.786,2.786,0,0,0-2.067,3.346,2.83,2.83,0,0,0,3.423,2.067,2.893,2.893,0,0,0,2.067-3.421A2.788,2.788,0,0,0,416.913,191.391Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74095-2",
    "data-name": "Path 74095",
    d: "M405.522,193.533a3.448,3.448,0,0,0-2.517,4.023,3.5,3.5,0,0,0,4.134,2.52,3.37,3.37,0,1,0-1.617-6.543Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74096-2",
    "data-name": "Path 74096",
    d: "M394.114,195.639a3.987,3.987,0,0,0-2.9,4.832,3.973,3.973,0,0,0,7.724-1.862A3.983,3.983,0,0,0,394.114,195.639Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74097-2",
    "data-name": "Path 74097",
    d: "M382.779,197.9a4.576,4.576,0,0,0-3.421,5.47,4.677,4.677,0,0,0,5.6,3.327,4.532,4.532,0,1,0-2.181-8.8Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74098-2",
    "data-name": "Path 74098",
    d: "M371.444,199.962a5.159,5.159,0,1,0,6.184,3.8A5.194,5.194,0,0,0,371.444,199.962Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74099-2",
    "data-name": "Path 74099",
    d: "M281.4,221.655a5.367,5.367,0,1,0,6.438,3.946A5.351,5.351,0,0,0,281.4,221.655Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74100-2",
    "data-name": "Path 74100",
    d: "M270.185,225.02a4.714,4.714,0,0,0-3.469,5.732,4.769,4.769,0,1,0,9.268-2.256A4.715,4.715,0,0,0,270.185,225.02Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74101-2",
    "data-name": "Path 74101",
    d: "M259.113,228.309a4.167,4.167,0,0,0-3.091,5,4.218,4.218,0,0,0,5.084,3.1,4.173,4.173,0,1,0-1.993-8.1Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74102-2",
    "data-name": "Path 74102",
    d: "M247.967,231.5a3.684,3.684,0,1,0,4.446,2.707A3.716,3.716,0,0,0,247.967,231.5Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74103-2",
    "data-name": "Path 74103",
    d: "M236.951,234.944a2.921,2.921,0,0,0-2.246,3.609,2.97,2.97,0,0,0,3.667,2.237,3.025,3.025,0,0,0,2.188-3.684A2.889,2.889,0,0,0,236.951,234.944Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74104-2",
    "data-name": "Path 74104",
    d: "M225.8,238.139a2.467,2.467,0,1,0,3.028,1.8A2.563,2.563,0,0,0,225.8,238.139Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74105-2",
    "data-name": "Path 74105",
    d: "M214.733,241.485a1.839,1.839,0,0,0-1.409,2.2,1.844,1.844,0,1,0,1.409-2.2Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74106-2",
    "data-name": "Path 74106",
    d: "M202.685,246.316a1.308,1.308,0,0,0,1.56.978,1.381,1.381,0,0,0,.9-1.542,1.23,1.23,0,0,0-1.562-.9A1.183,1.183,0,0,0,202.685,246.316Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74107-2",
    "data-name": "Path 74107",
    d: "M191.933,248.91a.645.645,0,0,0,.845.507.716.716,0,0,0,.564-.845.679.679,0,0,0-.9-.508A.7.7,0,0,0,191.933,248.91Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74108-2",
    "data-name": "Path 74108",
    d: "M181.312,251.542c0,.131.056.075.131.075.058,0,.133-.075.058-.208a.215.215,0,0,0-.133-.056C181.312,251.353,181.312,251.542,181.312,251.542Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74109-2",
    "data-name": "Path 74109",
    d: "M459.283,171.918c.15.337.413.545.714.45a.483.483,0,0,0,.338-.677c0-.262-.338-.412-.6-.337A.587.587,0,0,0,459.283,171.918Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74110-2",
    "data-name": "Path 74110",
    d: "M447.441,174.83a1.109,1.109,0,0,0,1.428.828,1.014,1.014,0,0,0,.828-1.353,1.139,1.139,0,0,0-1.353-.809A1.174,1.174,0,0,0,447.441,174.83Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74111-2",
    "data-name": "Path 74111",
    d: "M437.778,179.136a1.927,1.927,0,0,0,1.279-2.256,1.74,1.74,0,0,0-2.1-1.261,1.8,1.8,0,0,0-1.355,2.125A1.864,1.864,0,0,0,437.778,179.136Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74112-2",
    "data-name": "Path 74112",
    d: "M425.542,177.744a2.362,2.362,0,0,0-1.73,2.839,2.408,2.408,0,0,0,2.839,1.8,2.342,2.342,0,0,0,1.729-2.837A2.38,2.38,0,0,0,425.542,177.744Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74113-2",
    "data-name": "Path 74113",
    d: "M414.207,180a2.808,2.808,0,0,0-2.18,3.459,2.91,2.91,0,1,0,5.659-1.353A2.8,2.8,0,0,0,414.207,180Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74114-2",
    "data-name": "Path 74114",
    d: "M402.741,182.106a3.536,3.536,0,0,0-2.575,4.248,3.513,3.513,0,1,0,6.823-1.673A3.486,3.486,0,0,0,402.741,182.106Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74115-2",
    "data-name": "Path 74115",
    d: "M391.35,184.192a4.132,4.132,0,0,0-3.045,5,4.217,4.217,0,0,0,5.037,3.1,4.172,4.172,0,0,0-1.992-8.1Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74116-2",
    "data-name": "Path 74116",
    d: "M380,186.429a4.677,4.677,0,0,0-3.534,5.657,4.778,4.778,0,1,0,9.285-2.256A4.689,4.689,0,0,0,380,186.429Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74117-2",
    "data-name": "Path 74117",
    d: "M368.606,188.571A5.305,5.305,0,0,0,364.62,195a5.432,5.432,0,0,0,6.562,4.06,5.521,5.521,0,0,0,3.928-6.654A5.413,5.413,0,0,0,368.606,188.571Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74118-2",
    "data-name": "Path 74118",
    d: "M267.479,213.554a4.869,4.869,0,0,0-3.667,5.976,4.974,4.974,0,1,0,3.667-5.976Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74119-2",
    "data-name": "Path 74119",
    d: "M256.407,216.9a4.308,4.308,0,0,0-3.28,5.206,4.375,4.375,0,1,0,8.506-2.049A4.3,4.3,0,0,0,256.407,216.9Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74120-2",
    "data-name": "Path 74120",
    d: "M245.2,220.188a3.724,3.724,0,0,0-2.7,4.512,3.8,3.8,0,0,0,4.5,2.818,3.774,3.774,0,1,0-1.8-7.33Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74121-2",
    "data-name": "Path 74121",
    d: "M234.189,223.534a3.153,3.153,0,0,0-2.379,3.778,3.148,3.148,0,1,0,2.379-3.778Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74122-2",
    "data-name": "Path 74122",
    d: "M223.042,226.823a2.63,2.63,0,0,0-1.917,3.064,2.6,2.6,0,0,0,3.138,1.9,2.555,2.555,0,0,0-1.221-4.962Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74123-2",
    "data-name": "Path 74123",
    d: "M211.971,230.151a1.9,1.9,0,0,0-1.411,2.331,1.915,1.915,0,1,0,3.722-.9A1.859,1.859,0,0,0,211.971,230.151Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74124-2",
    "data-name": "Path 74124",
    d: "M200.824,233.458a1.37,1.37,0,0,0-1.033,1.6,1.392,1.392,0,0,0,2.706-.657A1.393,1.393,0,0,0,200.824,233.458Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74125-2",
    "data-name": "Path 74125",
    d: "M189.1,237.689a.831.831,0,0,0,1.616-.378.831.831,0,1,0-1.616.378Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74126-2",
    "data-name": "Path 74126",
    d: "M178.473,240.262c0,.208.133.208.264.133a.153.153,0,0,0,.133-.169c-.077-.15-.133-.206-.264-.206C178.473,240.076,178.473,240.131,178.473,240.262Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74127-2",
    "data-name": "Path 74127",
    d: "M457.629,160.452a.464.464,0,0,0-.639-.358.48.48,0,0,0-.394.677c.055.337.319.451.639.412C457.629,161.108,457.741,160.864,457.629,160.452Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74128-2",
    "data-name": "Path 74128",
    d: "M447.064,163.12a1.326,1.326,0,0,0-1.428-1,1.255,1.255,0,0,0-.9,1.56,1.128,1.128,0,0,0,1.428.789A1.179,1.179,0,0,0,447.064,163.12Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74129-2",
    "data-name": "Path 74129",
    d: "M435.072,167.82a1.847,1.847,0,0,0,1.242-2.125,1.778,1.778,0,0,0-2.145-1.315,1.819,1.819,0,0,0-1.277,2.143A1.909,1.909,0,0,0,435.072,167.82Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74130-2",
    "data-name": "Path 74130",
    d: "M423.87,171.109a2.351,2.351,0,1,0-1.034-4.586,2.42,2.42,0,0,0-1.8,2.819A2.327,2.327,0,0,0,423.87,171.109Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74131-2",
    "data-name": "Path 74131",
    d: "M412.779,174.435a2.857,2.857,0,0,0,2.2-3.533,2.914,2.914,0,0,0-3.553-2.179,2.936,2.936,0,1,0,1.353,5.712Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74132-2",
    "data-name": "Path 74132",
    d: "M401.727,177.783a3.6,3.6,0,0,0-1.748-6.993,3.6,3.6,0,1,0,1.748,6.993Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74133-2",
    "data-name": "Path 74133",
    d: "M390.636,181.2a4.243,4.243,0,0,0,3.083-5.131,4.173,4.173,0,1,0-3.083,5.131Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74134-2",
    "data-name": "Path 74134",
    d: "M379.545,184.418a4.81,4.81,0,1,0-2.292-9.343,4.877,4.877,0,0,0-3.609,5.865A4.784,4.784,0,0,0,379.545,184.418Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74135-2",
    "data-name": "Path 74135",
    d: "M282.167,201.824a5.681,5.681,0,0,0-6.371-2.97,5.614,5.614,0,0,0-4.183,6.9,5.761,5.761,0,0,0,6.889,4.192,5.667,5.667,0,0,0,4.248-5.545,6.847,6.847,0,0,0,4.71,3.609,6.279,6.279,0,0,0-2.4,5.732,5.56,5.56,0,1,0-3.854,7.388,5.668,5.668,0,0,0,4.117-6.316,6.146,6.146,0,0,0,5.987,4.135,5.745,5.745,0,0,0-3.147,6.56,5.8,5.8,0,0,0,11.456-1.071,6.709,6.709,0,0,0,5.545,3.29,5.522,5.522,0,0,0-2.95,6.315,5.756,5.756,0,0,0,7.01,4.229,5.68,5.68,0,0,0,4.3-6.24,6.14,6.14,0,0,0,7.031,3.817,6.025,6.025,0,0,0,4.512-5.96,5.954,5.954,0,0,0,6.691,3.252,5.378,5.378,0,0,0-3.985,6.636,5.521,5.521,0,0,0,6.56,4.06,5.724,5.724,0,0,0,4.117-6.729,5.506,5.506,0,0,0-6.692-3.967,6.092,6.092,0,0,0,4.511-6.146,6.026,6.026,0,0,0,6.691,3.308,6.1,6.1,0,0,0,4.456-7.087,5.651,5.651,0,1,0,4.756-7.087,5.994,5.994,0,0,0,3.946-6.446,5.593,5.593,0,0,0,6.562,3.534,5.681,5.681,0,0,0,4.248-6.824,5.77,5.77,0,0,0-6.712-4.248,5.821,5.821,0,0,0,4.192-7.087,5.956,5.956,0,0,0-6-4.379,5.972,5.972,0,0,0,3.365-6.9,5.5,5.5,0,1,0,4.059-6.635,5.623,5.623,0,0,0-4.059,6.635,5.968,5.968,0,0,0-5.921-4.551,5.889,5.889,0,0,0,3.157-6.635,6.027,6.027,0,0,0-6.579-4.511,5.83,5.83,0,0,0,3.684-6.729,5.93,5.93,0,0,0-7.1-4.229,5.675,5.675,0,0,0-4.3,5.545,6.324,6.324,0,0,0-5.415-3.42,5.8,5.8,0,0,0-4.248-10.7,5.7,5.7,0,0,0-4.323,5.864,6.114,6.114,0,0,0-6.373-3.478,5.551,5.551,0,1,0-1.22.32,5.759,5.759,0,0,0-3.987,4.681,6.522,6.522,0,0,0-5.412-2.5,5.664,5.664,0,1,0-8.121-3.665,5.784,5.784,0,0,0,5.6,4.323,6.212,6.212,0,0,0-3.551,4.417,6.638,6.638,0,0,0-5.415-2.294,5.574,5.574,0,0,0,3.234-6.371,5.7,5.7,0,1,0-11.072,2.706,5.606,5.606,0,0,0,5.808,4.173,6.212,6.212,0,0,0-3.76,5.17,5.98,5.98,0,0,0-10.882,4.493,5.621,5.621,0,1,0-4.3,6.973,6.087,6.087,0,0,0-4.248,7.255,6.016,6.016,0,0,0,5.337,4.473,6.249,6.249,0,0,0-2.895,5.771,5.523,5.523,0,0,0-6.381-3.195,5.6,5.6,0,0,0-4.182,6.8,5.693,5.693,0,0,0,6.824,4.136,5.444,5.444,0,0,0,4.247-5.676,6.09,6.09,0,0,0,4.512,3.609A6.4,6.4,0,0,0,282.167,201.824Zm6.7-21.579a6.219,6.219,0,0,0,3.478,2.367,5.911,5.911,0,0,0-2.059,3.609,6.126,6.126,0,0,0-4.116-2.029A6.233,6.233,0,0,0,288.869,180.245Zm11.466-2.012A7.941,7.941,0,0,0,302.78,180a6.213,6.213,0,0,0-1.467,2.5,7.967,7.967,0,0,0-2.67-1.429A6.616,6.616,0,0,0,300.335,178.233Zm11.467-2.444a7.832,7.832,0,0,0,1.991,1.43,8.352,8.352,0,0,0-1.222,1.878,5.723,5.723,0,0,0-1.934-.977A8.024,8.024,0,0,0,311.8,175.789Zm11.465-2.837a5.823,5.823,0,0,0,2.331,1.483,7.568,7.568,0,0,0-1.428,1.956,8.7,8.7,0,0,0-2.067-1.222A7.423,7.423,0,0,0,323.267,172.952Zm11.2-3.329a6.842,6.842,0,0,0,3.214,2.068,5.927,5.927,0,0,0-1.936,2.689,7.47,7.47,0,0,0-2.893-1.673A7.164,7.164,0,0,0,334.47,169.623Zm14.041,8.16a5.965,5.965,0,0,0,4.643,2.142,5.855,5.855,0,0,0-3.232,3.984,6.783,6.783,0,0,0-3.534-2.386A7.094,7.094,0,0,0,348.511,177.783Zm4.268,17.668a6.563,6.563,0,0,0-3.759-2.462,6.749,6.749,0,0,0,2.2-3.929,6.165,6.165,0,0,0,4.829,2.218A5.457,5.457,0,0,0,352.779,195.451Zm-8.647,13.835a5.809,5.809,0,0,0-3.214-2.181,7.716,7.716,0,0,0,1.936-3.289,5.95,5.95,0,0,0,3.4,1.861A5.983,5.983,0,0,0,344.132,209.286Zm-11.6,2.256a6.312,6.312,0,0,0-2.442-1.805,5.762,5.762,0,0,0,1.542-2.443,10.938,10.938,0,0,0,2.575,1.353A7.369,7.369,0,0,0,332.533,211.542ZM321.2,214.193a6.123,6.123,0,0,0-2.575-1.675,8.037,8.037,0,0,0,1.559-2.254,6.962,6.962,0,0,0,2.444,1.353A7.439,7.439,0,0,0,321.2,214.193Zm-11.335,3.081a6.179,6.179,0,0,0-3.215-1.917,7.93,7.93,0,0,0,1.993-2.839,6.854,6.854,0,0,0,2.895,1.711A6.517,6.517,0,0,0,309.865,217.274Zm-6.71-26.991a4.884,4.884,0,0,0,1.8,1.22,5.66,5.66,0,0,0-1.015,1.936,7.218,7.218,0,0,0-2.181-1.033A6.479,6.479,0,0,0,303.155,190.283Zm23.083-5.151c.563.319,1.014.639,1.541.9a4.324,4.324,0,0,0-.827,1.184,6.989,6.989,0,0,0-1.24-.9A3.826,3.826,0,0,0,326.238,185.132Zm11.2-3.534a7.553,7.553,0,0,0,2.708,1.467,5.494,5.494,0,0,0-1.692,2.461,4.858,4.858,0,0,0-2.256-1.466A8.164,8.164,0,0,0,337.44,181.6Zm3.722,15.658a7.91,7.91,0,0,0-2.369-1.748,5.335,5.335,0,0,0,1.467-2.575,6.689,6.689,0,0,0,2.781,1.54A6.8,6.8,0,0,0,341.162,197.256ZM329.7,199.3a3.427,3.427,0,0,0-1.2-1.034c.245-.45.564-.958.828-1.466a4.245,4.245,0,0,0,1.465.639A6.855,6.855,0,0,0,329.7,199.3Zm-11.579,2.52a4.934,4.934,0,0,0-1.429-.772c.264-.4.584-.789.847-1.165.395.264.77.526,1.221.77C318.494,200.977,318.38,201.429,318.117,201.824Zm-11.222,3.4a6.7,6.7,0,0,0-2.443-1.353,10.243,10.243,0,0,0,1.484-2.106,6.961,6.961,0,0,0,1.993,1.317A4.879,4.879,0,0,0,306.895,205.225Zm8.779-16.484a10.352,10.352,0,0,0-.583,1.089,8.634,8.634,0,0,0-1.034-.506,3.786,3.786,0,0,0,.714-1.2A2.76,2.76,0,0,0,315.674,188.741Zm-23.966,3.289a6.087,6.087,0,0,0,3.026,2.067,7.561,7.561,0,0,0-1.881,3.215,5.91,5.91,0,0,0-3.335-1.936A6.315,6.315,0,0,0,291.708,192.03Zm2.706,11.391a6.905,6.905,0,0,0,3.215,2.068,6.466,6.466,0,0,0-1.806,3.42,5.921,5.921,0,0,0-3.609-2.067A7.2,7.2,0,0,0,294.414,203.421Zm4.454,17.782a5.576,5.576,0,0,0-5.112-2.782,6.488,6.488,0,0,0,3.345-4.1,6.837,6.837,0,0,0,3.8,2.386A6.308,6.308,0,0,0,298.868,221.2Zm14.342,9.4a5.7,5.7,0,0,0-5.281-3.609,6.437,6.437,0,0,0,3.289-4.193,6.719,6.719,0,0,0,4.117,2.464A5.961,5.961,0,0,0,313.21,230.6Zm11.147-3.421a6.209,6.209,0,0,0-4.06-3.158,6.294,6.294,0,0,0,2.445-3.648,5.974,5.974,0,0,0,3.759,2.181A5.588,5.588,0,0,0,324.357,227.181Zm11.391-2.575a6.187,6.187,0,0,0-4.06-3.328,6.017,6.017,0,0,0,2.331-3.665A7.147,7.147,0,0,0,338,219.736,5.879,5.879,0,0,0,335.748,224.606Zm11.618-1.711a5.92,5.92,0,0,0-4.775-4.268,6.973,6.973,0,0,0,2.764-4.4,5.6,5.6,0,0,0,5.545,2.218A5.659,5.659,0,0,0,347.366,222.9Zm8.421-14.512a6.242,6.242,0,0,0-4.437-3.947,6.236,6.236,0,0,0,2.518-4.285,5.978,5.978,0,0,0,5.9,2.123A5.745,5.745,0,0,0,355.787,208.383ZM345.43,165.489a5.516,5.516,0,0,0,5.657,2.912,6.2,6.2,0,0,0-3.873,4.381,6.142,6.142,0,0,0-3.909-2.537A6.419,6.419,0,0,0,345.43,165.489Zm-14.192-8.76A5.843,5.843,0,0,0,336.2,160a5.979,5.979,0,0,0-3.083,3.929,6.573,6.573,0,0,0-3.929-2.292A6.489,6.489,0,0,0,331.238,156.729Zm-10.941,4a6.549,6.549,0,0,0,3.421,2.181,6.648,6.648,0,0,0-2.123,3.158,7.839,7.839,0,0,0-3.29-1.861A6.5,6.5,0,0,0,320.3,160.733Zm-11.391,2.839a6.229,6.229,0,0,0,3.215,2.161,6.865,6.865,0,0,0-1.992,3.121,6.394,6.394,0,0,0-3.234-1.806A6.648,6.648,0,0,0,308.906,163.572ZM297.365,165.7a6.369,6.369,0,0,0,3.609,2.745,7.215,7.215,0,0,0-2.181,3.57,5.814,5.814,0,0,0-3.74-2.084A5.4,5.4,0,0,0,297.365,165.7Zm-11.71,1.072a6,6,0,0,0,4.7,4.342,6.364,6.364,0,0,0-2.641,4.3,6.3,6.3,0,0,0-6.051-2.142A5.483,5.483,0,0,0,285.655,166.767Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74136-2",
    "data-name": "Path 74136",
    d: "M267.1,212.068a5.01,5.01,0,0,0,3.733-6.129,5.068,5.068,0,1,0-3.733,6.129Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74137-2",
    "data-name": "Path 74137",
    d: "M255.693,214.193a4.489,4.489,0,0,0,3.3-5.415,4.429,4.429,0,0,0-5.412-3.214,4.307,4.307,0,0,0-3.224,5.339A4.4,4.4,0,0,0,255.693,214.193Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74138-2",
    "data-name": "Path 74138",
    d: "M244.292,216.316a3.843,3.843,0,0,0,2.847-4.568,3.848,3.848,0,1,0-2.847,4.568Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74139-2",
    "data-name": "Path 74139",
    d: "M232.957,218.421a3.212,3.212,0,0,0,2.321-3.853,3.192,3.192,0,1,0-6.184,1.559A3.122,3.122,0,0,0,232.957,218.421Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74140-2",
    "data-name": "Path 74140",
    d: "M221.5,220.544a2.468,2.468,0,0,0,1.917-3.062,2.508,2.508,0,0,0-3.084-2.011,2.6,2.6,0,0,0-1.917,3.231A2.471,2.471,0,0,0,221.5,220.544Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74141-2",
    "data-name": "Path 74141",
    d: "M210.165,222.764a2.018,2.018,0,0,0-.9-3.929,2.036,2.036,0,0,0-1.542,2.443A2.067,2.067,0,0,0,210.165,222.764Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74142-2",
    "data-name": "Path 74142",
    d: "M198.757,224.887a1.367,1.367,0,0,0,1.034-1.673,1.417,1.417,0,0,0-2.764.62A1.36,1.36,0,0,0,198.757,224.887Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74143-2",
    "data-name": "Path 74143",
    d: "M188.005,226.053a.908.908,0,0,0-1.016-.583.8.8,0,0,0-.6,1.034.755.755,0,0,0,.978.564A.806.806,0,0,0,188.005,226.053Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74144-2",
    "data-name": "Path 74144",
    d: "M175.711,229.079c.056.114.112.169.245.114.13-.077.263-.114.206-.245,0-.152-.131-.152-.262-.152C175.767,228.873,175.636,228.948,175.711,229.079Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74145-2",
    "data-name": "Path 74145",
    d: "M454.921,149.267c-.075-.32-.394-.545-.639-.451a.519.519,0,0,0-.45.7.565.565,0,0,0,.7.4A.625.625,0,0,0,454.921,149.267Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74146-2",
    "data-name": "Path 74146",
    d: "M444.227,151.842a1.158,1.158,0,0,0-1.353-.9,1.134,1.134,0,0,0-.847,1.392,1.129,1.129,0,1,0,2.2-.489Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74147-2",
    "data-name": "Path 74147",
    d: "M432.308,156.6a1.821,1.821,0,0,0-.845-3.534,1.778,1.778,0,0,0-1.278,2.181A1.735,1.735,0,0,0,432.308,156.6Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74148-2",
    "data-name": "Path 74148",
    d: "M421.162,159.868a2.431,2.431,0,0,0,1.805-2.875,2.469,2.469,0,0,0-2.9-1.748,2.39,2.39,0,0,0-1.748,2.912A2.341,2.341,0,0,0,421.162,159.868Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74149-2",
    "data-name": "Path 74149",
    d: "M410.073,163.158a2.938,2.938,0,0,0,2.2-3.515,3.032,3.032,0,0,0-3.59-2.2,3.1,3.1,0,0,0-2.2,3.554A2.962,2.962,0,0,0,410.073,163.158Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74150-2",
    "data-name": "Path 74150",
    d: "M398.943,166.523a3.586,3.586,0,0,0-1.672-6.974,3.586,3.586,0,1,0,1.672,6.974Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74151-2",
    "data-name": "Path 74151",
    d: "M387.8,169.887a4.175,4.175,0,1,0-1.935-8.121,4.107,4.107,0,0,0-3.008,5A4.165,4.165,0,0,0,387.8,169.887Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74152-2",
    "data-name": "Path 74152",
    d: "M376.8,173.158a4.788,4.788,0,0,0,3.456-5.733,4.65,4.65,0,0,0-5.713-3.609,4.806,4.806,0,0,0,2.257,9.342Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74153-2",
    "data-name": "Path 74153",
    d: "M365.711,176.522a5.409,5.409,0,1,0-6.578-4.023A5.454,5.454,0,0,0,365.711,176.522Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74154-2",
    "data-name": "Path 74154",
    d: "M264.339,200.79a5.041,5.041,0,1,0-6.128-3.742A5.093,5.093,0,0,0,264.339,200.79Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74155-2",
    "data-name": "Path 74155",
    d: "M252.929,202.913a4.572,4.572,0,0,0,3.355-5.357,4.5,4.5,0,0,0-5.413-3.214,4.407,4.407,0,1,0,2.058,8.571Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74156-2",
    "data-name": "Path 74156",
    d: "M241.594,205.038a3.811,3.811,0,1,0-4.643-2.858A3.837,3.837,0,0,0,241.594,205.038Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74157-2",
    "data-name": "Path 74157",
    d: "M230.26,207.236a3.257,3.257,0,0,0-1.541-6.315,3.185,3.185,0,0,0-2.387,3.929A3.3,3.3,0,0,0,230.26,207.236Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74158-2",
    "data-name": "Path 74158",
    d: "M218.795,209.286a2.539,2.539,0,0,0,1.916-3.083,2.625,2.625,0,0,0-3.158-1.937,2.74,2.74,0,0,0-1.917,3.159A2.6,2.6,0,0,0,218.795,209.286Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74159-2",
    "data-name": "Path 74159",
    d: "M207.459,211.542a2.065,2.065,0,0,0,1.409-2.5,1.985,1.985,0,0,0-3.853.958A2.045,2.045,0,0,0,207.459,211.542Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74160-2",
    "data-name": "Path 74160",
    d: "M195.993,213.665a1.42,1.42,0,0,0-.658-2.762,1.431,1.431,0,0,0-1.015,1.748A1.525,1.525,0,0,0,195.993,213.665Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74161-2",
    "data-name": "Path 74161",
    d: "M185.185,214.812a.779.779,0,0,0-.9-.583.842.842,0,0,0-.659,1,1.048,1.048,0,0,0,1.034.639A.936.936,0,0,0,185.185,214.812Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74162-2",
    "data-name": "Path 74162",
    d: "M173.455,217.669c0-.15-.206-.187-.339-.15-.111,0-.186.15-.186.283.075.13.186.244.319.167C173.38,217.969,173.455,217.8,173.455,217.669Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74163-2",
    "data-name": "Path 74163",
    d: "M452.14,138.045a.434.434,0,0,0-.564-.375.45.45,0,0,0-.395.639.371.371,0,0,0,.583.261A.4.4,0,0,0,452.14,138.045Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74164-2",
    "data-name": "Path 74164",
    d: "M441.463,140.64a1.033,1.033,0,0,0-1.3-.847,1.159,1.159,0,0,0-.844,1.353,1.266,1.266,0,0,0,1.352.847A1.227,1.227,0,0,0,441.463,140.64Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74165-2",
    "data-name": "Path 74165",
    d: "M429.546,145.263a1.826,1.826,0,0,0,1.278-2.067,1.8,1.8,0,0,0-2.067-1.278,1.776,1.776,0,0,0-1.278,2.123A1.7,1.7,0,0,0,429.546,145.263Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74166-2",
    "data-name": "Path 74166",
    d: "M418.456,148.553a2.3,2.3,0,0,0,1.672-2.707,2.39,2.39,0,0,0-2.762-1.747,2.352,2.352,0,0,0-1.673,2.856A2.234,2.234,0,0,0,418.456,148.553Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74167-2",
    "data-name": "Path 74167",
    d: "M407.328,151.842a2.893,2.893,0,0,0,2.106-3.42,2.855,2.855,0,0,0-3.459-2.125,2.854,2.854,0,1,0,1.353,5.545Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74168-2",
    "data-name": "Path 74168",
    d: "M396.181,155.187a3.456,3.456,0,0,0,2.576-4.209,3.387,3.387,0,0,0-4.193-2.481,3.431,3.431,0,0,0-2.519,4.173A3.511,3.511,0,0,0,396.181,155.187Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74169-2",
    "data-name": "Path 74169",
    d: "M385.091,158.515a4.04,4.04,0,0,0,3.025-4.869,4.2,4.2,0,0,0-4.962-3.121,4.113,4.113,0,0,0,1.937,7.99Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74170-2",
    "data-name": "Path 74170",
    d: "M374.019,161.8a4.714,4.714,0,0,0,3.422-5.584,4.641,4.641,0,1,0-3.422,5.584Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74171-2",
    "data-name": "Path 74171",
    d: "M362.93,165.037a5.208,5.208,0,0,0-2.5-10.111,5.208,5.208,0,1,0,2.5,10.111Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74172-2",
    "data-name": "Path 74172",
    d: "M273.032,187.255a5.547,5.547,0,0,0,4-6.635,5.5,5.5,0,1,0-10.7,2.575A5.572,5.572,0,0,0,273.032,187.255Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74173-2",
    "data-name": "Path 74173",
    d: "M261.556,189.324a4.841,4.841,0,1,0-2.321-9.4,4.906,4.906,0,0,0-3.542,5.94A4.844,4.844,0,0,0,261.556,189.324Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74174-2",
    "data-name": "Path 74174",
    d: "M250.223,191.447a4.147,4.147,0,0,0,3.091-5.093,4.246,4.246,0,0,0-5.151-3.159,4.294,4.294,0,0,0-3.091,5.226A4.212,4.212,0,0,0,250.223,191.447Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74175-2",
    "data-name": "Path 74175",
    d: "M238.757,193.647a3.533,3.533,0,0,0,2.706-4.381,3.648,3.648,0,1,0-2.706,4.381Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74176-2",
    "data-name": "Path 74176",
    d: "M227.421,195.789a3.033,3.033,0,0,0,2.256-3.609,3.164,3.164,0,0,0-3.664-2.35,3.12,3.12,0,0,0-2.332,3.742A3.059,3.059,0,0,0,227.421,195.789Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74177-2",
    "data-name": "Path 74177",
    d: "M216.086,198.082A2.6,2.6,0,0,0,217.892,195a2.557,2.557,0,0,0-3.026-1.88A2.5,2.5,0,0,0,213,196.147,2.649,2.649,0,0,0,216.086,198.082Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74178-2",
    "data-name": "Path 74178",
    d: "M204.7,200.151a1.921,1.921,0,0,0,1.355-2.256,1.9,1.9,0,1,0-3.684.9A1.874,1.874,0,0,0,204.7,200.151Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74179-2",
    "data-name": "Path 74179",
    d: "M194.187,200.79a1.284,1.284,0,0,0-1.559-1.033,1.331,1.331,0,0,0-.939,1.614,1.381,1.381,0,0,0,1.6.959A1.27,1.27,0,0,0,194.187,200.79Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74180-2",
    "data-name": "Path 74180",
    d: "M182.4,203.627a.742.742,0,0,0-.9-.581.846.846,0,0,0-.508.939c.056.414.45.545.827.414A.636.636,0,0,0,182.4,203.627Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74181-2",
    "data-name": "Path 74181",
    d: "M170.616,206.522c-.075-.131-.131-.186-.206-.186a.33.33,0,0,0-.113.242c.057.077.113.114.188.077A.162.162,0,0,0,170.616,206.522Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74182-2",
    "data-name": "Path 74182",
    d: "M449.245,126.71a.274.274,0,0,0-.376-.17.589.589,0,0,0-.394.3.472.472,0,0,0,.508.394C449.189,127.162,449.378,126.993,449.245,126.71Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74183-2",
    "data-name": "Path 74183",
    d: "M438.606,129.38a1.044,1.044,0,0,0-1.2-.79,1.013,1.013,0,0,0-.714,1.24.986.986,0,1,0,1.917-.45Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74184-2",
    "data-name": "Path 74184",
    d: "M426.765,133.8a1.539,1.539,0,0,0,1.164-1.842,1.463,1.463,0,0,0-1.861-1.109,1.426,1.426,0,0,0-1.164,1.8A1.484,1.484,0,0,0,426.765,133.8Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74185-2",
    "data-name": "Path 74185",
    d: "M415.618,137.142a2.081,2.081,0,0,0,1.615-2.631,2.116,2.116,0,0,0-2.573-1.484,2.2,2.2,0,0,0-1.617,2.537A2.156,2.156,0,0,0,415.618,137.142Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74186-2",
    "data-name": "Path 74186",
    d: "M404.547,140.526a2.875,2.875,0,0,0,1.992-3.384,2.748,2.748,0,0,0-5.34,1.3A2.9,2.9,0,0,0,404.547,140.526Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74187-2",
    "data-name": "Path 74187",
    d: "M393.4,143.721a3.251,3.251,0,1,0-1.542-6.315,3.219,3.219,0,0,0-2.387,3.873A3.269,3.269,0,0,0,393.4,143.721Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74188-2",
    "data-name": "Path 74188",
    d: "M382.253,147.069a3.862,3.862,0,0,0,2.838-4.776,3.759,3.759,0,0,0-4.643-2.67,3.831,3.831,0,0,0,1.8,7.446Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74189-2",
    "data-name": "Path 74189",
    d: "M371.182,150.225a4.343,4.343,0,1,0-5.284-3.214A4.314,4.314,0,0,0,371.182,150.225Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74190-2",
    "data-name": "Path 74190",
    d: "M360.11,153.515a4.808,4.808,0,0,0,3.534-5.921,4.876,4.876,0,1,0-3.534,5.921Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74191-2",
    "data-name": "Path 74191",
    d: "M348.964,156.729a5.356,5.356,0,0,0,4-6.56,5.487,5.487,0,0,0-6.579-4,5.644,5.644,0,0,0-4.061,6.579A5.467,5.467,0,0,0,348.964,156.729Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74192-2",
    "data-name": "Path 74192",
    d: "M270.185,175.658a5.183,5.183,0,0,0,3.74-6.316,5.112,5.112,0,0,0-6.185-3.722,5,5,0,0,0-3.73,6.184A5.1,5.1,0,0,0,270.185,175.658Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74193-2",
    "data-name": "Path 74193",
    d: "M258.784,177.875a4.686,4.686,0,0,0,3.355-5.62,4.572,4.572,0,1,0-3.355,5.62Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74194-2",
    "data-name": "Path 74194",
    d: "M247.393,180.037a4.046,4.046,0,1,0-4.9-3.026A4.031,4.031,0,0,0,247.393,180.037Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74195-2",
    "data-name": "Path 74195",
    d: "M236.05,182.256a3.563,3.563,0,0,0,2.583-4.267,3.515,3.515,0,1,0-6.823,1.692A3.553,3.553,0,0,0,236.05,182.256Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74196-2",
    "data-name": "Path 74196",
    d: "M224.715,184.418a2.993,2.993,0,0,0,2.067-3.609,2.921,2.921,0,0,0-5.657,1.447A2.965,2.965,0,0,0,224.715,184.418Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74197-2",
    "data-name": "Path 74197",
    d: "M213.268,186.616A2.382,2.382,0,0,0,215,183.74a2.347,2.347,0,0,0-4.568,1.072A2.383,2.383,0,0,0,213.268,186.616Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74198-2",
    "data-name": "Path 74198",
    d: "M201.914,188.741a1.79,1.79,0,0,0,1.3-2.125,1.706,1.706,0,0,0-2.125-1.2,1.63,1.63,0,0,0-1.353,1.975A1.72,1.72,0,0,0,201.914,188.741Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74199-2",
    "data-name": "Path 74199",
    d: "M191.35,189.474a1.14,1.14,0,0,0-1.428-.864,1.218,1.218,0,0,0-.883,1.428,1.294,1.294,0,0,0,1.484.959A1.281,1.281,0,0,0,191.35,189.474Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74200-2",
    "data-name": "Path 74200",
    d: "M179.509,192.35a.617.617,0,0,0-.716-.451.631.631,0,0,0,.319,1.221A.578.578,0,0,0,179.509,192.35Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74201-2",
    "data-name": "Path 74201",
    d: "M167.779,195.189l-.075.056h-.058c0,.131.058.131.058.131C167.779,195.339,167.779,195.339,167.779,195.189Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74202-2",
    "data-name": "Path 74202",
    d: "M446.408,115.563c0-.131-.133-.169-.245-.169-.208,0-.264.169-.264.319,0,.133.189.17.376.17A.253.253,0,0,0,446.408,115.563Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74203-2",
    "data-name": "Path 74203",
    d: "M435.673,118.233a.685.685,0,0,0-.9-.583.694.694,0,0,0-.6.9.772.772,0,0,0,.978.584A.734.734,0,0,0,435.673,118.233Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74204-2",
    "data-name": "Path 74204",
    d: "M424,122.481a1.343,1.343,0,0,0,1.033-1.673,1.285,1.285,0,0,0-1.672-1.033,1.364,1.364,0,0,0-1.034,1.653A1.385,1.385,0,0,0,424,122.481Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74205-2",
    "data-name": "Path 74205",
    d: "M412.854,125.676a1.918,1.918,0,0,0,1.484-2.292,2.055,2.055,0,0,0-2.387-1.428,1.949,1.949,0,0,0-1.353,2.33A1.832,1.832,0,0,0,412.854,125.676Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74206-2",
    "data-name": "Path 74206",
    d: "M401.783,129.041A2.528,2.528,0,0,0,403.588,126a2.376,2.376,0,0,0-2.97-1.785,2.431,2.431,0,0,0-1.861,2.951A2.612,2.612,0,0,0,401.783,129.041Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74207-2",
    "data-name": "Path 74207",
    d: "M390.636,132.255a2.983,2.983,0,0,0,2.181-3.665,2.9,2.9,0,0,0-3.609-2.2,3.019,3.019,0,0,0,1.428,5.865Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74208-2",
    "data-name": "Path 74208",
    d: "M379.509,135.564a3.688,3.688,0,0,0,2.631-4.343,3.776,3.776,0,0,0-4.4-2.706,3.622,3.622,0,0,0-2.445,4.379A3.517,3.517,0,0,0,379.509,135.564Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74209-2",
    "data-name": "Path 74209",
    d: "M368.418,138.834a4.25,4.25,0,0,0,2.97-5.037,4.082,4.082,0,1,0-7.932,1.936A4.235,4.235,0,0,0,368.418,138.834Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74210-2",
    "data-name": "Path 74210",
    d: "M357.271,141.918a4.469,4.469,0,0,0,3.346-5.451,4.568,4.568,0,1,0-8.891,2.1A4.576,4.576,0,0,0,357.271,141.918Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74211-2",
    "data-name": "Path 74211",
    d: "M346.125,145.074a5,5,0,1,0-5.977-3.645A4.918,4.918,0,0,0,346.125,145.074Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74212-2",
    "data-name": "Path 74212",
    d: "M334.978,148.158a5.327,5.327,0,1,0-6.448-3.909A5.312,5.312,0,0,0,334.978,148.158Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74213-2",
    "data-name": "Path 74213",
    d: "M290.026,159.3a5.536,5.536,0,0,0-2.643-10.752,5.537,5.537,0,0,0,2.643,10.752Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74214-2",
    "data-name": "Path 74214",
    d: "M278.691,161.636a5.139,5.139,0,1,0-6.25-3.74A5.179,5.179,0,0,0,278.691,161.636Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74215-2",
    "data-name": "Path 74215",
    d: "M267.355,163.928a4.658,4.658,0,0,0,3.479-5.638,4.737,4.737,0,1,0-9.2,2.254A4.659,4.659,0,0,0,267.355,163.928Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74216-2",
    "data-name": "Path 74216",
    d: "M255.955,166.184a4.148,4.148,0,0,0,3.158-5.076,4.278,4.278,0,1,0-8.307,2.05A4.143,4.143,0,0,0,255.955,166.184Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74217-2",
    "data-name": "Path 74217",
    d: "M244.621,168.534a3.83,3.83,0,0,0,2.772-4.606,3.747,3.747,0,0,0-4.512-2.706,3.814,3.814,0,0,0-2.827,4.511A3.866,3.866,0,0,0,244.621,168.534Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74218-2",
    "data-name": "Path 74218",
    d: "M233.221,170.657a3.173,3.173,0,0,0,2.377-3.815,3.273,3.273,0,0,0-3.929-2.369,3.226,3.226,0,0,0-2.311,3.853A3.137,3.137,0,0,0,233.221,170.657Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74219-2",
    "data-name": "Path 74219",
    d: "M221.876,172.952a2.669,2.669,0,0,0,1.936-3.29,2.743,2.743,0,0,0-3.214-1.992,2.772,2.772,0,0,0-1.992,3.307A2.6,2.6,0,0,0,221.876,172.952Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74220-2",
    "data-name": "Path 74220",
    d: "M210.56,175.207a2.147,2.147,0,0,0,1.467-2.614,2.049,2.049,0,0,0-2.576-1.616,2.165,2.165,0,0,0-1.6,2.633A2.289,2.289,0,0,0,210.56,175.207Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74221-2",
    "data-name": "Path 74221",
    d: "M199.076,177.331a1.553,1.553,0,0,0,1.221-1.918,1.49,1.49,0,0,0-1.917-1.147,1.569,1.569,0,0,0-1.24,1.917A1.519,1.519,0,0,0,199.076,177.331Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74222-2",
    "data-name": "Path 74222",
    d: "M188.53,178.328a1.083,1.083,0,0,0-1.3-.79,1.055,1.055,0,0,0-.77,1.24,1.115,1.115,0,0,0,1.278.772A1.138,1.138,0,0,0,188.53,178.328Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74223-2",
    "data-name": "Path 74223",
    d: "M176.67,181.2a.53.53,0,0,0-.508-.394.6.6,0,0,0-.4.583c.133.206.319.45.583.412A.531.531,0,0,0,176.67,181.2Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74224-2",
    "data-name": "Path 74224",
    d: "M443.513,104.436l-.058-.15c-.131,0-.131,0-.131.15h.189Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74225-2",
    "data-name": "Path 74225",
    d: "M432.816,106.992a.637.637,0,0,0-.752-.45.583.583,0,0,0-.451.769c.039.339.376.453.753.414A.671.671,0,0,0,432.816,106.992Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74226-2",
    "data-name": "Path 74226",
    d: "M422.008,109.662a1.062,1.062,0,0,0-1.353-.865,1.076,1.076,0,1,0,.507,2.087A.967.967,0,0,0,422.008,109.662Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74227-2",
    "data-name": "Path 74227",
    d: "M410.073,114.285a1.738,1.738,0,0,0,1.239-2.048,1.626,1.626,0,0,0-1.992-1.222,1.7,1.7,0,0,0-1.278,2.048A1.729,1.729,0,0,0,410.073,114.285Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74228-2",
    "data-name": "Path 74228",
    d: "M398.943,117.444a2.076,2.076,0,0,0,1.617-2.576,2.118,2.118,0,0,0-2.65-1.692,2.248,2.248,0,0,0-1.6,2.707A2.215,2.215,0,0,0,398.943,117.444Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74229-2",
    "data-name": "Path 74229",
    d: "M387.8,120.677a2.775,2.775,0,0,0,2.069-3.233,2.865,2.865,0,0,0-3.365-2.05,2.835,2.835,0,0,0-1.994,3.328A2.721,2.721,0,0,0,387.8,120.677Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74230-2",
    "data-name": "Path 74230",
    d: "M376.65,123.873a3.178,3.178,0,1,0-1.464-6.185,3.272,3.272,0,0,0-2.332,3.89A3.163,3.163,0,0,0,376.65,123.873Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74231-2",
    "data-name": "Path 74231",
    d: "M365.579,127.124a3.7,3.7,0,0,0-1.748-7.18,3.8,3.8,0,0,0-2.706,4.51A3.733,3.733,0,0,0,365.579,127.124Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74232-2",
    "data-name": "Path 74232",
    d: "M354.432,130.282a4.184,4.184,0,0,0,3.045-4.925,4.076,4.076,0,0,0-4.962-3.026,4.155,4.155,0,0,0-3.1,4.962A4.248,4.248,0,0,0,354.432,130.282Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74233-2",
    "data-name": "Path 74233",
    d: "M343.23,133.308a4.453,4.453,0,0,0,3.345-5.282,4.516,4.516,0,0,0-5.413-3.364,4.445,4.445,0,0,0,2.068,8.646Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74234-2",
    "data-name": "Path 74234",
    d: "M332.083,136.372a4.681,4.681,0,0,0,3.478-5.639,4.735,4.735,0,0,0-5.715-3.7,4.8,4.8,0,0,0-3.495,5.865A4.706,4.706,0,0,0,332.083,136.372Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74235-2",
    "data-name": "Path 74235",
    d: "M320.936,139.342a4.939,4.939,0,0,0,3.609-6,5.026,5.026,0,0,0-6.051-3.741,5.019,5.019,0,0,0,2.442,9.737Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74236-2",
    "data-name": "Path 74236",
    d: "M309.6,142.18a5.1,5.1,0,1,0-2.387-9.925,5.1,5.1,0,0,0,2.387,9.925Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74237-2",
    "data-name": "Path 74237",
    d: "M298.418,144.888a5.085,5.085,0,0,0,3.721-6.054,5.037,5.037,0,1,0-9.792,2.37A5.065,5.065,0,0,0,298.418,144.888Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74238-2",
    "data-name": "Path 74238",
    d: "M287.064,147.463a4.931,4.931,0,0,0,3.676-5.922,4.868,4.868,0,0,0-5.923-3.552,4.716,4.716,0,0,0-3.541,5.865A4.851,4.851,0,0,0,287.064,147.463Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74239-2",
    "data-name": "Path 74239",
    d: "M275.861,149.85a4.57,4.57,0,0,0-2.19-8.874,4.57,4.57,0,1,0,2.19,8.874Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74240-2",
    "data-name": "Path 74240",
    d: "M264.526,152.331a4.337,4.337,0,0,0-2.067-8.421,4.227,4.227,0,0,0-3.082,5.262A4.271,4.271,0,0,0,264.526,152.331Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74241-2",
    "data-name": "Path 74241",
    d: "M253.127,154.587a3.774,3.774,0,0,0,2.828-4.55,3.841,3.841,0,1,0-7.463,1.8A3.806,3.806,0,0,0,253.127,154.587Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74242-2",
    "data-name": "Path 74242",
    d: "M241.792,156.935a3.522,3.522,0,0,0,2.5-4.059,3.436,3.436,0,0,0-4.117-2.576,3.415,3.415,0,0,0,1.617,6.635Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74243-2",
    "data-name": "Path 74243",
    d: "M230.391,159.191a2.981,2.981,0,0,0,2.181-3.5,2.919,2.919,0,1,0-2.181,3.5Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74244-2",
    "data-name": "Path 74244",
    d: "M219.056,161.353a2.4,2.4,0,0,0,1.806-2.838,2.511,2.511,0,0,0-2.9-1.786,2.376,2.376,0,1,0,1.089,4.624Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74245-2",
    "data-name": "Path 74245",
    d: "M207.723,163.609a1.879,1.879,0,0,0-.9-3.646,1.839,1.839,0,0,0-1.353,2.292A1.793,1.793,0,0,0,207.723,163.609Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74246-2",
    "data-name": "Path 74246",
    d: "M196.313,165.864a1.345,1.345,0,0,0-.64-2.612,1.394,1.394,0,0,0-.977,1.673A1.357,1.357,0,0,0,196.313,165.864Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74247-2",
    "data-name": "Path 74247",
    d: "M185.56,167.181a.916.916,0,0,0-1.033-.714.877.877,0,0,0-.583,1.07.793.793,0,0,0,.977.545A.807.807,0,0,0,185.56,167.181Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74248-2",
    "data-name": "Path 74248",
    d: "M173.775,170c-.075-.245-.206-.339-.32-.245-.131,0-.263.131-.263.356.057.133.263.264.377.226C173.7,170.245,173.831,170.112,173.775,170Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74249-2",
    "data-name": "Path 74249",
    d: "M429.735,95.809c0-.133-.189-.264-.32-.264-.264.131-.319.264-.264.4,0,.188.131.225.395.188C429.658,96.128,429.81,95.94,429.735,95.809Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74250-2",
    "data-name": "Path 74250",
    d: "M419.038,98.384a.862.862,0,0,0-1.091-.639.81.81,0,0,0-.581,1.015.857.857,0,1,0,1.672-.376Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74251-2",
    "data-name": "Path 74251",
    d: "M407.253,102.688a1.326,1.326,0,0,0,1.014-1.73,1.361,1.361,0,0,0-1.653-.976,1.511,1.511,0,0,0-1.034,1.692A1.367,1.367,0,0,0,407.253,102.688Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74252-2",
    "data-name": "Path 74252",
    d: "M396.181,105.922a1.89,1.89,0,0,0,1.353-2.331,1.84,1.84,0,0,0-2.255-1.278,1.788,1.788,0,0,0-1.429,2.179A1.881,1.881,0,0,0,396.181,105.922Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74253-2",
    "data-name": "Path 74253",
    d: "M384.96,109.078a2.321,2.321,0,1,0-1.092-4.511,2.237,2.237,0,0,0-1.672,2.744A2.269,2.269,0,0,0,384.96,109.078Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74254-2",
    "data-name": "Path 74254",
    d: "M373.832,112.274a2.809,2.809,0,1,0-1.355-5.451,2.715,2.715,0,0,0-1.934,3.328A2.779,2.779,0,0,0,373.832,112.274Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74255-2",
    "data-name": "Path 74255",
    d: "M362.742,115.394a3.214,3.214,0,0,0,2.386-3.89,3.259,3.259,0,0,0-3.928-2.387,3.293,3.293,0,0,0-2.387,3.89A3.335,3.335,0,0,0,362.742,115.394Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74256-2",
    "data-name": "Path 74256",
    d: "M351.614,118.552a3.65,3.65,0,1,0-1.749-7.087,3.612,3.612,0,0,0-2.651,4.381A3.681,3.681,0,0,0,351.614,118.552Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74257-2",
    "data-name": "Path 74257",
    d: "M340.392,121.578a3.912,3.912,0,1,0-4.756-2.9A3.879,3.879,0,0,0,340.392,121.578Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74258-2",
    "data-name": "Path 74258",
    d: "M329.188,124.587a4.19,4.19,0,0,0,3.1-5.1,4.11,4.11,0,0,0-5.039-3.063,4.159,4.159,0,0,0-3.157,5A4.216,4.216,0,0,0,329.188,124.587Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74259-2",
    "data-name": "Path 74259",
    d: "M317.986,127.443a4.293,4.293,0,0,0,3.214-5.282,4.347,4.347,0,0,0-5.282-3.251,4.39,4.39,0,0,0,2.068,8.533Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74260-2",
    "data-name": "Path 74260",
    d: "M306.764,130.319A4.342,4.342,0,0,0,310,124.906a4.393,4.393,0,0,0-5.34-3.289,4.465,4.465,0,0,0-3.308,5.376A4.512,4.512,0,0,0,306.764,130.319Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74261-2",
    "data-name": "Path 74261",
    d: "M295.5,132.969a4.42,4.42,0,0,0,3.289-5.356,4.437,4.437,0,1,0-8.626,2.086A4.441,4.441,0,0,0,295.5,132.969Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74262-2",
    "data-name": "Path 74262",
    d: "M284.226,135.6a4.257,4.257,0,0,0,3.157-5.207,4.274,4.274,0,1,0-8.307,2.011A4.289,4.289,0,0,0,284.226,135.6Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74263-2",
    "data-name": "Path 74263",
    d: "M272.966,138.045a3.994,3.994,0,1,0-1.878-7.763,4,4,0,1,0,1.878,7.763Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74264-2",
    "data-name": "Path 74264",
    d: "M261.633,140.565a3.786,3.786,0,0,0,2.762-4.551,3.784,3.784,0,1,0-7.349,1.806A3.938,3.938,0,0,0,261.633,140.565Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74265-2",
    "data-name": "Path 74265",
    d: "M250.223,142.819a3.246,3.246,0,0,0,2.575-3.985,3.41,3.41,0,0,0-4.117-2.462,3.282,3.282,0,0,0-2.443,4A3.1,3.1,0,0,0,250.223,142.819Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74266-2",
    "data-name": "Path 74266",
    d: "M238.943,145.207a2.959,2.959,0,0,0,2.135-3.553,2.918,2.918,0,0,0-3.544-2.181,3.01,3.01,0,0,0-2.181,3.609A2.964,2.964,0,0,0,238.943,145.207Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74267-2",
    "data-name": "Path 74267",
    d: "M227.552,147.594a2.6,2.6,0,0,0,1.937-3.1,2.549,2.549,0,1,0-1.937,3.1Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74268-2",
    "data-name": "Path 74268",
    d: "M216.219,149.775a2.078,2.078,0,0,0,1.559-2.445,2.065,2.065,0,1,0-1.559,2.445Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74269-2",
    "data-name": "Path 74269",
    d: "M204.884,152.106a1.626,1.626,0,0,0,1.166-1.937,1.6,1.6,0,1,0-1.166,1.937Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74270-2",
    "data-name": "Path 74270",
    d: "M194.32,152.989a1.187,1.187,0,0,0-1.278-.7,1.054,1.054,0,1,0,1.278.7Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74271-2",
    "data-name": "Path 74271",
    d: "M182.535,155.9a.56.56,0,0,0-.639-.411.669.669,0,0,0-.453.656.5.5,0,0,0,.7.339A.456.456,0,0,0,182.535,155.9Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74272-2",
    "data-name": "Path 74272",
    d: "M170.749,158.741v.055h0C170.8,158.8,170.8,158.8,170.749,158.741Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74273-2",
    "data-name": "Path 74273",
    d: "M426.765,84.587l-.058-.058c-.056,0,0,.133,0,.133v-.075Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74274-2",
    "data-name": "Path 74274",
    d: "M416.013,87.238a.59.59,0,0,0-.639-.4.55.55,0,0,0-.453.639.57.57,0,0,0,.7.4A.581.581,0,0,0,416.013,87.238Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74275-2",
    "data-name": "Path 74275",
    d: "M405.186,89.886a1.031,1.031,0,0,0-1.2-.789,1.07,1.07,0,0,0-.714,1.241.945.945,0,0,0,1.164.695A.931.931,0,0,0,405.186,89.886Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74276-2",
    "data-name": "Path 74276",
    d: "M393.342,94.248a1.552,1.552,0,0,0,1.092-1.8,1.6,1.6,0,0,0-1.806-1.091,1.491,1.491,0,1,0,.714,2.9Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74277-2",
    "data-name": "Path 74277",
    d: "M382.14,97.481a1.967,1.967,0,0,0,1.542-2.386,1.907,1.907,0,0,0-2.445-1.355,1.835,1.835,0,0,0-1.428,2.313A1.971,1.971,0,0,0,382.14,97.481Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74278-2",
    "data-name": "Path 74278",
    d: "M370.993,100.563a2.386,2.386,0,0,0,1.861-2.818,2.415,2.415,0,0,0-2.95-1.692,2.32,2.32,0,0,0,1.089,4.51Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74279-2",
    "data-name": "Path 74279",
    d: "M359.847,103.666a2.717,2.717,0,1,0-3.271-1.936A2.6,2.6,0,0,0,359.847,103.666Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74280-2",
    "data-name": "Path 74280",
    d: "M348.775,106.748a3.08,3.08,0,0,0-1.484-5.977,3.08,3.08,0,1,0,1.484,5.977Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74281-2",
    "data-name": "Path 74281",
    d: "M337.553,109.85a3.459,3.459,0,1,0-4.117-2.539A3.409,3.409,0,0,0,337.553,109.85Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74282-2",
    "data-name": "Path 74282",
    d: "M326.351,112.726a3.6,3.6,0,1,0-1.73-6.993,3.6,3.6,0,1,0,1.73,6.993Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74283-2",
    "data-name": "Path 74283",
    d: "M315.147,115.638a3.757,3.757,0,0,0-1.8-7.293,3.756,3.756,0,1,0,1.8,7.293Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74284-2",
    "data-name": "Path 74284",
    d: "M303.869,118.422a3.831,3.831,0,0,0,2.839-4.587,3.792,3.792,0,0,0-4.644-2.82,3.812,3.812,0,0,0,1.8,7.407Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74285-2",
    "data-name": "Path 74285",
    d: "M292.609,121.164a3.778,3.778,0,0,0,2.839-4.623,3.816,3.816,0,1,0-7.416,1.805A3.724,3.724,0,0,0,292.609,121.164Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74286-2",
    "data-name": "Path 74286",
    d: "M281.332,123.759a3.717,3.717,0,0,0,2.771-4.437,3.712,3.712,0,1,0-7.218,1.731A3.731,3.731,0,0,0,281.332,123.759Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74287-2",
    "data-name": "Path 74287",
    d: "M270.062,126.334a3.463,3.463,0,0,0,2.575-4.267,3.564,3.564,0,0,0-4.182-2.575,3.678,3.678,0,0,0-2.641,4.267A3.557,3.557,0,0,0,270.062,126.334Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74288-2",
    "data-name": "Path 74288",
    d: "M258.784,128.8a3.232,3.232,0,1,0-3.853-2.406A3.176,3.176,0,0,0,258.784,128.8Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74289-2",
    "data-name": "Path 74289",
    d: "M247.393,131.166a2.882,2.882,0,1,0-1.353-5.6,2.882,2.882,0,0,0,1.353,5.6Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74290-2",
    "data-name": "Path 74290",
    d: "M236.116,133.666a2.672,2.672,0,0,0,1.869-3.159,2.522,2.522,0,1,0-4.887,1.242A2.548,2.548,0,0,0,236.116,133.666Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74291-2",
    "data-name": "Path 74291",
    d: "M224.715,135.92a2.146,2.146,0,0,0,1.617-2.574,2.266,2.266,0,0,0-2.651-1.6,2.172,2.172,0,0,0-1.541,2.631A2.127,2.127,0,0,0,224.715,135.92Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74292-2",
    "data-name": "Path 74292",
    d: "M213.455,138.176a1.644,1.644,0,0,0,1.2-1.992,1.729,1.729,0,0,0-2.048-1.223,1.769,1.769,0,0,0-1.3,2.07A1.7,1.7,0,0,0,213.455,138.176Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74293-2",
    "data-name": "Path 74293",
    d: "M202.947,139.079a1.16,1.16,0,0,0-1.409-.9,1.068,1.068,0,0,0-.9,1.447,1.2,1.2,0,0,0,1.41.9A1.3,1.3,0,0,0,202.947,139.079Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74294-2",
    "data-name": "Path 74294",
    d: "M191.237,141.918a.763.763,0,0,0-.9-.584.744.744,0,0,0-.528.9.676.676,0,0,0,.9.506A.656.656,0,0,0,191.237,141.918Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74295-2",
    "data-name": "Path 74295",
    d: "M179.509,144.755c0-.131-.133-.262-.264-.206a.364.364,0,0,0-.264.339c0,.111.208.186.4.186C179.509,145,179.509,144.888,179.509,144.755Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74296-2",
    "data-name": "Path 74296",
    d: "M412.929,76.091a.3.3,0,0,0-.264-.264.394.394,0,0,0-.186.32c.056.225.186.225.3.131C412.929,76.278,412.985,76.241,412.929,76.091Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74297-2",
    "data-name": "Path 74297",
    d: "M402.1,78.664a.628.628,0,0,0-.77-.45.583.583,0,0,0-.508.77.768.768,0,0,0,.828.583A.788.788,0,0,0,402.1,78.664Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74298-2",
    "data-name": "Path 74298",
    d: "M391.275,81.315a1.064,1.064,0,0,0-2.067.508,1.066,1.066,0,1,0,2.067-.508Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74299-2",
    "data-name": "Path 74299",
    d: "M379.358,85.882a1.513,1.513,0,0,0,1.09-1.934,1.519,1.519,0,1,0-2.951.714A1.632,1.632,0,0,0,379.358,85.882Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74300-2",
    "data-name": "Path 74300",
    d: "M368.154,88.835a1.829,1.829,0,0,0,1.43-2.219,1.893,1.893,0,0,0-3.686.864A1.891,1.891,0,0,0,368.154,88.835Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74301-2",
    "data-name": "Path 74301",
    d: "M357.027,92.067a2.348,2.348,0,0,0,1.653-2.837,2.286,2.286,0,0,0-4.435,1.108A2.4,2.4,0,0,0,357.027,92.067Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74302-2",
    "data-name": "Path 74302",
    d: "M345.88,95.037a2.619,2.619,0,1,0-3.158-1.936A2.612,2.612,0,0,0,345.88,95.037Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74303-2",
    "data-name": "Path 74303",
    d: "M334.658,97.97a2.773,2.773,0,0,0,2.068-3.383,2.827,2.827,0,0,0-5.488,1.353A2.776,2.776,0,0,0,334.658,97.97Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74304-2",
    "data-name": "Path 74304",
    d: "M323.456,100.958a3.118,3.118,0,0,0,2.256-3.665A3.044,3.044,0,1,0,319.79,98.7,3.157,3.157,0,0,0,323.456,100.958Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74305-2",
    "data-name": "Path 74305",
    d: "M312.252,103.722a3.04,3.04,0,0,0,2.313-3.74,3.074,3.074,0,0,0-3.8-2.314,3.158,3.158,0,0,0-2.312,3.8A3.058,3.058,0,0,0,312.252,103.722Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74306-2",
    "data-name": "Path 74306",
    d: "M300.974,106.636a3.243,3.243,0,0,0-1.466-6.317,3.242,3.242,0,0,0,1.466,6.317Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74307-2",
    "data-name": "Path 74307",
    d: "M289.772,109.248a3.179,3.179,0,0,0-1.552-6.165,3.252,3.252,0,0,0-2.311,3.872A3.144,3.144,0,0,0,289.772,109.248Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74308-2",
    "data-name": "Path 74308",
    d: "M278.437,111.918a3.089,3.089,0,0,0,2.321-3.742,3.046,3.046,0,0,0-3.73-2.254,3.08,3.08,0,1,0,1.409,6Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74309-2",
    "data-name": "Path 74309",
    d: "M267.234,114.493a2.844,2.844,0,0,0,2.048-3.478,2.9,2.9,0,0,0-3.468-2.218,3.07,3.07,0,0,0-2.189,3.571A2.994,2.994,0,0,0,267.234,114.493Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74310-2",
    "data-name": "Path 74310",
    d: "M255.889,117.068a2.78,2.78,0,0,0,1.992-3.308,2.56,2.56,0,0,0-3.214-1.937,2.719,2.719,0,0,0-2.058,3.251A2.818,2.818,0,0,0,255.889,117.068Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74311-2",
    "data-name": "Path 74311",
    d: "M244.554,119.492a2.482,2.482,0,0,0,1.806-2.951,2.389,2.389,0,0,0-2.9-1.728,2.4,2.4,0,1,0,1.1,4.679Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74312-2",
    "data-name": "Path 74312",
    d: "M233.286,121.88a2.075,2.075,0,0,0,1.477-2.519,2.111,2.111,0,0,0-2.445-1.542,2.173,2.173,0,0,0-1.551,2.539A2.028,2.028,0,0,0,233.286,121.88Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74313-2",
    "data-name": "Path 74313",
    d: "M221.876,124.286a1.789,1.789,0,0,0,1.3-2.086,1.735,1.735,0,0,0-2.048-1.278,1.841,1.841,0,0,0-1.316,2.048A1.758,1.758,0,0,0,221.876,124.286Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74314-2",
    "data-name": "Path 74314",
    d: "M211.519,125.037a1.24,1.24,0,0,0-1.485-.9A1.33,1.33,0,0,0,209,125.676a1.355,1.355,0,0,0,1.617.9A1.278,1.278,0,0,0,211.519,125.037Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74315-2",
    "data-name": "Path 74315",
    d: "M199.846,127.895a.855.855,0,1,0-1.672.357,1.058,1.058,0,0,0,1.108.714A.9.9,0,0,0,199.846,127.895Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74316-2",
    "data-name": "Path 74316",
    d: "M188.136,130.733a.282.282,0,0,0-.4-.281c-.263,0-.375.186-.375.45a.423.423,0,0,0,.525.189A.267.267,0,0,0,188.136,130.733Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74317-2",
    "data-name": "Path 74317",
    d: "M399.02,67.518c0-.131-.207-.169-.338-.169-.114,0-.189.169-.189.321s.189.242.32.242A.284.284,0,0,0,399.02,67.518Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74318-2",
    "data-name": "Path 74318",
    d: "M388.193,70.168a.748.748,0,0,0-.847-.525.735.735,0,0,0-.583.864.8.8,0,0,0,.9.489A.641.641,0,0,0,388.193,70.168Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74319-2",
    "data-name": "Path 74319",
    d: "M377.289,72.8a1.135,1.135,0,0,0-1.333-.771,1.08,1.08,0,0,0-.715,1.222,1.049,1.049,0,0,0,2.048-.451Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74320-2",
    "data-name": "Path 74320",
    d: "M365.317,77.256a1.6,1.6,0,0,0,1.109-1.787,1.476,1.476,0,0,0-1.806-1.033,1.331,1.331,0,0,0-1.033,1.655A1.6,1.6,0,0,0,365.317,77.256Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74321-2",
    "data-name": "Path 74321",
    d: "M354.17,80.3a1.8,1.8,0,0,0,1.3-2.218,1.823,1.823,0,0,0-2.125-1.353,1.89,1.89,0,0,0-1.278,2.217A1.751,1.751,0,0,0,354.17,80.3Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74322-2",
    "data-name": "Path 74322",
    d: "M342.966,83.232a2.016,2.016,0,0,0,1.561-2.481,2.065,2.065,0,0,0-4,1.016A2,2,0,0,0,342.966,83.232Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74323-2",
    "data-name": "Path 74323",
    d: "M331.839,86.277a2.366,2.366,0,0,0,1.655-2.818A2.229,2.229,0,0,0,330.73,81.9a2.171,2.171,0,0,0-1.673,2.631A2.372,2.372,0,0,0,331.839,86.277Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74324-2",
    "data-name": "Path 74324",
    d: "M320.561,89.1a2.419,2.419,0,0,0,1.879-2.931,2.489,2.489,0,0,0-4.849,1.127A2.411,2.411,0,0,0,320.561,89.1Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74325-2",
    "data-name": "Path 74325",
    d: "M309.357,91.936a2.53,2.53,0,0,0,1.919-3.1,2.586,2.586,0,0,0-5.02,1.24A2.517,2.517,0,0,0,309.357,91.936Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74326-2",
    "data-name": "Path 74326",
    d: "M298.155,94.775a2.691,2.691,0,0,0,1.916-3.233,2.726,2.726,0,0,0-3.214-1.918A2.69,2.69,0,0,0,295,92.839,2.6,2.6,0,0,0,298.155,94.775Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74327-2",
    "data-name": "Path 74327",
    d: "M286.867,97.406a2.619,2.619,0,0,0,1.946-3.083,2.62,2.62,0,0,0-5.1,1.222A2.538,2.538,0,0,0,286.867,97.406Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74328-2",
    "data-name": "Path 74328",
    d: "M275.6,100.188a2.625,2.625,0,0,0,1.881-3.12,2.534,2.534,0,0,0-3.035-1.806,2.531,2.531,0,0,0,1.154,4.926Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74329-2",
    "data-name": "Path 74329",
    d: "M264.339,102.632A2.25,2.25,0,0,0,266,99.868a2.369,2.369,0,0,0-2.771-1.747,2.23,2.23,0,0,0-1.675,2.837A2.288,2.288,0,0,0,264.339,102.632Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74330-2",
    "data-name": "Path 74330",
    d: "M253.06,105.283a2.163,2.163,0,0,0,1.542-2.651,2.046,2.046,0,0,0-2.576-1.505,2.018,2.018,0,0,0-1.54,2.539A2.248,2.248,0,0,0,253.06,105.283Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74331-2",
    "data-name": "Path 74331",
    d: "M241.726,107.65a1.824,1.824,0,1,0-.9-3.534,1.824,1.824,0,1,0,.9,3.534Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74332-2",
    "data-name": "Path 74332",
    d: "M230.391,110.151a1.537,1.537,0,0,0,1.147-1.937,1.558,1.558,0,0,0-3.025.734A1.571,1.571,0,0,0,230.391,110.151Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74333-2",
    "data-name": "Path 74333",
    d: "M219.959,111.053a1.239,1.239,0,0,0-1.5-.9,1.388,1.388,0,0,0-.9,1.5,1.443,1.443,0,0,0,1.5.958A1.354,1.354,0,0,0,219.959,111.053Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74334-2",
    "data-name": "Path 74334",
    d: "M208.362,113.91a.89.89,0,0,0-1.034-.734.867.867,0,0,0-.639,1.109.908.908,0,0,0,1.09.658A.809.809,0,0,0,208.362,113.91Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74335-2",
    "data-name": "Path 74335",
    d: "M196.632,116.749c0-.283-.189-.32-.4-.32a.443.443,0,0,0-.375.487c.131.283.32.414.525.32A.324.324,0,0,0,196.632,116.749Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74336-2",
    "data-name": "Path 74336",
    d: "M385.091,59.022a.406.406,0,0,0-.395-.206c-.112,0-.189.206-.189.206.077.244.189.338.339.338C384.96,59.36,385.091,59.154,385.091,59.022Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74337-2",
    "data-name": "Path 74337",
    d: "M374.152,61.655a.763.763,0,0,0-.772-.452.638.638,0,0,0-.45.771.6.6,0,0,0,.714.451A.7.7,0,0,0,374.152,61.655Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74338-2",
    "data-name": "Path 74338",
    d: "M363.192,64.361a.927.927,0,0,0-1.165-.714.916.916,0,0,0-.7,1.165,1.055,1.055,0,0,0,1.147.733A.973.973,0,0,0,363.192,64.361Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74339-2",
    "data-name": "Path 74339",
    d: "M352.253,67.012a1.316,1.316,0,0,0-1.542-.978,1.361,1.361,0,0,0-.9,1.559,1.316,1.316,0,0,0,1.541.9A1.27,1.27,0,0,0,352.253,67.012Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74340-2",
    "data-name": "Path 74340",
    d: "M340.148,71.579a1.616,1.616,0,0,0,1.089-1.936,1.478,1.478,0,0,0-1.8-1.072,1.432,1.432,0,0,0-1.089,1.842A1.547,1.547,0,0,0,340.148,71.579Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74341-2",
    "data-name": "Path 74341",
    d: "M328.944,74.436a1.791,1.791,0,0,0,1.278-2.087,1.746,1.746,0,0,0-2.067-1.278,1.688,1.688,0,0,0-1.279,2.142A1.794,1.794,0,0,0,328.944,74.436Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74342-2",
    "data-name": "Path 74342",
    d: "M317.722,77.386a1.9,1.9,0,0,0,1.353-2.331,1.824,1.824,0,1,0-3.534.9A1.93,1.93,0,0,0,317.722,77.386Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74343-2",
    "data-name": "Path 74343",
    d: "M306.52,80.15a1.98,1.98,0,0,0,1.409-2.386,1.96,1.96,0,0,0-3.8.975A2.112,2.112,0,0,0,306.52,80.15Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74344-2",
    "data-name": "Path 74344",
    d: "M295.259,82.913a1.988,1.988,0,1,0-.977-3.854,2,2,0,0,0-1.429,2.389A1.945,1.945,0,0,0,295.259,82.913Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74345-2",
    "data-name": "Path 74345",
    d: "M283.972,85.621a1.926,1.926,0,0,0,1.542-2.389,2.05,2.05,0,0,0-2.444-1.465,2.012,2.012,0,0,0-1.409,2.443A1.891,1.891,0,0,0,283.972,85.621Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74346-2",
    "data-name": "Path 74346",
    d: "M272.77,88.271a1.785,1.785,0,0,0,1.353-2.256,1.886,1.886,0,0,0-2.256-1.428,1.987,1.987,0,0,0-1.418,2.331A1.893,1.893,0,0,0,272.77,88.271Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74347-2",
    "data-name": "Path 74347",
    d: "M261.49,90.9a1.7,1.7,0,0,0,1.232-2.125,1.762,1.762,0,0,0-2.067-1.353,1.789,1.789,0,0,0,.835,3.478Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74348-2",
    "data-name": "Path 74348",
    d: "M250.157,93.42a1.585,1.585,0,0,0,1.23-1.878,1.686,1.686,0,0,0-1.936-1.279,1.664,1.664,0,0,0-1.155,2.068A1.524,1.524,0,0,0,250.157,93.42Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74349-2",
    "data-name": "Path 74349",
    d: "M239.846,94.361a1.386,1.386,0,0,0-1.6-1.072,1.325,1.325,0,0,0-.968,1.673,1.318,1.318,0,1,0,2.566-.6Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74350-2",
    "data-name": "Path 74350",
    d: "M228.324,97.162a1.006,1.006,0,0,0-1.3-.772,1.05,1.05,0,0,0-.77,1.278,1.066,1.066,0,0,0,2.067-.506Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74351-2",
    "data-name": "Path 74351",
    d: "M216.725,99.924a.647.647,0,0,0-.9-.506.727.727,0,0,0-.508.9.748.748,0,0,0,.9.508A.685.685,0,0,0,216.725,99.924Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74352-2",
    "data-name": "Path 74352",
    d: "M205.2,102.763a.357.357,0,0,0-.45-.283c-.264.094-.4.208-.32.452a.577.577,0,0,0,.506.339A.749.749,0,0,0,205.2,102.763Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74353-2",
    "data-name": "Path 74353",
    d: "M370.937,50.526a.736.736,0,0,0-.208-.056c-.055,0-.055.056-.055.113,0,0,.055.112.131.112C370.862,50.695,370.937,50.583,370.937,50.526Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74354-2",
    "data-name": "Path 74354",
    d: "M359.977,53.234c-.13-.283-.319-.4-.581-.322-.188,0-.319.264-.263.489a.37.37,0,0,0,.45.283C359.847,53.684,359.977,53.4,359.977,53.234Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74355-2",
    "data-name": "Path 74355",
    d: "M348.964,55.865a.689.689,0,0,0-.847-.527.7.7,0,0,0-.506.9.811.811,0,0,0,.9.526A.83.83,0,0,0,348.964,55.865Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74356-2",
    "data-name": "Path 74356",
    d: "M337.948,58.571a.957.957,0,1,0-.639,1.147A.943.943,0,0,0,337.948,58.571Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74357-2",
    "data-name": "Path 74357",
    d: "M326.876,61.278a1.089,1.089,0,0,0-1.278-.826,1.134,1.134,0,0,0-.9,1.353,1.174,1.174,0,0,0,1.391.751A1.074,1.074,0,0,0,326.876,61.278Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74358-2",
    "data-name": "Path 74358",
    d: "M315.786,63.984a1.285,1.285,0,0,0-1.54-.976,1.3,1.3,0,0,0,.581,2.537A1.348,1.348,0,0,0,315.786,63.984Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74359-2",
    "data-name": "Path 74359",
    d: "M303.681,68.365a1.505,1.505,0,0,0,.977-1.673,1.547,1.547,0,0,0-1.691-1.109,1.486,1.486,0,0,0-1.015,1.766A1.518,1.518,0,0,0,303.681,68.365Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74360-2",
    "data-name": "Path 74360",
    d: "M292.347,71.071a1.283,1.283,0,0,0,1.034-1.673,1.311,1.311,0,0,0-1.673-1.033,1.365,1.365,0,0,0-1.035,1.692A1.311,1.311,0,0,0,292.347,71.071Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74361-2",
    "data-name": "Path 74361",
    d: "M281.143,73.835a1.382,1.382,0,0,0,1.024-1.75,1.438,1.438,0,0,0-1.673-1.014,1.338,1.338,0,0,0-1.024,1.73A1.3,1.3,0,0,0,281.143,73.835Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74362-2",
    "data-name": "Path 74362",
    d: "M270.834,74.888a1.3,1.3,0,0,0-1.608-1,1.33,1.33,0,0,0,.584,2.6A1.324,1.324,0,0,0,270.834,74.888Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74363-2",
    "data-name": "Path 74363",
    d: "M259.5,77.631a1.289,1.289,0,0,0-1.409-.9,1.165,1.165,0,0,0-.9,1.484,1.08,1.08,0,0,0,1.409.9A1.227,1.227,0,0,0,259.5,77.631Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74364-2",
    "data-name": "Path 74364",
    d: "M248.042,80.414a.935.935,0,0,0-1.164-.714,1.032,1.032,0,0,0-.838,1.22,1,1,0,0,0,1.223.734A.943.943,0,0,0,248.042,80.414Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74365-2",
    "data-name": "Path 74365",
    d: "M236.566,83.176a.8.8,0,0,0-.968-.583.833.833,0,0,0,.394,1.617A.817.817,0,0,0,236.566,83.176Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74366-2",
    "data-name": "Path 74366",
    d: "M225.11,86.015a.579.579,0,0,0-.639-.452c-.339.058-.451.377-.395.714a.553.553,0,0,0,.639.452A.63.63,0,0,0,225.11,86.015Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74367-2",
    "data-name": "Path 74367",
    d: "M213.568,88.835c-.055-.113-.113-.244-.3-.244a.23.23,0,0,0-.152.319c0,.131.152.32.264.262C213.568,89.1,213.643,88.985,213.568,88.835Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74368-2",
    "data-name": "Path 74368",
    d: "M345.749,44.718c-.075-.113-.133-.057-.188-.057-.131,0-.264.057-.206.188.075.075.131.206.261.206A.306.306,0,0,0,345.749,44.718Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74369-2",
    "data-name": "Path 74369",
    d: "M334.658,47.425c-.055-.245-.188-.32-.45-.32-.264.114-.377.264-.264.526a.306.306,0,0,0,.451.244A.33.33,0,0,0,334.658,47.425Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74370-2",
    "data-name": "Path 74370",
    d: "M323.587,50.131a.65.65,0,0,0-.658-.45.677.677,0,0,0-.451.695c.15.319.414.544.714.452A.564.564,0,0,0,323.587,50.131Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74371-2",
    "data-name": "Path 74371",
    d: "M312.515,52.837a.754.754,0,0,0-.845-.564.774.774,0,0,0-.583.9.665.665,0,0,0,.845.508A.844.844,0,0,0,312.515,52.837Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74372-2",
    "data-name": "Path 74372",
    d: "M301.35,55.546a.742.742,0,0,0-.94-.584.8.8,0,0,0-.6.978.75.75,0,0,0,.976.581A.729.729,0,0,0,301.35,55.546Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74373-2",
    "data-name": "Path 74373",
    d: "M290.091,58.252a.752.752,0,0,0-.968-.583.824.824,0,1,0,.4,1.6A.776.776,0,0,0,290.091,58.252Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74374-2",
    "data-name": "Path 74374",
    d: "M278.812,61.033c-.121-.45-.506-.733-.884-.581a.758.758,0,0,0-.656.939.861.861,0,0,0,1.034.583A.7.7,0,0,0,278.812,61.033Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74375-2",
    "data-name": "Path 74375",
    d: "M267.554,63.739a.789.789,0,0,0-.9-.544.861.861,0,0,0-.583.9.753.753,0,0,0,.9.584A.846.846,0,0,0,267.554,63.739Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74376-2",
    "data-name": "Path 74376",
    d: "M256.143,66.559a.636.636,0,0,0-.7-.45.625.625,0,0,0-.452.695c.067.414.394.545.781.452A.516.516,0,0,0,256.143,66.559Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74377-2",
    "data-name": "Path 74377",
    d: "M244.743,69.267a.44.44,0,0,0-.508-.319.522.522,0,0,0-.328.564.406.406,0,0,0,.526.337A.469.469,0,0,0,244.743,69.267Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74378-2",
    "data-name": "Path 74378",
    d: "M233.352,72.085c0-.111-.2-.225-.4-.186-.121,0-.188.186-.121.319,0,.131.186.264.319.264A.365.365,0,0,0,233.352,72.085Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74379-2",
    "data-name": "Path 74379",
    d: "M221.876,74.888h0Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74380-2",
    "data-name": "Path 74380",
    d: "M309.226,41.691c-.075-.056-.131-.112-.206-.112-.058.056-.114.112-.058.187a.267.267,0,0,0,.133.038A.124.124,0,0,0,309.226,41.691Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74381-2",
    "data-name": "Path 74381",
    d: "M298,44.4c0-.058-.113-.133-.244-.058-.131.058-.131.058-.131.17,0,.15.131.15.262.15C297.968,44.661,298,44.511,298,44.4Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74382-2",
    "data-name": "Path 74382",
    d: "M286.811,47.1a.46.46,0,0,0-.254-.131c-.14.075-.263.206-.2.245,0,.15.2.281.264.281C286.744,47.5,286.811,47.219,286.811,47.1Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74383-2",
    "data-name": "Path 74383",
    d: "M275.532,49.887s-.121-.206-.254-.131c-.131,0-.2.169-.2.169.065.15.2.32.329.281C275.532,50.206,275.6,50.019,275.532,49.887Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74384-2",
    "data-name": "Path 74384",
    d: "M264.264,52.631c0-.038-.133-.13-.254-.13,0,0-.123.13-.123.225a.55.55,0,0,0,.189.186C264.264,52.837,264.264,52.782,264.264,52.631Z",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74385-2",
    "data-name": "Path 74385",
    d: "M252.929,55.338H252.8v.075c0,.075,0,.075.066.075C252.864,55.488,252.929,55.488,252.929,55.338Z",
    fill: "#aec2fd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_141972",
    "data-name": "Group 141972",
    transform: "translate(-334 -121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73803",
    "data-name": "Path 73803",
    d: "M358.152,183.069c-23.6,8.159-46.034,25.628-63.7,41.915-36.8,33.916-42.288,41.047-87.684,69.522-26.457,16.6-47.317,30.631-57.594,49.4-28.87,52.73,5.517,109.682,77.574,109.682H519.661s34.456.724,59.6-27.46c85.219-95.523-56.125-300.1-221.109-243.062",
    transform: "translate(920.142 48.637)",
    fill: "#ecf5ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_141958",
    "data-name": "Group 141958",
    transform: "translate(1059.103 221.832)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54527",
    "data-name": "Rectangle 54527",
    width: 176.312,
    height: 254.185,
    transform: "translate(157.558 26.178)",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54528",
    "data-name": "Rectangle 54528",
    width: 176.312,
    height: 254.185,
    transform: "translate(160.137 26.178)",
    fill: "#d0e0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73804",
    "data-name": "Path 73804",
    d: "M1276.813,571.265l.458,42.612H1115.6v-235.8h161.214Z",
    transform: "translate(-947.876 -342.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73805",
    "data-name": "Path 73805",
    d: "M1398.495,234.5a4.722,4.722,0,1,0,4.722,4.722,4.722,4.722,0,0,0-4.722-4.722m-13.406,4.722c1.6-4.733,6-8.707,13.406-8.707s11.806,3.975,13.406,8.707c9,0,23.537,6.36,25.213,16.634h-77.237C1361.552,245.585,1376.094,239.224,1385.089,239.224Z",
    transform: "translate(-1150.202 -220.673)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_141956",
    "data-name": "Group 141956",
    transform: "translate(1059.103 221.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73806",
    "data-name": "Path 73806",
    d: "M1234.311,472.717h112.7a4.989,4.989,0,0,1,4.974,4.974v19.541a4.989,4.989,0,0,1-4.974,4.974h-112.7a4.989,4.989,0,0,1-4.974-4.974V477.691a4.989,4.989,0,0,1,4.974-4.974",
    transform: "translate(-1042.44 -421.279)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73839",
    "data-name": "Path 73839",
    d: "M1247.277,1421.077h-16.731a2.115,2.115,0,0,0-1.5.624h0a2.112,2.112,0,0,0-.619,1.5v16.731a2.131,2.131,0,0,0,2.122,2.122h16.731a2.111,2.111,0,0,0,1.5-.619v0a2.116,2.116,0,0,0,.624-1.5V1423.2a2.113,2.113,0,0,0-.619-1.5l0,0a2.112,2.112,0,0,0-1.5-.619m-16.731-2.539h16.731a4.648,4.648,0,0,1,3.288,1.368l.005,0a4.65,4.65,0,0,1,1.368,3.289v16.731a4.65,4.65,0,0,1-1.368,3.293l0,0a4.647,4.647,0,0,1-3.291,1.371h-16.731a4.672,4.672,0,0,1-4.661-4.661V1423.2a4.649,4.649,0,0,1,1.371-3.291l0,0A4.648,4.648,0,0,1,1230.545,1418.538Z",
    transform: "translate(-1039.221 -1204.669)",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73847",
    "data-name": "Path 73847",
    d: "M1247.277,1196.421h-16.731a2.114,2.114,0,0,0-1.5.624h0a2.111,2.111,0,0,0-.619,1.5v16.731a2.131,2.131,0,0,0,2.122,2.122h16.731a2.113,2.113,0,0,0,1.5-.619v0a2.117,2.117,0,0,0,.624-1.5v-16.731a2.112,2.112,0,0,0-.619-1.5l0,0a2.111,2.111,0,0,0-1.5-.62m-16.731-2.539h16.731a4.648,4.648,0,0,1,3.288,1.368l.005,0a4.649,4.649,0,0,1,1.368,3.288v16.731a4.649,4.649,0,0,1-1.368,3.293l0,0a4.647,4.647,0,0,1-3.291,1.371h-16.731a4.672,4.672,0,0,1-4.661-4.661v-16.731a4.649,4.649,0,0,1,1.371-3.291l0,0A4.647,4.647,0,0,1,1230.545,1193.882Z",
    transform: "translate(-1039.221 -1018.594)",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73848",
    "data-name": "Path 73848",
    d: "M1230.393,1211.522l14.008-13.062a2.708,2.708,0,1,1,3.687,3.967l-16.072,14.977-.04.033a2.716,2.716,0,0,1-3.817-.254l-7.742-8.862a2.706,2.706,0,0,1,4.071-3.566Z",
    transform: "translate(-1034.141 -1021.788)",
    fill: "#f85c24",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73849",
    "data-name": "Path 73849",
    d: "M1456.211,1204.068h22.5a1.635,1.635,0,1,1,0,3.27h-22.5a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(-1228.639 -1027.031)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73850",
    "data-name": "Path 73850",
    d: "M1456.211,1254.717H1496.3a1.635,1.635,0,0,1,0,3.27h-40.091a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(-1228.639 -1068.982)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73851",
    "data-name": "Path 73851",
    d: "M1740.3,1254.717h13.8a1.635,1.635,0,1,1,0,3.27h-13.8a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(-1463.94 -1068.982)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73852",
    "data-name": "Path 73852",
    d: "M1456.211,1303.461h10.006a1.635,1.635,0,1,1,0,3.27h-10.006a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(-1228.639 -1109.355)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73853",
    "data-name": "Path 73853",
    d: "M1554.27,1303.461h35.283a1.635,1.635,0,1,1,0,3.27H1554.27a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(-1309.858 -1109.355)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73854",
    "data-name": "Path 73854",
    d: "M1799.517,1303.461h16.006a1.635,1.635,0,0,1,0,3.27h-16.006a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(-1512.987 -1109.355)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73855",
    "data-name": "Path 73855",
    d: "M1230.393,1445.283l14.008-13.062a2.708,2.708,0,1,1,3.687,3.967l-16.072,14.977-.04.033a2.716,2.716,0,0,1-3.817-.254l-7.742-8.862a2.706,2.706,0,0,1,4.071-3.566Z",
    transform: "translate(-1034.141 -1215.403)",
    fill: "#f85c24",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73856",
    "data-name": "Path 73856",
    d: "M1456.211,1437.829h22.5a1.635,1.635,0,1,1,0,3.27h-22.5a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(-1228.639 -1220.647)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73857",
    "data-name": "Path 73857",
    d: "M1456.211,1488.477H1496.3a1.635,1.635,0,0,1,0,3.27h-40.091a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(-1228.639 -1262.597)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73858",
    "data-name": "Path 73858",
    d: "M1740.3,1488.477h13.8a1.635,1.635,0,1,1,0,3.27h-13.8a1.635,1.635,0,1,1,0-3.27",
    transform: "translate(-1463.94 -1262.597)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73859",
    "data-name": "Path 73859",
    d: "M1456.211,1537.221h10.006a1.635,1.635,0,0,1,0,3.27h-10.006a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(-1228.639 -1302.97)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73860",
    "data-name": "Path 73860",
    d: "M1554.27,1537.221h35.283a1.635,1.635,0,1,1,0,3.27H1554.27a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(-1309.858 -1302.97)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73861",
    "data-name": "Path 73861",
    d: "M1799.517,1537.221h16.006a1.635,1.635,0,0,1,0,3.27h-16.006a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(-1512.987 -1302.97)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73862",
    "data-name": "Path 73862",
    d: "M1225.591,780.487h22.5a1.635,1.635,0,1,1,0,3.27h-22.5a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(-1037.624 -676.194)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73863",
    "data-name": "Path 73863",
    d: "M1225.591,831.135h40.09a1.635,1.635,0,0,1,0,3.27h-40.09a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(-1037.624 -718.144)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73864",
    "data-name": "Path 73864",
    d: "M1225.591,879.879H1235.6a1.635,1.635,0,1,1,0,3.27h-10.006a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(-1037.624 -758.517)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73865",
    "data-name": "Path 73865",
    d: "M1323.65,879.879h35.283a1.635,1.635,0,1,1,0,3.27H1323.65a1.635,1.635,0,1,1,0-3.27",
    transform: "translate(-1118.843 -758.517)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73867",
    "data-name": "Path 73867",
    d: "M1509.68,928.642h13.8a1.635,1.635,0,0,1,0,3.27h-13.8a1.635,1.635,0,1,1,0-3.27",
    transform: "translate(-1272.925 -798.905)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73869",
    "data-name": "Path 73869",
    d: "M1225.591,1033.463h23.124a1.635,1.635,0,1,1,0,3.27h-23.124a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(-1037.624 -885.725)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    id: "RESUME",
    transform: "translate(208.897 73.168)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RESUME"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_141957",
    "data-name": "Group 141957",
    transform: "translate(1059.103 221.832)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54529",
    "data-name": "Rectangle 54529",
    width: 45.725,
    height: 53.341,
    transform: "translate(262.528 104.293)",
    fill: "#d0e0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73840",
    "data-name": "Path 73840",
    d: "M1697.665,944.12c-15.785-.239-17.21,11.778-17.519,25.144h42.435c-.333-10.375-3.409-26.828-17.35-25.139,0,0,1.006,5.029-2.652,5.388-4.093-.2-4.255-3.526-4.915-5.393",
    transform: "translate(-1415.471 -811.63)",
    fill: "#1d3975"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73841",
    "data-name": "Path 73841",
    d: "M1821.148,942.56l-.294,3.78-1.2,21.727h2.646l3.755-14.583-2.557-2.9,1.918-2.175-.943-5.274a10.352,10.352,0,0,0-3.328-.576",
    transform: "translate(-1531.022 -810.433)",
    fill: "#6d6e9b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73842",
    "data-name": "Path 73842",
    d: "M1761.423,942.56l.717,3.418,3.684,22.089h-2.546l-5.114-14.144,2.209-3.247-2.146-1.879.257-5.646a20.749,20.749,0,0,1,2.939-.591",
    transform: "translate(-1480.09 -810.433)",
    fill: "#6d6e9b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73893",
    "data-name": "Path 73893",
    d: "M1783.9,939.885c.579,4.932-.553,16-1.644,25.507h-4.11c-1.9-9.793-4.2-22.067-4.558-25.507a24.2,24.2,0,0,1,10.312,0",
    transform: "translate(-1492.865 -807.758)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73844",
    "data-name": "Path 73844",
    d: "M1801.809,994.115q-.084.744-.168,1.478h-4.22c-.142-.738-.286-1.491-.431-2.253l1.251-13.234-.9-2.128,1.68-2.186,1.668,2.226-.93,2.05Z",
    transform: "translate(-1512.248 -837.958)",
    fill: "#f85c24",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73845",
    "data-name": "Path 73845",
    d: "M1779.758,909.617a5.448,5.448,0,0,1,.517,3.253c-.042.943-.028,1.906-.112,2.842l-.032.347c.629,1.874.952,4.774,4.954,4.972,3.653-.359,2.654-5.375,2.651-5.387a3.916,3.916,0,0,1-.178-1.042,3.726,3.726,0,0,1,.115-1c.05-.232.275-.879.137-.826Z",
    transform: "translate(-1497.976 -783.147)",
    fill: "#f7aaac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73846",
    "data-name": "Path 73846",
    d: "M1779.831,824.075s3.844,13.934-2.714,15.78a8.459,8.459,0,0,1-9.06-4.119s-4.833-3.185-2.142-5.82a1.552,1.552,0,0,1,1.922,0l-1.153-5.821,4.393-4.008,5.147,2.045Z",
    transform: "translate(-1485.835 -708.993)",
    fill: "#f7aaac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73892",
    "data-name": "Path 73892",
    d: "M1757.445,820.228a5.457,5.457,0,0,1,3.385-5.453c5-2.416,8.661.207,10.163.94,1.039.507,1.694.914,2.723,1.373,2.575,1.148,2.151,6.383-.193,7.805-.233.141-.242-2.324-.494-2.208a2.283,2.283,0,0,1-.609.211c-3.52.937-6.751-1.778-9.067,0-1.146.878-1.391,2.45-.886,5.068.148.771.438,1.379-.634.568-.493-.372-1.318-.922-1.679-.739a1.452,1.452,0,0,0-.246,2.138c.208.22.616.57.616.57-4.829-2.046-5.332-9.191-3.08-10.267",
    transform: "translate(-1478.427 -703.764)",
    fill: "#1d3975",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73807",
    "data-name": "Path 73807",
    d: "M705.75,1805.917H273.957a.475.475,0,1,0,0,.949H705.75a.475.475,0,1,0,0-.949",
    transform: "translate(808.723 -1303.689)",
    fill: "#0f4884",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73808",
    "data-name": "Path 73808",
    d: "M705.566,1723.267l.663-7.006-7.03.169.067,8.022Z",
    transform: "translate(456.117 -1229.43)",
    fill: "#f8a98e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73809",
    "data-name": "Path 73809",
    d: "M686.706,1753.611c1.363,4.864,5.224,6.983,2.7,10.015H676.534c-.021-.058-.042-.121-.062-.188a2.091,2.091,0,0,1-.323-2.109c.746-2.823,2.938-7.161,3.691-7.385,1.493-.442,3.614.8,6.867-.334",
    transform: "translate(475.321 -1260.366)",
    fill: "#355298",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73810",
    "data-name": "Path 73810",
    d: "M689.7,1798.182v.006l.016.528a2.194,2.194,0,0,1-.976,1.828H676.011a1.825,1.825,0,0,1-.386-2.3Z",
    transform: "translate(475.844 -1297.283)",
    fill: "#1d3975",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73811",
    "data-name": "Path 73811",
    d: "M722.093,1155.387l-7.531,30.589-3.844,18.21-8.534,44.354a10.716,10.716,0,0,1-4.692.657,21.634,21.634,0,0,1-4.344-.594c-.063-13.1,0-29.728,1.416-46.442,1.188-14.007-1.644-25.734-.786-41.182.253-4.564,3.529-13.268,3.463-13.1Z",
    transform: "translate(461.141 -758.655)",
    fill: "#1d3975",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73812",
    "data-name": "Path 73812",
    d: "M883.147,1722.111l-.027-7.245-7.029.169.756,8.262Z",
    transform: "translate(309.602 -1228.274)",
    fill: "#f8a98e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73813",
    "data-name": "Path 73813",
    d: "M878.088,1748.027c3.488,4.135,10.994,5.02,14.132,6.054,2.544.838,3.767,3.656,1.792,4.92H869.954c-.021-.058-.042-.121-.062-.188-.357-1.189-1.292-9.683,1.21-9.494a10.727,10.727,0,0,0,6.987-1.293",
    transform: "translate(315.127 -1255.741)",
    fill: "#355298",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73814",
    "data-name": "Path 73814",
    d: "M895.677,1798.182v.006l.016.528a2.194,2.194,0,0,1-.976,1.828H870.66q-.032-.087-.062-.188c-.07-.232-.24-1.439-.323-2.109Z",
    transform: "translate(314.421 -1297.283)",
    fill: "#1d3975",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73815",
    "data-name": "Path 73815",
    d: "M796.537,1154.5l.767,11.62c2.273,23.461,1.279,53.612-.688,83.155a27.506,27.506,0,0,1-6.26.561c-2.887-.167-2.36-.5-2.36-.5l-6.756-48.285s-1.528-11-5.1-19.564c-2.582-6.188-5.748-7.971-5.281-15.162.484-7.446-.142-13.217.882-15.79s6.141-1.54,6.141-1.54Z",
    transform: "translate(396.804 -759.412)",
    fill: "#1d3975",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73816",
    "data-name": "Path 73816",
    d: "M820,1353.826l-1.513-10.812a103.962,103.962,0,0,0-2.707-12.578h0l1.431-10.246,2.973,25.7Z",
    transform: "translate(359.557 -901.377)",
    fill: "#1d3975",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73817",
    "data-name": "Path 73817",
    d: "M854.34,929.768c4,8.771,6.927,16.626,18.365,18.331,8.093.225,16.972-28.35,15.878-31.14-1.19-3.034,2.542-1.557-2.107-1.469-6.179-.018-13.052,19.026-14.446,18.928-1.32-.093-7.865-17.927-15.974-20.871-.962-.62-4.528,11.984-1.714,16.221",
    transform: "translate(328.497 -564.552)",
    fill: "#355298",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73818",
    "data-name": "Path 73818",
    d: "M593.742,970.262c-5.428,13.247-7.388,27.849-9.083,41.957-.171,1.422,1,3.092,2.758,4.034,1.117.6.726,1.15,2.792-.668,3.137-3.778,5.675-18.753,9.088-24.329,6.736-11.005,13.224-21.683,9.645-28.736-.169-.99-14.127,3.41-15.2,7.743",
    transform: "translate(550.999 -605.016)",
    fill: "#1d3975",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73819",
    "data-name": "Path 73819",
    d: "M617.946,931.664a163.326,163.326,0,0,1,1.642,33.548c15.636,2.685,30.563,1.836,39.9-1.137-.437-10.318,2.611-59.827-12.68-63.106-10.344-2.9-24.216-1.982-29.947,3.669-5.254,4.929-10.561,20.449-12.387,27.473-5.342,20.55,8.993,9.2,13.47-.446",
    transform: "translate(535.547 -552.823)",
    fill: "#355298",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73820",
    "data-name": "Path 73820",
    d: "M759.481,898.239c1.877,8.52,2.53,37.289,2.332,46.794-.364-.716-16.284-40.324-17.631-46.9,4.366-1.242,10.49-1.074,15.3.106",
    transform: "translate(418.859 -551.093)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73821",
    "data-name": "Path 73821",
    d: "M803.362,965.105l-.634,16.183-7.066-14.879-.424-21.086L793.58,943l1.779-1.956,2.2,1.18-.733,2.67c2.172,5.789,5.093,15.7,6.539,20.208",
    transform: "translate(377.944 -587.348)",
    fill: "#1d3975",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73822",
    "data-name": "Path 73822",
    d: "M688.584,1052.161c1.218,7.754,1.931,23.816,1.642,33.548,4.1-10.164,1.924-36.766,1.129-40.863a51.048,51.048,0,0,1-2.771,7.315",
    transform: "translate(464.908 -673.321)",
    fill: "#1d3975",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73823",
    "data-name": "Path 73823",
    d: "M750.955,779.155a10.12,10.12,0,0,1-4.357,4.7l.059,3.18.463.394c1.812,1.942-.15,5.928-2.214,5.806-5.218.257-9.225-4.022-7.656-6.345l.681-.759.151-4.5c-.27-.015-2.229-1.129-2.813-1.308a3.026,3.026,0,0,1-1.5-2.49c-.057-1.186,1.776-.8,1.776-.8-2.221-3.04-4.737-5.523-1.475-8.26s10.753-4.335,10.753-4.335l4.509-1.563c-.574,1.556.193,6.746,1.351,9.987,1.038,2.908,1.743,3.359.267,6.3",
    transform: "translate(428.525 -439.77)",
    fill: "#f7aaac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73824",
    "data-name": "Path 73824",
    d: "M777.319,875.735c1.479,2.537,3.207,5.167,6.45,4.781l-.059-3.18c-1.444.232-2.856.118-6.391-1.6",
    transform: "translate(391.412 -533.252)",
    fill: "#e16e73",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73825",
    "data-name": "Path 73825",
    d: "M835.6,949.682h0l4.362-35.662-3.533-2.982,2.237-2.65-2.2-4.72a22,22,0,0,1-3.2-.781c1.877,8.52,2.53,37.287,2.332,46.793",
    transform: "translate(345.071 -555.743)",
    fill: "#1d3975",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73826",
    "data-name": "Path 73826",
    d: "M741.089,949.368h0l-21.521-33.064,2.506-3.885-2.914-1.88,1.044-7.23a28.779,28.779,0,0,1,3.263-.8c1.4,6.688,17.249,46.122,17.622,46.858",
    transform: "translate(439.583 -555.429)",
    fill: "#1d3975",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73827",
    "data-name": "Path 73827",
    d: "M1142.813,731.829c.646-.266,2.5.872,2.334,2.112L1141.688,739l-3.617-3.355Z",
    transform: "translate(92.614 -414.028)",
    fill: "#f85c24",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73828",
    "data-name": "Path 73828",
    d: "M1030.592,761.647l19.718-13.62a7.128,7.128,0,0,1,3.431,3.183l-12.72,20.112-7.847-5.617Z",
    transform: "translate(181.635 -427.476)",
    fill: "#b1cbef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73829",
    "data-name": "Path 73829",
    d: "M671.4,835.2,594.758,917.8l-10.429-9.675,76.639-82.606c.993-1.071,4.133.228,7.013,2.9s4.409,5.706,3.416,6.776",
    transform: "translate(551.259 -491.353)",
    fill: "#ff8c63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73830",
    "data-name": "Path 73830",
    d: "M604.123,919.682l-1.492-1.384L680.908,833.9a18.523,18.523,0,0,1,4.155,3.851l-78.278,84.4Z",
    transform: "translate(536.1 -498.605)",
    fill: "#f85c24",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73831",
    "data-name": "Path 73831",
    d: "M589.881,1309.43c2.88,2.672,4.409,5.705,3.416,6.776s-4.133-.228-7.013-2.9-4.409-5.705-3.416-6.776,4.133.228,7.013,2.9",
    transform: "translate(552.72 -889.755)",
    fill: "#f4d81e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73832",
    "data-name": "Path 73832",
    d: "M637.9,943.632l76.639-82.606.2-.317c.375-.916-.3-2.6-1.694-4.379l-2.022,2.18-74.608,80.438c1.566,2.009,2.221,3.888,1.483,4.684",
    transform: "translate(508.116 -517.18)",
    fill: "#c84904",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73833",
    "data-name": "Path 73833",
    d: "M537.515,1324.854l9.175-9.844a1.481,1.481,0,0,0,1.143-.4c1.072-1.155-.578-4.428-3.685-7.31s-6.493-4.282-7.565-3.128a1.517,1.517,0,0,0-.313,1.231l-9.091,9.809Z",
    transform: "translate(598.594 -887.773)",
    fill: "#b1cbef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73834",
    "data-name": "Path 73834",
    d: "M585.9,1304.562a16.649,16.649,0,0,1,3.513,4.443c.717,1.422.871,2.663.312,3.427l0,.018c-.043.047-.1.112-.144.155a2.2,2.2,0,0,1-1.9.5l1.159-1.179.066-.054c.35-.42.182-1.311-.376-2.42a15.635,15.635,0,0,0-3.292-4.15l-.014-.013a15.655,15.655,0,0,0-4.4-2.982c-1.172-.484-2.086-.58-2.465-.171a.721.721,0,0,0-.156.277l-.947,1.059a2.195,2.195,0,0,1,.374-2.013l.032-.034c.7-.712,2-.676,3.541-.038a16.67,16.67,0,0,1,4.694,3.173Z",
    transform: "translate(557.185 -885.401)",
    fill: "#cb4700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73835",
    "data-name": "Path 73835",
    d: "M533.106,1371.97c2.879,2.672,4.065,5.385,3.072,6.455s-3.79.093-6.669-2.579-4.66-6-3.667-7.066,4.385.518,7.264,3.19",
    transform: "translate(599.931 -941.345)",
    fill: "#7ba9e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73836",
    "data-name": "Path 73836",
    d: "M584.633,1251.306l-.24,2.189,1.675,3.4c.336.463,1.808,3.639.523,2.981-.9-.463-2.574-2.118-2.65-2.053-.991.847-1.379,7.408-1.467,7.491-1.235,1.156-1.233-3.024-1.264-3.733a25.848,25.848,0,0,1-.787,2.773,1.418,1.418,0,0,1-.663-1.223,17.406,17.406,0,0,0,.042-2.765c-.178-.163-.771,2.813-.925,2.649a1.245,1.245,0,0,1-.367-.98,23.97,23.97,0,0,0,.177-2.72c-.146-.22-.444,1.935-.561,1.722-.091-.167-.42-.147-.434-.33-.362-4.931,2.2-4.344,1.631-9.979-.315-3.134,4.616-.379,5.308.577",
    transform: "translate(556.785 -842.64)",
    fill: "#f7aaac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73837",
    "data-name": "Path 73837",
    d: "M1024.822,907.542s-3.75-1.725-3.31-2.5,2.706.3,2.706.3l-2.686-2.106s-.078-.694.6-.625,3.16.788,3.16.788l-2.5-2.006c-1.1-.884-.439-1.525-.038-1.362.549.223,2.982,1.537,2.982,1.537l-2.082-2.45a1.126,1.126,0,0,1,1.363-.189,18.674,18.674,0,0,1,2.146,1.2c5.257,3.612-1.16,8.28-2.351,7.42",
    transform: "translate(189.185 -552.348)",
    fill: "#f7aaac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73838",
    "data-name": "Path 73838",
    d: "M716.919,749.4a6.639,6.639,0,0,1,2.621-7.354c5.325-4.159,9.9-1.86,11.871-1.376,1.365.335,2.287.3,3.629.579,3.356.7,3.642,7.682,1.222,9.976-.24.228-.613-2.97-.882-2.766a5.933,5.933,0,0,1-.942.675c-3.943,2.02-8.483-.376-10.779,2.328-1.137,1.34-1.023,3.27.251,6.252.375.879.876,1.526-.608.838-.681-.315-1.8-.756-2.186-.447a1.765,1.765,0,0,0,.258,2.6c.3.208.878.519.878.519-6.267-1.188-7.732-9.972-5.333-11.831",
    transform: "translate(442.343 -420.498)",
    fill: "#1d3975",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73866",
    "data-name": "Path 73866",
    d: "M1225.591,928.642h40.09a1.635,1.635,0,0,1,0,3.27h-40.09a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(21.479 -577.073)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73872",
    "data-name": "Path 73872",
    d: "M2182.348,1316.115h24.876a.455.455,0,0,1,.454.454v7.754a.455.455,0,0,1-.454.454h-24.876a.455.455,0,0,1-.454-.454v-7.754a.455.455,0,0,1,.454-.454m0-3.907h24.876a4.374,4.374,0,0,1,4.361,4.361v7.754a4.374,4.374,0,0,1-4.361,4.361h-24.876a4.374,4.374,0,0,1-4.361-4.361v-7.754A4.374,4.374,0,0,1,2182.348,1312.208Z",
    transform: "translate(-768.711 -894.768)",
    fill: "#95afff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73873",
    "data-name": "Path 73873",
    d: "M1975.239,1373.747h96.442a4.377,4.377,0,0,1,4.364,4.364v65.458a4.376,4.376,0,0,1-4.364,4.364h-96.442a4.376,4.376,0,0,1-4.364-4.364v-65.458a4.377,4.377,0,0,1,4.364-4.364",
    transform: "translate(-597.168 -945.738)",
    fill: "#95afff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73874",
    "data-name": "Path 73874",
    d: "M1976.866,1373.747h96.441a4.377,4.377,0,0,1,4.364,4.364v57.6a4.377,4.377,0,0,1-4.364,4.364h-96.441a4.376,4.376,0,0,1-4.364-4.364v-57.6a4.376,4.376,0,0,1,4.364-4.364",
    transform: "translate(-598.516 -945.738)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73875",
    "data-name": "Path 73875",
    d: "M2001.061,1374.7h95.9v36.219a3.247,3.247,0,0,1-3.222,3.253h-89.568a3.135,3.135,0,0,1-3.111-3.14Z",
    transform: "translate(-622.17 -946.524)",
    fill: "#95afff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73876",
    "data-name": "Path 73876",
    d: "M1997.912,1368.4h96.442v36.08a3.249,3.249,0,0,1-3.24,3.24H2001.04a3.137,3.137,0,0,1-3.128-3.128Z",
    transform: "translate(-619.562 -941.307)",
    fill: "#d0e0ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73877",
    "data-name": "Path 73877",
    d: "M2042.568,1386.107h76.415a2.839,2.839,0,0,1,2.831,2.83h0a2.838,2.838,0,0,1-2.831,2.83h-76.415a2.838,2.838,0,0,1-2.83-2.83h0a2.838,2.838,0,0,1,2.83-2.83",
    transform: "translate(-654.205 -955.976)",
    fill: "#eaf1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54530",
    "data-name": "Rectangle 54530",
    width: 105.169,
    height: 1.693,
    transform: "translate(1373.986 488.151)",
    fill: "#95afff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73878",
    "data-name": "Path 73878",
    d: "M2209.436,1308.844H2231.5a.443.443,0,0,1,.442.442v4.131a.443.443,0,0,1-.442.442h-22.065a.443.443,0,0,1-.442-.442v-4.131a.443.443,0,0,1,.442-.442",
    transform: "translate(-794.394 -891.981)",
    fill: "#95afff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73879",
    "data-name": "Path 73879",
    d: "M2214,1312.208h20.475a.372.372,0,0,1,.371.371h0a.371.371,0,0,1-.371.371H2214a.372.372,0,0,1-.371-.371h0a.372.372,0,0,1,.371-.371",
    transform: "translate(-798.234 -894.768)",
    fill: "#e7efff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73880",
    "data-name": "Path 73880",
    d: "M2093.092,1360.4h3.819a2.718,2.718,0,0,1,2.728,2.691v71.1a2.718,2.718,0,0,1-2.728,2.691h-3.819a2.718,2.718,0,0,1-2.727-2.691v-71.1a2.717,2.717,0,0,1,2.727-2.691",
    transform: "translate(-696.138 -934.686)",
    fill: "#95afff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73881",
    "data-name": "Path 73881",
    d: "M2074.569,1646.27h.51v2.176h-.51a.485.485,0,0,0-.483.483v9.945a.485.485,0,0,0,.483.483h10.294a.484.484,0,0,0,.483-.483v-9.945a.484.484,0,0,0-.483-.483h-.51v-2.176h.51a2.667,2.667,0,0,1,2.659,2.659v9.945a2.666,2.666,0,0,1-2.659,2.659h-10.294a2.666,2.666,0,0,1-2.659-2.659v-9.945a2.666,2.666,0,0,1,2.659-2.659",
    transform: "translate(-680.852 -1171.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73882",
    "data-name": "Path 73882",
    d: "M2415.761,1360.4h3.819a2.718,2.718,0,0,1,2.727,2.691v71.1a2.718,2.718,0,0,1-2.727,2.691h-3.819a2.718,2.718,0,0,1-2.728-2.691v-71.1a2.717,2.717,0,0,1,2.728-2.691",
    transform: "translate(-963.393 -934.686)",
    fill: "#95afff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73883",
    "data-name": "Path 73883",
    d: "M2397.238,1646.27h.51v2.176h-.51a.485.485,0,0,0-.484.483v9.945a.485.485,0,0,0,.484.483h10.293a.484.484,0,0,0,.483-.483v-9.945a.484.484,0,0,0-.483-.483h-.51v-2.176h.51a2.667,2.667,0,0,1,2.659,2.659v9.945a2.667,2.667,0,0,1-2.659,2.659h-10.293a2.666,2.666,0,0,1-2.659-2.659v-9.945a2.666,2.666,0,0,1,2.659-2.659",
    transform: "translate(-948.107 -1171.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73884",
    "data-name": "Path 73884",
    d: "M2195.093,827.431v38.434h64.615V827.431l-33-28.257Z",
    transform: "translate(-782.88 -469.839)",
    fill: "#fd9900",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54531",
    "data-name": "Rectangle 54531",
    width: 45.119,
    height: 52.568,
    transform: "translate(1422.381 338.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73885",
    "data-name": "Path 73885",
    d: "M2259.708,963.714l-31.82,28.331-32.795-28.331v38.434h64.615Z",
    transform: "translate(-782.88 -606.123)",
    fill: "#fcb53d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73886",
    "data-name": "Path 73886",
    d: "M2259.708,1082.876l-29.338-20.562a5.15,5.15,0,0,0-6.5.04l-28.781,20.522Z",
    transform: "translate(-782.88 -686.85)",
    fill: "#fbc760",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73887",
    "data-name": "Path 73887",
    d: "M2307.576,938.05h-12.665a1.367,1.367,0,1,0,0,2.735h12.665a1.367,1.367,0,0,0,0-2.735",
    transform: "translate(-864.423 -584.866)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73888",
    "data-name": "Path 73888",
    d: "M2323.9,974.392h-28.99a1.367,1.367,0,0,0,0,2.735h28.99a1.367,1.367,0,0,0,0-2.735",
    transform: "translate(-864.423 -614.967)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73889",
    "data-name": "Path 73889",
    d: "M2323.9,1010.734h-28.99a1.367,1.367,0,0,0,0,2.735h28.99a1.367,1.367,0,0,0,0-2.735",
    transform: "translate(-864.423 -645.067)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73890",
    "data-name": "Path 73890",
    d: "M2416.227,886.864h-12.547v12.548h12.547Zm-7.682,6.318a2.941,2.941,0,0,0-1.727.7,17.543,17.543,0,0,0-.966,4.657h-1.3V887.735h10.805V898.54h-1.333c-.187-1.511-.7-4.259-1.11-4.693a3.446,3.446,0,0,0-1.483-.657l0-.017a2.176,2.176,0,0,0-.462-.1v-.008q-.141-.029-.271-.049a.712.712,0,0,1-.007-.08.548.548,0,0,1,0-.081,1.44,1.44,0,0,0,.323-.032c.778-.219.791-1.326.689-2.137a1.056,1.056,0,0,0,.293-1.56c-.206-.2-.268-.022-.628,0-.293.016-.695-.291-.957-.359-.308-.08-1.274-.127-1.487.657-.635.207-.521,1.541-.146,1.612-.242.4.262.823.441.958l-.024-.009a1.045,1.045,0,0,1,.1.623c-.006.135-.006.273-.013.409-.1.016-.2.033-.29.052l0,.012c-.149.025-.355.08-.448.1Z",
    transform: "translate(-955.645 -542.47)",
    fill: "#aec2fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73891",
    "data-name": "Path 73891",
    d: "M2301.369,902.793h-6.458a1.367,1.367,0,0,0,0,2.735h6.458a1.367,1.367,0,1,0,0-2.735",
    transform: "translate(-864.423 -555.664)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73895",
    "data-name": "Path 73895",
    d: "M1225.591,981.052h54.053a1.635,1.635,0,0,1,0,3.27h-54.053a1.635,1.635,0,0,1,0-3.27",
    transform: "translate(21.479 -620.483)",
    fill: "#aec2fd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_937",
    "data-name": "Ellipse 937",
    cx: 29.178,
    cy: 29.178,
    r: 29.178,
    transform: "translate(1263.618 118.643)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_938",
    "data-name": "Ellipse 938",
    cx: 14.178,
    cy: 14.178,
    r: 14.178,
    transform: "translate(1192 72.643)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.4eea94d4794c03268172e0fc2cef5eff.svg";
export { ForwardRef as ReactComponent };